package org.multiplatform.kotfolio.pages.kotlin

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText

import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul

@Page("/kotlin/questions")
@Composable
fun QuestionsKotlinPage() {
    BlogLayout(
        PageProperties(
            "Kotlin Questions",
            ""
        ),
        BlogProperties("Kotlin", "Interview Questions")
    ) {
        Column(horizontalAlignment = Alignment.Start)
        {
            Ol {
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "SOLID Principles in Android with Kotlin.",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "SRP (Single Responsibility Principle)",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Each class should have only one reason to change.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "For example, separate your data operations (Repository), business logic (UseCase), and UI logic (ViewModel).",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "OCP (Open-Closed Principle)",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Classes should be open for extension but closed for modification.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Use interfaces and abstract classes to define contracts.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Makes adding new features easier without changing existing code.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }
                                }
                            }

                            KotlinCode(
                                code = """
                                    class PaymentProcessor {
                                        fun processPayment(paymentType: String) {
                                            when (paymentType) {
                                                "credit" -> processCreditPayment()
                                                "debit" -> processDebitPayment()
                                                // Adding new payment type requires modifying existing code
                                            }
                                        }
                                    }

                                    // Good Example - Open for extension, closed for modification
                                    interface PaymentMethod {
                                        fun process()
                                    }

                                    class CreditCardPayment : PaymentMethod {
                                        override fun process() {
                                            // Process credit card payment
                                        }
                                    }

                                    class DebitCardPayment : PaymentMethod {
                                        override fun process() {
                                            // Process debit card payment
                                        }
                                    }

                                    // New payment methods can be added without modifying existing code
                                    class CryptoPayment : PaymentMethod {
                                        override fun process() {
                                            // Process crypto payment
                                        }
                                    }
                                """.trimIndent()
                            )

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "LSP (Liskov Substitution Principle)",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Subtypes must be substitutable for their base types.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Ensures that inheritance is used correctly.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Child classes should enhance, not replace, parent class behavior.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }
                                }
                            }

                            KotlinCode(
                                code = """
                                    // Bad Example - Violating LSP
                                    open class Bird {
                                        open fun fly() {
                                            // Flying implementation
                                        }
                                    }

                                    class Penguin : Bird() {
                                        override fun fly() {
                                            throw Exception("Penguins can't fly!") // Violates LSP
                                        }
                                    }

                                    // Good Example - Following LSP
                                    interface Flying {
                                        fun fly()
                                    }

                                    class Bird {
                                        // Base bird functionality
                                    }

                                    class Sparrow : Bird(), Flying {
                                        override fun fly() {
                                            // Flying implementation
                                        }
                                    }

                                    class Penguin : Bird() {
                                        fun swim() {
                                            // Swimming implementation
                                        }
                                    }
                                """.trimIndent()
                            )

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "ISP (Interface Segregation Principle)",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Clients shouldn’t be forced to depend on interfaces they don’t use.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Break down large interfaces into smaller, more specific ones.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Common in Android when dealing with callbacks and listeners.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "DIP (Dependency Inversion Principle)",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "High-level modules shouldn’t depend on low-level modules; both should depend on abstractions.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Perfect for dependency injection in Android.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Makes your code more testable and flexible.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why dp developers choose Kotlin?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "One of the main reasons is that Google favors it for Android development. Its concise syntax and safety features minimize common coding errors, making programming faster and app quality better. It's also got great tools for converting Java code to Kotlin in Android Studio, making it easy for developers to adapt.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is Kotlin's target platform, and how does Kotlin-Java interoperability work?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Kotlin's target platform is the Java Virtual Machine (JVM). Kotlin-Java interoperability is seamless, allowing Kotlin and Java code to coexist within the same project. This is achieved through interoperability features like calling Java code from Kotlin using straightforward syntax, and vice versa. The compatibility extends to data types, exceptions, and other language constructs, fostering a smooth integration between Kotlin and Java components. Kotlin's use of annotations simplifies the process of leveraging existing Java libraries in Kotlin projects. Kotlin's target platform, the JVM, enables it to effortlessly collaborate with Java, ensuring a versatile and compatible development environment.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain powerful features of Kotlin.",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Data Classes: Data classes make it easy to create simple data transfer objects. With a few lines of code, you can use the data keyword which automatically generates all the necessary boilerplate code.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Function Types: Function types make it easier to work with functions, such as lambda expressions and higher-order functions. A function type represents the signature of a function (its params + return type).",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            KotlinCode(
                                code = """
                                    // Function type: takes two Ints, returns Int
                                    val operation: (Int, Int) -> Int = { a, b -> a + b }

                                    // Function type: takes String, returns Unit
                                    val printer: (String) -> Unit = { message -> println(message) }
                                """.trimIndent()
                            )

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Extension Functions: Allow you to add new functions to existing classes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Safe Null Operations: Helps to prevent NullPointerException errors.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Var and Val: var allows you to change the value of a variable at runtime, while val makes a variable immutable.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Destructuring: Makes it easy to unpack data structures.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Multiplatform Support: Kotlin can be run on different platforms, including the JVM, JavaScript, native, and Kotlin Multiplatform Mobile (KMM), which can be compiled to JVM and native.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the it keyword in lambdas?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "If a lambda has only one parameter, Kotlin lets you skip naming it and use the implicit it.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                 val numbers = listOf(1, 2, 3, 4, 5)
                                 val doubled = numbers.map { it * 2 } // 'it' = current element
                                 println(doubled) // [2, 4, 6, 8, 10]
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Labeled this@ — when you're drowning in receivers",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Scope functions and DSLs stack implicit receivers, and inside apply { } inside a callback inside a class, this is a lottery. Reviewers rarely catch it because the code reads naturally.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                class SessionManager {
                                    private var listener: Listener? = null

                                    fun connect() {
                                        socket.onOpen {
                                            // `this` here is the socket's callback scope...
                                            listener?.onConnected(this)   // ...oops, passed the wrong `this`
                                        }
                                    }
                                }
                                
                                fun connect() {
                                    socket.onOpen {
                                        listener?.onConnected(this@SessionManager)
                                    }
                                }

                                // works with scope functions too:
                                val config = Config().apply {
                                    timeout = this@SessionManager.defaultTimeout  // outer field, unambiguously
                                }
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "class",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A class is a user defined data type that acts like a blueprint for creating objects.It also defines the properties and behaviour that the object will have but it does not contain the actual data of an object it only specifies what the object should look like.",
                                    modifier = Modifier.fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "object",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "An object is an instance of class. when an object is created, memory is allocated to store the objects data members and maintain its state.",
                                    modifier = Modifier.fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Did you know Kotlin’s DATA CLASS can inherit from other classes?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "In early Kotlin versions, data class was strictly final and couldn’t extend anything. This blocked clean hierarchies, especially for domain models and Algebraic Data Types. KEEP proposal (accepted & shipped in Kotlin 1.1), that limitation is gone. data class can now safely extend open classes or sealed hierarchies.",
                                    modifier = Modifier.fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = $$"""
                                //Early Kotlin: Compiler error
                                data class User (val id: Int, val name: String) : BaseEntity()
                                
                                //Modern Kotlin: Fully supported
                                open class BaseEntity(val createdAt: Long)
                                
                                data class User (val id: Int, 
                                    val name: String, 
                                    createdAt: Long
                                ): BaseEntity(createdAt)
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is a lambda function?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A lambda function is a concise way to define an anonymous function (a function without a name). Can be passed around as values. Often used with higher-order functions.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = $$"""
                                val sumLambda: (Int, Int) -> Int = { a, b -> a + b }
                                val greetingLambda: (String) -> Unit = { name -> println("Hello, $name!") }
                                val noParamLambda: () -> String = { "No parameters" }

                                println(sumLambda(10, 20)) // 30
                                greetingLambda("World")    // Hello, World!
                                println(noParamLambda())   // No parameters
                                
                                // Function type: takes two Ints, returns Int
                                val operation: (Int, Int) -> Int = { a, b -> a + b }

                                // Function type: takes String, returns Unit
                                val printer: (String) -> Unit = { message -> println(message) }
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is a Lambda with Receiver?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A special type of lambda that attaches a receiver object (this) to its scope, allowing direct access to the object's members. (The basis of Scope Functions).",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is a trailing lambda?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "If the last parameter of a function is a function type, you can place the lambda outside the parentheses.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                fun execute(times: Int, action: () -> Unit) {
                                    repeat(times) { action() }
                                }

                                fun main() {
                                    // Without trailing lambda
                                    execute(3, { println("Hello") })

                                    // With trailing lambda
                                    execute(2) {
                                        println("World")
                                    }
                                }
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Encapsulation",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Encapsulation is used to hide the internal details of a class and expose only the required functionalities through getter and setter methods.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ol {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Encapsulation is used in ViewModel to manage UI-related data while keeping implementation details private.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "For example, LiveData in ViewModel exposes immutable data to the UI, ensuring encapsulation.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Inheritance",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Allows a class to inherit properties and methods of a parent class, promoting code reusability. For example: Xml layout, IntentService",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ol {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Activities inherit from AppCompatActivity to gain lifecycle management.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Custom views inherit from the View class to use its core rendering capabilities.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Polymorphism",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Allows methods to behave differently based on the object that calls them (method overriding) or parameters passed (method overloading).",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ol {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Overriding lifecycle methods (onCreate, onStart).",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Customizing adapter behavior in RecyclerView.Adapter.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Abstraction",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Hides complex implementation details and shows only the necessary features.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ol {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Abstract classes like AsyncTask.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Abstract methods in RecyclerView.Adapter.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference between abstraction and encapsulation?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Abstraction hides implementation details and encapsulation restricts data access.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Abstraction works at the design level and encapsulation at the implementation level.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Abstraction uses abstract classes and interfaces and encapsulation uses access modifiers and getter/setter methods.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        Column {
                            SpanText(
                                text = "Interfaces",
                                modifier = Modifier.fontSize(FontSize.Large)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Ul {
                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Interfaces are contracts that define a set of methods without implementation. Classes implement interfaces to provide specific behavior.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Interfaces are useful when you need to define shared functionality across unrelated classes.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Ol {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Interfaces like OnClickListener, Runnable, and Parcelable.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Commonly used for callbacks in RecyclerView.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }
                                }
                            }
                        }
                    }
                }

                KotlinCode(
                    code = $$"""
                        //Implementing Interfaces Inline
                        
                        interface DownloadListener {
                            fun onDownloadStarted()
                            fun onDownloadCompleted(file: String)
                            fun onProgressUpdate(progress: Int)
                        }

                        class Downloader {
                            var downloadListener: DownloadListener? = null

                            fun downloadFile(file: String) {
                                downloadListener?.onDownloadStarted()
                                for (i in 1..10) {
                                    downloadListener?.onProgressUpdate(i * 10)
                                    Thread.sleep(600)
                                }
                                downloadListener?.onDownloadCompleted(file)
                            }
                        }

                        // Traditional approach - create a class
                        class App : DownloadListener {
                            override fun onDownloadStarted() {
                                println("Download started")
                            }

                            override fun onDownloadCompleted(file: String) {
                                println("$file Downloaded")
                            }

                            override fun onProgressUpdate(progress: Int) {
                                println("$progress% download")
                            }
                        }

                        fun main() {
                            // Approach 1: Using a class
                            val downloadListener = App()
                            val downloader = Downloader()
                            downloader.downloadListener = downloadListener
                            downloader.downloadFile("FileName.mp3")

                            // Approach 2: Using object expression (anonymous inner class)
                            val downloader2 = Downloader()
                            downloader2.downloadListener = object : DownloadListener {
                                override fun onDownloadStarted() {
                                    println("Download started")
                                }

                                override fun onDownloadCompleted(file: String) {
                                    println("$file Downloaded")
                                }

                                override fun onProgressUpdate(progress: Int) {
                                    println("$progress% download")
                                }
                            }
                        }
                    """.trimIndent()
                )

                //https://doveletter.skydoves.me/book/kotlin#pro-tips-for-mastery-whats-a-supervisorjob
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are functional (SAM) interfaces?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Functional interfaces only one method, also known as Single Abstract Method (SAM) interfaces, are interfaces that have exactly one abstract method. These interfaces are designed to represent a single operation or function, making them an essential feature for enabling functional programming constructs and simplifying the use of lambda expressions.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A functional interface can be annotated with @FunctionalInterface for clarity, although this annotation is optional. The key characteristic of a functional interface is its single abstract method, which allows you to use lambda expressions or method references instead of creating verbose implementations.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Kotlin offers SAM conversion, which allows you to pass a lambda expression wherever a functional interface is expected. This works seamlessly with Java functional interfaces too.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = $$"""
                            fun interface Greeter {
                                fun greet(name: String): String
                            }

                            val greeter = Greeter { name -> "Hello, $name from Multiplatform Developer!" }
                            println(greeter.greet("Kotlin")) // Output: Hello, Kotlin from Multiplatform Developer!
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                            //1 Function Type
                            val multiply: (Int, Int) -> Int = { x, y -> x * y }
                            println(multiply(2, 3)) // Output: 6
                            
                            //2 SAM
                            fun execute(calculator: Calculator) {
                                println(calculator.calculate(3, 4))
                            }

                            // Using SAM conversion
                            execute { x, y -> x * y } // Output: 12, using the lambda for multiplication.
                            
                            //3
                            @FunctionalInterface
                            fun interface WakeUpTask {
                                fun wakeUp()
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Normal interface",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Imagine a contract between two people: 1. Wake up early, 2. Go to the gym, 3. Eat a healthy breakfast. When you agree to this contract, you have to do all three things. It can have many tasks (methods). You must complete all of them.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = $"""
                            interface MorningRoutine {
                                fun wakeUp()
                                fun exercise()
                                fun haveBreakfast()
                            }
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                            //1 Function Type
                            val multiply: (Int, Int) -> Int = { x, y -> x * y }
                            println(multiply(2, 3)) // Output: 6
                            
                            //2 SAM
                            fun execute(calculator: Calculator) {
                                println(calculator.calculate(3, 4))
                            }

                            // Using SAM conversion
                            execute { x, y -> x * y } // Output: 12, using the lambda for multiplication.
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Interface Segregation Principle (ISP)",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The Interface Segregation Principle (ISP) is another important SOLID principle. It states:",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A class should not be forced to implement interfaces it does not use.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This principle encourages splitting large, generic interfaces into smaller, more specific ones so that implementing classes only need to define methods that are relevant to their behavior.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = """
                            //Incorrect Implementation (Violates ISP)

                            interface FileOperations {
                                fun readFile(fileName: String)
                                fun writeFile(fileName: String, content: String)
                                fun downloadFile(url: String)
                                fun uploadFile(url: String)
                            }


                           class LocalFileHandler : FileOperations {
                               override fun readFile(fileName: String) {

                               }

                               override fun writeFile(fileName: String, content: String) {
                               }

                               override fun downloadFile(url: String) {
                                   // This class does not support downloading files!
                                   throw UnsupportedOperationException("Download is not supported")
                               }

                               override fun uploadFile(url: String) {
                                   // This class does not support uploading files!
                                   throw UnsupportedOperationException("Upload is not supported")
                               }
                           }

                           //Correct Implementation (Follows ISP)
                           interface Readable {
                               fun readFile(fileName: String)
                           }

                           interface Writable {
                               fun writeFile(fileName: String, content: String)
                           }

                           interface Downloadable {
                               fun downloadFile(url: String)
                           }

                           interface Uploadable {
                               fun uploadFile(url: String)
                           }

                           class LocalFileHandler : Readable, Writable {
                               override fun readFile(fileName: String) {

                               }

                               override fun writeFile(fileName: String, content: String) {

                               }
                           }

                           class RemoteFileHandler : Downloadable, Uploadable {
                               override fun downloadFile(url: String) {

                               }

                               override fun uploadFile(url: String) {

                               }
                           }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain Composition, Aggregation, and Association",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "An object-oriented programming, the relationships between classes significantly impact code flexibility and maintainability. Three key concepts in OOP in general, are Composition, Aggregation, and Association. Let's delve into it:",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Function Types: Function types make it easier to work with functions, such as lambda expressions and higher-order functions.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Association",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Represents a uses-a relationship.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Two objects interact independently.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "For instance, a Person might use a Car, existing separately.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Aggregation",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Signifies a has-a relationship with loose ownership.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "One object contains another, but the contained object can stand alone.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Example: A Team has Players; Players can exist independently.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Composition",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Indicates a has-a relationship with strong ownership.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "The contained object relies on the parent for existence.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Example: A Car (Has A) engine. Objects completely encapsulated. Can change behavior at runtime. Jetpack Compose, WorkManager",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                                .textAlign(TextAlign.Start)
                                        )
                                    }
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why do primitive-type variables work faster than reference-type variables?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Primitive type variables are generally stored in stack memory. The stack is very fast for memory management because data is organized in a last-in, first-out (LIFO) manner. This allows for quick allocation and deallocation of memory space.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "On the other hand, reference type variables are typically stored in heap memory. The heap has a more complex memory management structure; here, data allocation and deallocation can be slower because finding space and managing memory chunks in the heap is more complicated and time-consuming.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the @volatile Keyword in Kotlin?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "@Volatile annotation in Kotlin is used to ensure that a variable is always read from and written to main memory, rather than being cached in CPU registers or local memory. This helps prevent race conditions in multithreading.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ol {
                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Ensures visibility of changes across multiple threads.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Prevents caching of variable values by different CPU cores.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Does not guarantee atomicity for compound operations (e.g., x++ is still not thread-safe).",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }

                        KotlinCode(
                            code = """
                                //Without @Volatile (Thread Issue)

                                import kotlinx.coroutines.*

                                class SharedResource {
                                    var isActive = true
                                }

                                fun main() {
                                    val sharedResource = SharedResource()

                                    GlobalScope.launch {
                                        while (sharedResource.isActive) {
                                            // Keep running while isActive is true
                                        }
                                        println("Stopped Loop!")
                                    }

                                    Thread.sleep(1000)  // Allow coroutine to run
                                    sharedResource.isActive = false  // Attempt to stop the loop
                                    println("Main thread updated isActive = false")
                                }
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "In Kotlin, how do you use break, continue, return, and return@label statements to manage control flow within loops and functions? What are the differences between these statements?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "break: Used to exit from a loop (for, while). The break statement immediately terminates the loop and allows you to exit from it.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "continue: Allows you to skip the current iteration of the loop when a specific condition is met. The continue statement prevents the remaining code in the loop from being executed and moves to the next iteration.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "return: Used to return a result from a function. The return statement specifies the return value of the function and exits from it.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "return@label: Enables you to return from specific labeled loops or nested functions in more complex loop structures. The return@label allows you to specify which function or loop you want to exit from.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is a Default (None) Argument in functions?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "In Kotlin, when we provide a default value for a function parameter, we eliminate the necessity of explicitly specifying that parameter every time. It's like offering a backup option! This feature allows us to perform function overloading without writing multiple versions of the same function.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Thanks to default values, let's consider a function that sends a message; we can call this function without specifying the recipient. If we skip mentioning the recipient, the default value we defined will be used automatically. This makes our function calls cleaner and more readable.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Kotlin Varargs",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "vararg modifier is used to declare a parameter that accepts a variable number of arguments of the same type. Essential to flexible function design, these variable arguments reduce the need for multiple overloaded functions. When using Kotlin varargs, one core limitation surfaces—each function is permitted only one vararg parameter, and it must be the last parameter.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                KotlinCode(
                    code = $$"""
                        fun greet(vararg names: String, greeting: String) {
                            names.forEach { name -> println("$greeting $name") }
                        }

                        fun main() {
                            greet("Alice", "Bob", greeting = "Hello") // Uses named argument for greeting
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        //Kotlin List to Vararg
                        
                        fun printNames(vararg names: String) {
                            names.forEach { println(it) }
                        }

                        fun main() {
                            val list = listOf("John", "Jane", "Joe")
                            printNames(*list.toTypedArray())
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        //Spread Operator
                        
                        val numbers = intArrayOf(1, 2, 3, 4)
                        val summation = sum(*numbers)
                        assertEquals(10, summation)
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Call multiple methods on an object instance (with) in kotlin",
                            modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 0.3.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "In Kotlin, you can use the with function to call multiple methods on an object instance, improving readability by avoiding repetitive references to the object. The with function takes an object and a block of code, allowing you to access the object's properties and methods directly within that block.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = $$"""
                            data class User(val name: String, val age: Int) {
                                fun greet() = println("Hello, my name is $name.")
                                fun showAge() = println("I am $age years old.")
                                fun farewell() = println("Goodbye!")
                            }

                            fun main() {
                                val user = User("Alice", 25)

                                with(user) {
                                    greet()      // Equivalent to user.greet()
                                    showAge()    // Equivalent to user.showAge()
                                    farewell()   // Equivalent to user.farewell()
                                }
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Context Receivers in Kotlin",
                            modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 0.3.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Context Receivers let functions operate within multiple implicit contexts, meaning they gain access to receivers without needing explicit parameters.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = $$"""
                             class NetworkClient {
                                 fun request(url: String) = println("Fetching data from $url")
                             }

                             class Database {
                                 fun save(data: String) = println("Saving: $data")
                             }

                             context(NetworkClient, Database)
                             fun fetchData() {
                                 request("https://api.example.com")
                                 save("API Response Data")
                             }

                             fun main() {
                                 with(NetworkClient()) {
                                     with(Database()) {
                                         fetchData()
                                     }
                                 }
                             }
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = $$"""
                            class Logger {
                                fun log(message: String) = println("Log: $message")
                            }

                            class Database {
                                fun saveData(data: String) = println("Saving: $data")
                            }

                            // Using context receivers
                            context(Logger, Database)
                            fun performOperation() {
                                log("Starting operation...")  // Directly calling log() without logger.log()
                                saveData("User data")  // Directly calling saveData() without db.saveData()
                                log("Operation complete!")
                            }

                            fun main() {
                                val logger = Logger()
                                val db = Database()
                                with(logger) {
                                    with(db) {
                                        performOperation()  // No explicit parameters needed!
                                    }
                                }
                            }
                        """.trimIndent()
                    )
                }

                KotlinCode(
                    code = """
                        // Context Receivers
                        context(Activity)
                        fun showToast(message: String) {
                            Toast.makeText(this, message, Toast.LENGTH_SHORT).show()
                        }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Abstract class",
                            modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 0.3.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Is a class that cannot be instantiated on its own and is meant to be subclassed. It can contain both abstract methods (without implementation) and concrete methods (with implementation). An abstract class is a class that cannot be instantiated directly and is intended to be subclassed by other classes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "An abstract class can have both abstract and concrete methods, and it can also have instance variables.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The abstract methods declared in an abstract class do not have any implementation, and they must be implemented by any subclass that extends the abstract class.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Use abstract classes when you have a common base class that should not be instantiated and subclasses share a common implementation. Abstract classes are useful when you need to maintain state and provide common behavior across multiple related classes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Use when you need a base class with shared functionality, state, or constructors.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "When Should You Use an Abstract Class?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 0.3.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Multiple classes share common state.",
                                    modifier = Modifier.fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Multiple classes share implementation.",
                                    modifier = Modifier.fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Child classes have a strong “is-a” relationship.",
                                    modifier = Modifier .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You need constructors.",
                                    modifier = Modifier.fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You want to reuse code.",
                                    modifier = Modifier.fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "super in Abstract Classes",
                            modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 0.3.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "In an abstract class, super is used to call a method or property from the parent class. Since abstract classes support concrete implementations, the super keyword allows access to those.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = $$"""
                            abstract class Animal {
                                abstract val name: String
                                open fun sound(): String {
                                    return "Some generic sound"
                                }

                                fun eat() {
                                    println("$name is eating.")

                                }
                            }

                            class Dog : Animal() {
                                override val name: String = "Dog"
                                override fun sound(): String {
                                    return super.sound() + ", but specifically: Bark"
                                }
                            }

                            fun main() {
                                val dog = Dog()
                                println(dog.sound()) // Some generic sound, but specifically: Bark
                                dog.eat()            // Dog is eating.
                            }

                            Here:
                            super.sound() calls the concrete method from the parent Animal class.
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is Composition?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Composition means building one class using another class. It represents a “has-a” relationship.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Multiple Inheritance with Interfaces",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Instead of supporting multiple inheritance by classes, Kotlin provides a solution through interfaces. Interfaces can contain default implementations, allowing classes to inherit behavior from multiple interfaces without the issues associated with multiple inheritance by classes.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                    interface A {
                        fun foo() {
                            println("A")
                        }
                    }

                    interface B {
                        fun foo() {
                            println("B")
                        }
                    }

                    class C : A, B {
                        override fun foo() {
                            super<A>.foo()  // Calls A's implementation
                            super<B>.foo()  // Calls B's implementation
                        }
                    }

                    fun main() {
                        val c = C()
                        c.foo()
                    }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Data Classes and Inheritance",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Kotlin provides a special class type called data classes, which are designed to hold data. While data classes can inherit from other classes, there are some considerations to keep in mind.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                    //data class inheritance is not allowed unless the parent class is abstract or open.

                    open class Person(val name: String, val age: Int)
                    data class Student(val school: String, val StudentName: String, val StudentAge: Int) : Person(StudentName, StudentAge)
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                    // Correct: Implementing multiple interfaces
                    interface Runnable {
                        fun run()
                    }

                    interface Swimmable {
                        fun swim()
                    }

                    sealed class Vehicle : Runnable, Swimmable {
                        class Car : Vehicle() {
                            override fun run() {
                                println("Car is running")
                            }

                            override fun swim() {
                                println("Car cannot swim!")
                            }
                        }
                    }

                    sealed class Animal {
                        class Dog : Animal()
                        class Cat : Animal()
                    }

                    // Incorrect: Attempting multiple class inheritance (will fail)
                    open class FlyingAnimal

                    sealed class Bird : Animal(), FlyingAnimal // This is not allowed
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Inheritance and Constructors",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Kotlin allows subclasses to inherit from superclasses with custom constructors.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Calling Superclass Constructor: The primary constructor of the subclass calls the primary constructor of the superclass, allowing the subclass to initialize the superclass properties.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Custom Initialization: Subclasses can have their own additional properties and initialization logic.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = $$"""
                    open class Person(val name: String, val age: Int)
                    class Student(name: String, age: Int, val school: String) : Person(name, age)

                    fun main() {
                        val student = Student("John Doe", 20, "School")
                        println("Name: ${student.name}, Age: ${student.age}, School: ${student.school}")
                    }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "super in Interface",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Interfaces in Kotlin can also have default method implementations. You can use super to call the implementation from a specific interface when a class implements multiple interfaces, or when overriding an interface’s default implementation.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                    interface Animal {
                        fun sound() {
                            println("Some generic animal sound")
                        }
                    }

                    interface Pet {
                        fun sound() {
                            println("Pet makes a friendly sound")
                        }
                    }

                    class Dog : Animal, Pet {
                        override fun sound() {
                            super<Animal>.sound() // Calls Animal's implementation
                            super<Pet>.sound()    // Calls Pet's implementation
                            println("Dog says: Bark!")
                        }
                    }

                    fun main() {
                        val dog = Dog()
                        dog.sound()
                    }

                    Output:
                    Some generic animal sound
                    Pet makes a friendly sound
                    Dog says: Bark!
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Interface",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An interface in Kotlin is a blueprint for classes. It can define methods without implementations, allowing multiple classes to implement these methods in their own way. Think of it as a way to standardize behavior.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An interface is a collection of abstract methods that define a contract for classes that implement them. (An interface in Kotlin defines a contract that classes can implement. It can contain abstract methods as well as concrete methods with default implementations.)",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, an interface can also declare default implementations for its methods.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Unlike abstract classes, an interface cannot have instance variables and cannot provide any implementation details for its methods.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Example: Using Interfaces in a Project In a recent app, I needed various data sources (API, database, etc.). I created a DataSource interface that defined methods like fetchData(). Each implementation could then handle data retrieval differently.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When you want to define a common behavior across unrelated classes or need multiple inheritance.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Consider an online payment system that supports different payment methods. Using interfaces, we can define a common contract for all payment methods.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "When Should You Use an Interface?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Payable - (CardPayment, UpiPayment, WalletPayment) These classes don’t share common state, but they all know how to perform a payment.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Clickable - (Button, ImageView, CardView)",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = " Media Player - (Downloadable)",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Differences between abstract classes and interfaces in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An abstract class can have instance variables, while an interface cannot have instance variables.<= this statement is true only until Kotlin 1.5.Even interfaces can also have instance variables",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An abstract class can provide a base implementation for its methods, while an interface cannot provide any implementation details for its methods.<= this statement is also not entirely true as interfaces can have default implementation.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A class can only extend one abstract class, while it can implement multiple interfaces.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An abstract class can have both abstract and concrete methods, while an interface can only have abstract methods (with default implementations in Kotlin).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An abstract class can be used to define a hierarchy of related classes, while an interface can be used to define a set of unrelated classes that share a common behavior.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Choosing between abstract classes and interfaces in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ol {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "You want to define a base implementation that can be reused by its subclasses.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "You want to enforce a contract for any subclass that extends the abstract class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "You want to have instance variables that are inherited by its subclasses.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "You want to define a hierarchy of related classes.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Ol {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "You want to define a contract for classes that implement the interface.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "You want to provide default implementations for the methods in the interface.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "You want to provide flexibility for a class to implement multiple interfaces.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "You want to define a set of unrelated classes that share a common behavior.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 // Abstract class example
                                 abstract class Animal(val name: String) {

                                     // Concrete method
                                     fun introduction() {
                                         println(name)
                                     }

                                     // Abstract method, to be implemented by subclasses
                                     abstract fun makeSound()
                                 }

                                 // Subclass of Animal, which must implement makeSound()
                                 class Dog(name: String) : Animal(name) {

                                     override fun makeSound() {
                                         println("Woof!")
                                     }
                                 }

                                 // Interface example
                                 interface Shape {

                                     // Abstract method
                                     fun area(): Double

                                     // Default implementation
                                     fun perimeter(): Double {
                                         return 0.0
                                     }
                                 }

                                 // Class that implements Shape interface
                                 class Rectangle(val length: Double, val width: Double) : Shape {

                                     // Implementation of area() method
                                     override fun area(): Double {
                                         return length * width
                                     }

                                     // Override of perimeter() method with custom implementation
                                     override fun perimeter(): Double {
                                         return 2 * (length + width)
                                     }
                                 }

                                 fun main() {
                                     val dog = Dog("Fido")
                                     dog.introduction() // My name is Fido
                                     dog.makeSound() // Woof!

                                     val rectangle = Rectangle(5.0, 3.0)
                                     println(rectangle.area()) // Area of rectangle is 15.0
                                     println(rectangle.perimeter()) // Perimeter of rectangle is 16.0
                                 }
                            """.trimIndent()
                    )
                }

                KotlinCode(
                    code = """
                    //Combining Abstract Class and Interface

                    //If a class inherits from both an abstract class and an interface, you can use super to access members from each parent.

                    abstract class Animal {
                        open fun sound() {
                            println("Animal makes a sound")
                        }
                    }

                    interface Pet {
                        fun sound() {
                            println("Pet makes a friendly sound")
                        }
                    }

                    class Dog : Animal(), Pet {
                        override fun sound() {
                            super<Animal>.sound() // Call Animal's implementation
                            super<Pet>.sound()    // Call Pet's implementation
                            println("Dog says: Bark!")
                        }
                    }

                    fun main() {
                        val dog = Dog()
                        dog.sound()
                    }

                    Output
                    Animal makes a sound
                    Pet makes a friendly sound
                    Dog says: Bark!
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Can you explain why abstract methods in Kotlin cannot have a body and how they differ from methods with default implementations?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Abstract methods in Kotlin cannot have a body because they are meant to be implemented by subclasses.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The purpose of an abstract method is to define a contract that the subclass must fulfill.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If a body were provided, it would defeat the purpose of requiring the subclass to provide its own implementation.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Methods with default implementations, on the other hand, can have a body and provide a default behavior that subclasses can either use or override.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Types of Polymorphism in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Compile-time Polymorphism (Static Polymorphism): Achieved through function overloading.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Runtime Polymorphism (Dynamic Polymorphism): Achieved through inheritance, interface implementation, and function overriding.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain Association in Kotlin.",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Association is a relationship between two classes that establishes a connection through their objects. It can be unidirectional or bidirectional.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = """
                            //Unidirectional Association
                            class Student(val name: String)

                            class Teacher(val name: String) {
                                private val students = mutableListOf<Student>()

                                fun addStudent(student: Student) {
                                    students.add(student)
                                }

                                fun getStudents(): List<Student> {
                                    return students
                                }
                            }

                            fun main() {
                                val teacher = Teacher("Mrs. Smith")
                                val student1 = Student("John")
                                val student2 = Student("Jane")

                                teacher.addStudent(student1)
                                teacher.addStudent(student2)

                                println(teacher.name)
                                teacher.getStudents().forEach { println(it.name) }
                            }
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                            //Bidirectional Association

                            class Wife(val name: String) {
                                var husband: Husband? = null

                                fun setHusband(husband: Husband) {
                                    this.husband = husband
                                }
                            }

                            class Husband(val name: String) {
                                var wife: Wife? = null

                                fun setWife(wife: Wife) {
                                    this.wife = wife
                                }
                            }

                            fun main() {
                                val husband = Husband("John")
                                val wife = Wife("Jane")

                                husband.setWife(wife)
                                wife.setHusband(husband)

                                //husband.name
                                //husband.wife?.name
                                //wife.name
                                //wife.husband?.name
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why Prefer val + copy()?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Immutability — once created, the original object cannot be changed.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Thread safety — No synchronization issues with immutable data",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Functional programming — Encourages pure functions without side effects; transforming data rather than mutating it.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Debugging — Values don’t change unexpectedly",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Cleaner code - No risk of accidental side effects from mutation.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                        //copy() performs a shallow copy. If your data class contains mutable objects (like MutableList), the reference is copied, not the content:
                        
                        val profile = Profile(mutableListOf("reading"))
                        val copy = profile.copy()
                        copy.hobbies.add("coding")
                        println(profile.hobbies) // original now contains ["reading", "coding"]
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "data class copy() and deep state",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When you call the copy() method on a data class instance, it creates a new instance of that class, using the current instance’s properties as the default values. The copy() function natively generates a shallow copy. This means that while it creates a new container object, the nested/reference objects (like Lists, Maps, or nested classes) still point to the exact same memory locations as the original.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The data class copy method in Kotlin creates shallow copies and data classes are NOT immutable data structures by themselves. They become immutable though, if all of their properties are immutable themselves (_val_).",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Achieved: Manual Deep Copy, Serialization/Deserialization, State Management ( nested data classes)",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain Shallow Copy in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "new wrapper, same nested references",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A shallow copy creates a new object that is a copy of the original object, but it does not create new copies of any nested objects. Instead, the new object contains references to the same nested objects as the original. In Kotlin, you can achieve a shallow copy using the built-in copy() function provided by data classes.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                    data class Address(var city: String)

                    data class User(val name: String, val address: Address)

                    fun main() {
                        val originalAddress = Address("New York")
                        val originalUser = User("John", originalAddress)

                        // Create a shallow copy
                        val copiedUser = originalUser.copy(name = "Ilyas")
                        // Modify the address of the original user
                        originalUser.address.city = "San Francisco"
                        println(originalUser)  // Output: User(name=John, address=Address(city=San Francisco))
                        println(copiedUser)    // Output: User(name=Ilyas, address=Address(city=San Francisco))
                    }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain Deep Copy in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "New wrapper and new nested objects",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A deep copy, on the other hand, creates a new object and recursively copies all nested objects. This means that changes made to nested objects in the original will not affect the new object. To implement a deep copy in Kotlin, you typically need to override the clone() method or use serialization techniques.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                        //Deep Copy Using Cloneable
                        data class Address(var city: String) : Cloneable {
                            public override fun clone(): Address {
                                return Address(this.city)
                            }
                        }

                        data class User(val name: String, val address: Address) : Cloneable {
                            public override fun clone(): User {
                                return User(this.name, this.address.clone())
                            }
                        }
                        fun main() {
                            val originalAddress = Address("New York")
                            val originalUser = User("John", originalAddress)

                            // Create a deep copy
                            val clonedUser = originalUser.clone()
                            // Modify the address of the original user
                            originalUser.address.city = "San Francisco"
                            println(originalUser)  // Output: User(name=John, address=Address(city=San Francisco))
                            println(clonedUser)     // Output: User(name=John, address=Address(city=New York))
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                    //Deep Copy Using Serialization
                    import com.google.gson.Gson

                    data class Address(var city: String)

                    data class User(val name: String, val address: Address)

                    fun main() {
                        val gson = Gson()

                        val originalAddress = Address("New York")
                        val originalUser = User("John", originalAddress)

                        // Create a deep copy using JSON serialization
                        val clonedUserJson = gson.toJson(originalUser)
                        val clonedUser = gson.fromJson(clonedUserJson, User::class.java)
                        // Modify the address of the original user
                        originalUser.address.city = "San Francisco"
                        println(originalUser)  // Output: User(name=John, address=Address(city=San Francisco))
                        println(clonedUser)     // Output: User(name=John, address=Address(city=New York))
                    }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What's KSP?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "KSP (Kotlin Symbol Processing - Direct Approach) is Kotlin - native, directly processing Kotlin code without the Java conversion step. This means faster processing and better compatibility with Kotlin - specific features. Example: Moshi, the JSON parsing library, supports KSP allowing Kotlin users to benefit from faster build times and native processing.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What's KAPT?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "KAPT (Translator Approach) Kotlin Annotation Processing Tool lest's Kotlin work with Java - based annotation processors by converting Kotlin code to Java bytecode. Example: KAPT is helpful for libraries built with Java, like Retrofit with custom annotations for network calls.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What are the different visibility modifiers available in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Column {
                            SpanText(
                                text = "There are different visibility modifiers that control the visibility and accessibility of classes, functions, properties, and other declarations.",
                                modifier = Modifier.padding(topBottom = 0.3.em)
                                    .fontSize(FontSize.Medium)
                            )

                            SpanText(
                                text = "The visibility modifiers available in Kotlin are:",
                                modifier = Modifier.padding(topBottom = 0.3.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "public: Public declarations are accessible from anywhere.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "private: Private declarations are only accessible within the same file or the same scope (such as a class or a function).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "protected: Protected declarations are accessible within the same class and its subclasses. They are not visible outside the class hierarchy.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "internal: Internal declarations are visible within the same module. A module is a set of Kotlin files compiled together, such as an IntelliJ module or a Gradle module.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "default: The default visibility modifier in Kotlin is “internal.” This means that if no visibility modifier is specified, the entity (class, function, etc.) is visible within the same module but not outside of it. Internal visibility allows access to the entity from any code within the same module, providing a balance between encapsulation and accessibility.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                        class OtpViewModel internal constructor(
                            private val client: AuthClient,
                            private val authPreferences: AuthPreferences
                        ) : ViewModel() { }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why are classes in Kotlin Final by default?.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This is a design decision to prevent unintended inheritance (promoting Composition over Inheritance). The open keyword must be explicitly used to enable inheritance.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain const in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "const` keyword is crucial for Kotlin developers aiming to improve application performance and reduce runtime overhead. `const` makes it possible to define compile-time constants, leading to efficient use of resources and faster execution.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "`const` can only be used with primitives and String types. It is limited to properties declared on top-level or in objects (including companion objects), and must be initialized with a value known at compile-time.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "When to Use const val and val?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                        SpanText(
                            text = "const val",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        Li {
                            SpanText(
                                text = "You need a compile-time constant.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li {
                            SpanText(
                                text = "The value is a primitive type or 'String'.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li {
                            SpanText(
                                text = "The value does not change during the execution of the program.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li {
                            SpanText(
                                text = "You want to avoid the overhead of creating an object at runtime.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                        SpanText(
                            text = "val",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        Li {
                            SpanText(
                                text = "The value can only be determined at runtime.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li {
                            SpanText(
                                text = "You need to store complex objects, such as instances of a class, lists, or maps.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li {
                            SpanText(
                                text = "The value depends on user input or external data sources.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "val that changes value.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A teammate insists val means immutable, but in code review you see a val whose returned value changes on each access. How is that possible?",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "val means the reference/binding is read-only (no reassignment), not that the underlying object is immutable or that the value is constant. A val backed by a custom getter is re-evaluated on every access:",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Also, val list = mutableListOf(1) — the reference is fixed but list.add(2) mutates contents. True immutability requires immutable types (List, data class with val fields) plus no custom getters with side effects. Trap: assuming val guarantees thread-safety or constant value.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                        val now: Long get() = System.currentTimeMillis() // different each call
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain init block in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, the init block is a special segment of code within a class that gets executed automatically every time an instance of that class is created. It's like a constructor block, but it's used for additional setup operations beyond what can be done in the primary constructor.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "𝑬𝒙𝒆𝒄𝒖𝒕𝒊𝒐𝒏 𝑶𝒓𝒅𝒆𝒓: The 𝐢𝐧𝐢𝐭 block is executed immediately after the primary constructor and before any secondary constructors. If there are multiple init blocks within a class, they are executed in the order they appear.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "𝑨𝒄𝒄𝒆𝒔𝒔 𝒕𝒐 𝑷𝒓𝒐𝒑𝒆𝒓𝒕𝒊𝒆𝒔: Inside the 𝐢𝐧𝐢𝐭 block, you have access to all properties and methods of the class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "𝑴𝒖𝒍𝒕𝒊𝒑𝒍𝒆 𝒊𝒏𝒊𝒕 𝑩𝒍𝒐𝒄𝒌𝒔: You can have multiple 𝐢𝐧𝐢𝐭 blocks within a class, and they are executed in the order they are defined.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "𝑵𝒐 𝑷𝒂𝒓𝒂𝒎𝒆𝒕𝒆𝒓𝒔: Unlike constructors, the init block cannot take parameters. It's purely for initialization and setup logic.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When you need to validate input, perform logging, or set up complex logic after property assignments.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why use init block?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "𝑰𝒏𝒊𝒕𝒊𝒂𝒍𝒊𝒛𝒂𝒕𝒊𝒐𝒏 𝒐𝒇 𝑷𝒓𝒐𝒑𝒆𝒓𝒕𝒊𝒆𝒔: It allows you to initialize properties of your class right after the object is created, ensuring they have the right values from the beginning.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "𝑺𝒆𝒕𝒖𝒑 𝑳𝒐𝒈𝒊𝒄: You can perform any necessary setup operations or calculations before using the object, ensuring it's in the desired state.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Immutable Classes - Create thread safe class in Java",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If a class doesn’t maintain any state (fields), it’s automatically thread-safe. After all, if there’s nothing to modify, there’s nothing to corrupt!. This class is inherently thread-safe because each method operates only on its parameters, with no shared state between calls. Use final whenever possible(that’s said by many wise Java experts), as it helps in unintentional modification and thread safety.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        KotlinCode(
                            code = """
                                public class MathHelper {
                                    // No fields = no shared state

                                    public int add(int a, int b) {
                                        return a + b;
                                    }

                                    public static int multiply(int a, int b) {
                                        return a * b;
                                    }

                                    public double calculateAverage(int[] numbers) {
                                        int sum = 0;
                                        for (int num : numbers) {
                                            sum += num;
                                        }
                                        return numbers.length > 0 ? (double) sum / numbers.length : 0;
                                    }
                                }
                                """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What’s the difference between primary and secondary constructors in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, the primary constructor is the main constructor of a class. It is declared as part of the class header and it is responsible for initializing the properties of the class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        KotlinCode(
                            code = $$"""
                                    class MyClass(val param1: String, val param2: Int) {
                                        fun print() {
                                            println("$param1 and $param2")
                                        }
                                    }

                                    fun main() {
                                        val obj = MyClass("Kotlin", 10)
                                        obj.print() // Output: Kotlin and 10
                                    }
                                """.trimIndent()
                        )

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Secondary constructors in Kotlin are additional constructors that you can define in a class. They allow you to provide alternative ways of constructing objects with different parameter sets. Secondary constructors are defined using the constructor keyword.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        KotlinCode(
                            code = $$"""
                                    class MyClass {
                                        val param1: String
                                        val param2: Int

                                        constructor(param1: String, param2: Int) {
                                            this.param1 = param1
                                            this.param2 = param2
                                        }

                                        fun print() {
                                            println("$param1 and $param2")
                                        }
                                    }

                                    fun main() {
                                        val obj = MyClass("Kotlin", 10)
                                        obj.print() // Output: Kotlin and 10
                                    }
                                """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is Functional Interface or SAM (Single Abstract Method)?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Functional Interface which is also known as Single Abstract Method (or SAM) is just an interface with only one abstract method (method without implementation).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Functional interfaces can be defined by putting a fun modifier before the interface keyword and it should only have one abstract method.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                            fun interface ClickListener2 {
                                fun onClick(view: View)
                                
                                fun clicked() {
                                    println("Clicked")
                                }
                            }

                            fun click2() {
                                clickListener2?.onClick(view)
                                clickListener2?.clicked()
                            }
                        """.trimIndent()
                    )

                    Ul {
                        SpanText(
                            text = "We have created functional interface (ClickListener2) with only one method (onClick()) and created the setClickListener2 function that take the object of ClickListener2 type. As ClickListener2 is an functional interface we can use lambda expression while passing it.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the use of apply (Simplifying Object Configuration) and with functions in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        SpanText(
                            text = "Both apply and with functions are used to change properties of an object in a certain scope without repeatedly specifying the object’s name.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "apply is ideal when you need to set up an object and want to return the object itself. It’s commonly used in object creation and configuration. apply is an extension function that applies the specified function to the object and returns the object itself.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "with is similar to run but is not an extension function. It’s great for performing multiple operations on an object without needing to return a result. with is a higher-order function that takes an object and a lambda as parameters, allowing access to the object’s members directly.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                    data class Person(var name: String, var age: Int)

                                    fun main() {
                                        val person = Person("John", 30)

                                        person.apply {
                                            name = "Alice"
                                            age = 25
                                        }

                                        with(person) {
                                            name = "Bob"
                                            age = 35
                                        }

                                        println(person) // Output: Person(name=Bob, age=35)
                                    }
                                """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                             @Composable
                             fun CustomCard() {
                                 Card(
                                     modifier = Modifier
                                         .padding(16.dp)
                                         .fillMaxWidth()
                                 ).apply {
                                     Text(
                                         text = "Hello, Compose!",
                                         style = MaterialTheme.typography.h5,
                                         modifier = Modifier.padding(16.dp)
                                     )
                                 }
                             }
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                            @Composable
                            fun ItemList(items: List<String>) {
                                LazyColumn {
                                    items(items) { item ->
                                        with(item) {
                                            Text(text = this)
                                        }
                                    }
                                }
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "run (Grouping Operations and Returning a Result)",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(top = 1.em).toAttrs()) {
                            SpanText(
                                text = "run is useful when you want to perform multiple operations on an object and return a result. It’s often used for initializing complex objects or managing states. (Execute a block of code and return a result, often used for initializing or calculating values)",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                    val greeting = run {
                        val hour = LocalTime.now().hour
                        when {
                            hour < 12 -> "Good Morning"
                            hour < 18 -> "Good Afternoon"
                            else -> "Good Evening"
                        }
                    }

                    Text(text = greeting)
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the difference between let and apply scope functions in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        SpanText(
                            text = "In Kotlin, both let and apply are scope functions that allow you to operate on an object within a certain scope. While they share some similarities, they serve different purposes.",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                        )

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Object Reference: it. Return Value: Result of the lambda. let is a scope function that allows you to perform operations on a non-null object within the lambda expression. It is commonly used for null-checks and executing additional operations on an object. The result of the let function is the lambda expression result. (The let function is perfect for executing code only when an object is not null. It’s commonly used for null safety and method chaining.)",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Object Reference: this. Return Value: The object itself. apply is a scope function that allows you to configure an object by providing a lambda expression as a receiver. It is often used for initializing or configuring objects. The result of the apply function is the object itself.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                fun main() {
                                    val name: String? = "John"

                                    val result = name?.let {
                                        // Perform operations on non-null object
                                        it.length
                                    }

                                    println(result) // Output: 4
                                }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                data class Person(var name: String, var age: Int)

                                fun main() {
                                    val person = Person("John Doe", 25).apply {
                                        // Configure object
                                        age += 5
                                    }

                                    println(person) // Output: Person(name=John Doe, age=30)
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How does the apply function work in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The apply function in Kotlin is a scope function used for configuring an object. It runs the code block in the context of the object it is called on. The object is returned after the block executes, making it useful for initializing and configuring objects. apply returns the object itself. It is used when you need to perform multiple operations on the same object.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the use of the with function in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Object Reference: this. Return Value: Result of the lambda. The with function in Kotlin is a scope function that allows you to operate on an object within a specific scope without the need to repeatedly reference the object. It is designed to simplify code when you need to perform multiple operations on the same object. (perates on a non-null object without null-checking; good for multiple operations on the same object.)",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = $$"""
                                fun main() {
                                    val person = Person("John", 25)

                                    with(person) {
                                        // Inside this block, 'this' refers to the 'person' object
                                        println("Current person: $$this")

                                        // Operations on 'person'
                                        age += 1
                                        println("After a year: $$this")

                                        // Other operations...
                                    }

                                    // Outside the 'with' block, 'person' retains the modifications made inside the block
                                    println("Final person: $person")
                                }
                                """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the difference between val and var in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "val is used to declare read-only (immutable) variables. Once assigned, the value of a val cannot be changed.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "var is used to declare mutable variables. The value of a var can be reassigned multiple times.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How does String Interpolation work in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "String interpolation in Kotlin allows for the seamless integration of variables or expressions within a string. ",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This is achieved by embedding the variables or expressions directly into the string template.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "You can employ the dollar sign (\$) followed by the variable or expression directly within the string.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "For example, if you have a variable name, you can include it in a string using the syntax “Hello, (\$name)”.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Enclose them within curly braces after the dollar sign for complex expressions. This ensures that the entire expression is evaluated and its result is included in the string.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Kotlin’s string interpolation provides a concise and readable way to construct strings with dynamic content, making code more expressive and maintaining the flexibility of variable inclusion within string literals.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Operators",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )
                }

                KotlinCode(
                    code = """
                        KOTLIN OPERATORS
                                │
             ┌──────────┬───────┼────────┬──────────┐
             ↓          ↓       ↓        ↓          ↓
             Arithmetic Assignment Compare Logical  Equality
             + - * / %   = +=    > <      && || !    == !=
                         -=      >= <=               ===
                                  │
                     ┌────────────┼─────────────┐
                     ↓            ↓             ↓
                     Range       Membership      Type
                     .. until    in !in          is !is
                     downTo
                     step
                      │
                      ↓
                 NULL SAFETY 
                    ?.   → safe call
                    ?:   → Elvis
                    !!   → force non-null
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain equlity in in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Structural equality (==): Compares the values. This operator checks if two objects are equal by evaluating their content, rather than their references. It internally calls the equals() method of the object, so a == b is essentially a?.equals(b) ?: (b === null). Structural equality is usually what you want when comparing data or values for equivalence.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This is achieved by embedding the variables or expressions directly into the string template.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Referential equality (===): Compares the references. This operator checks if two references point to the same object in memory. a === b returns true if a and b are the exact same instance, not just equal in content.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Null Safety",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Kotlin addresses the infamous null reference problem by incorporating null safety into its type system.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, variables are non-nullable by default, meaning a variable cannot hold a null value unless explicitly specified.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How does null safety in Kotlin prevent null pointer exceptions?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Kotlin enforces non-null types by default, preventing variables from being assigned null unless explicitly marked as nullable using a question mark (?). This eliminates the possibility of accidentally using null values, which is a common cause of null pointer exceptions in other languages like Java.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is a null safety feature in Kotlin? How does it work?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Kotlin's null safety feature aims to eliminate null pointer exceptions (NPEs), a common problem in programming languages like Java. In Kotlin, types are non-nullable by default, meaning you cannot assign null to a variable unless explicitly allowed.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Non-nullable types: By default, variables in Kotlin cannot hold a null value. ",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Nullable types: To allow a variable to hold null, you need to declare the type as nullable by appending a ?:",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Safe calls (?.): The safe call operator (?.) allows you to safely call methods or access properties on a nullable object. If the object is null, the operation will return null rather than throwing a NullPointerException.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Elvis operator (?:): The Elvis operator allows you to provide a default value when a nullable expression evaluates to null.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Kotlin’s null safety system ensures that nullability is explicitly handled, preventing most of the common issues associated with null references.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the purpose of the “!!” operator in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The !! operator in Kotlin is called the \"not-null assertion operator.\" It is used to explicitly tell the compiler that a nullable reference is guaranteed to be non-null at a specific point in the code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If the value turns out to be null, a NullPointerException will be thrown. It should be used with caution as it bypasses the null safety checks provided by the Kotlin type system.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How do you handle nullability in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Safe Calls: Use the safe call operator (?.) to safely access properties or call methods on a nullable object. If the object is null, the expression evaluates to null instead of throwing a null pointer exception.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                val length: Int? = text?.length
                            """.trimIndent()
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Elvis Operator: The Elvis operator (?:) is a shorthand notation in Kotlin. The Elvis operator allows you to provide a default value when accessing a nullable object. If the object is null, the expression after the Elvis operator is returned instead. (If the variable is not null, it returns the variable; otherwise, it returns the specified default value.)",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                              val name: String? = null
                              val length = name?.length ?: 0 // Returns 0 if name is null
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                val a: String? = null
                                val length = a?.length ?: -1 //if a is not null, use it, otherwise use some non-null value
                                println(length) // - 1 printed
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                var state by mutableStateOf(WeatherState())
                                    private set

                                fun loadWeatherInfo() {
                                    viewModelScope.launch {
                                        state = state.copy(
                                            isLoading = true, errorMessage = null
                                        )
                                        location.getLocation()?.let { location ->
                                            val result = repository.getWeatherData(location.latitude, location.longitude)

                                            when (result) {
                                                is Resource.Success -> {
                                                    state = state.copy(
                                                        weatherInfo = result.data,
                                                        isLoading = false,
                                                        errorMessage = null,
                                                    )
                                                }

                                                is Resource.Error -> {
                                                    state = state.copy(
                                                        weatherInfo = null,
                                                        isLoading = false,
                                                        errorMessage = result.message,
                                                    )
                                                }
                                            }
                                        } ?: kotlin.run {
                                            state = state.copy(
                                                isLoading = false,
                                                errorMessage = "Couldn't retrieve location. Make sure to grant the permission and enable GPS."
                                            )
                                        }
                                    }
                                }
                        """.trimIndent()
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Safe Casts: Use the safe cast operator (as?) to perform type casts on nullable objects. If the cast is unsuccessful, the result is null. The safe cast operator is particularly useful when working with uncertain or dynamic types. If you are receiving data from external sources (like APIs) or handling generic data, you may not always be sure of the object’s type. Using as? allows you to avoid ClassCastException and gracefully handle cases where the object might not be of the expected type.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                val name: String? = value as? String
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                            val mixedList: List<Any> = listOf(1, "Hello", 3, true, 5)

                            fun processIntegersInList(mixedList: List<Any>) {
                                for (item in mixedList) {
                                    (item as? Int)?.let { println(it) }
                                }
                            }
                        """.trimIndent()
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Non-Null Assertion (Not-null assertion operator): When you are certain that a nullable variable is not null at a specific point, you can use the non-null assertion operator (!!) to bypass null safety checks. However, if the variable is actually null, a null pointer exception will occur.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                val length: Int = text!!.length
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What are Smart Casts?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A feature where the compiler, after a conditional type check (e.g., if (x is String)), automatically Casts the variable x to the String type, without needing an explicit cast.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is “any” extension function in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Any extension function loops through a data structure and checks if any elements satisfy the provided condition. It then returns a Boolean value accordingly.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                fun main() {
                                    val list = listOf(1, 2,3,4,1,2,5,4)
                                    val isGreaterThanThree = list.any { it > 3 }
                                    //isGreaterThanThree
                                }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                fun main(){
                                    val map = mapOf<String, Boolean>(
                                        "one" to false,
                                        "two" to true,
                                        "three" to false,
                                        "four" to false)
                                    val isAnyOneTrue = map.any{it.value}
                                }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                            //Overloading Extension Functions
                            
                             fun String.reverse(): String {
                                 return buildString {
                                     for (i in this@reverse.lastIndex downTo 0) {
                                         append(this@reverse[i])
                                     }
                                 }
                             }

                             fun Int.reverse(): Int {
                                 return this.toString().reversed().toInt()
                             }

                             // Usage
                             println("Hello".reverse())  // "olleH"
                             println(12345.reverse())    // 54321
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the concept of operator overloading in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Operator overloading in Kotlin allows you to define how an operator should behave when used with instances of your custom classes.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It enables you to provide custom implementations for operators such as +, -, *, /, and more. For example:",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                  data class Vector(val x: Int, val y: Int) {
                                      operator fun plus(other: Vector): Vector {
                                          return Vector(x + other.x, y + other.y)
                                      }
                                  }

                                  fun main() {
                                      val v1 = Vector(1, 2)
                                      val v2 = Vector(3, 4)
                                      val sum = v1 + v2

                                      println(sum) // Output: Vector(x=4, y=6)
                                  }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the operator modifier and how do you overload operators in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The operator modifier allows you to override symbols like +, [], or ==. It adds syntactic sugar to class operations.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                data class Point(val x: Int, val y: Int) 
                                {
                                    operator fun plus(other: Point): Point 
                                    {
                                        return Point(x + other.x, y + other.y)
                                    }
                                }
                                
                                val p1 = Point (1, 2)
                                val p2 = Point (3, 4)
                                val sum = p1 + p2 // Point(x=4,y=6)
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the difference between init and constructor in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "init is an initialization block that is executed when an instance of a class is created.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It is used to initialize properties or perform other setup operations.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The primary constructor and any secondary constructors are responsible for creating the instance, while the init block handles the initialization logic.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The main difference is that the init block is always executed regardless of which constructor is used.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = $$"""
                                class Person(name: String) {
                                    val greeting: String

                                    init {
                                        greeting = "Hello, $name!"
                                        println("Person initialized")
                                    }
                                }

                                fun main() {
                                    val person = Person("John") // Output: Person initialized

                                    println(person.greeting) // Output: Hello, John!
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the concept of typealias in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "We can use the typealias keyword to make complex types more readable and concise. typealias is used to provide an alternative name for an existing type. It allows you to create a new name for a complex or lengthy type, making the code more readable and maintainable.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Typealiases do not create new types; they are just aliases for existing types.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                typealias EmployeeId = String

                                class Employee(val id: EmployeeId, val name: String)

                                fun main() {
                                    val employee = Employee("123", "John Doe")
                                    println(employee.id) // Output: 123
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the purpose of the downTo keyword in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The downTo keyword in Kotlin is used in conjunction with the .. range operator to create a range of values in descending order. It is commonly used in for loops to iterate over a range of values from a higher value down to a lower value.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                for (i in 10 downTo 1) {
                                    println(i)
                                }

                                // Output:
                                // 10
                                // 9
                                // 8
                                // ...
                                // 1
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                //Palindrome downTo
                                fun main() {
                                    val originalString = "Madam"

                                    var reverseString = ""
                                    var length = originalString.length

                                    for (i in (length - 1) downTo 0) {
                                        reverseString += originalString[i]
                                    }

                                    // Case in-sensitive comparision
                                    if (originalString.equals(reverseString, ignoreCase = true)) {
                                        println("The given string is Palindrome")
                                    } else {
                                        println("The given string is NOT a Palindrome")
                                    }
                                }
                            """.trimIndent()
                    )
                }

                KotlinCode(
                    code = """
                        //ArrayDeque using Palindrome
                        
                        //ArrayDeque (Double-Ended Queue) fills this gap, offering a versatile, efficient, and Kotlin-idiomatic way to manage data from both ends.
                        
                        //1
                        fun isPalindromeDeque(text: String): Boolean {
                            val clean = text.lowercase().filter { it.isLetterOrDigit() }
                            val deque = ArrayDeque<Char>()

                            for (c in clean) deque.addLast(c)

                            while (deque.size > 1) {
                                if (deque.removeFirst() != deque.removeLast()) return false
                            }
                            return true
                        }

                        fun main() {
                            println(isPalindromeDeque("Madam")) // true
                        }
                        
                        //2
                        fun isPalindromeSentenceDeque(sentence: String): Boolean {
                            val deque = ArrayDeque<Char>()

                            for (ch in sentence.lowercase()) {
                                if (ch.isLetterOrDigit()) deque.addLast(ch)
                            }

                            while (deque.size > 1) {
                                if (deque.removeFirst() != deque.removeLast()) return false
                            }
                            return true
                        }

                        fun main() {
                            println(isPalindromeSentenceDeque("Madam, in Eden, I’m Adam")) // true
                        }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Labels in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, **labels** help control the flow of nested loops or functions. They allow you to break or continue specific loops or return from specific points in your code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "break@label: Exits a specific loop (not just the innermost one)..",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "continue@label: Skips the current iteration of a specific loop.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "return@label: Returns from a function or lambda.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = $$"""
                                  //break
                                  outerLoop@ for (i in 1..3) {
                                      for (j in 1..3) {
                                          if (i == 2 && j == 2) {
                                              break@outerLoop // Breaks out of the outer loop
                                          }
                                          println("i = $i, j = $j")
                                      }
                                  }
                                  
                                  //continue
                                  outerLoop@ for (i in 1..3) {
                                      for (j in 1..3) {
                                          if (i == 2 && j == 2) {
                                              continue@outerLoop // Skips to the next iteration of the outer loop
                                          }
                                          println("i = $i, j = $j")
                                      }
                                  }
                            """.trimIndent()
                    )
                }

                KotlinCode(
                    code = $$"""
                        fun main() {
                            outer@ for (i in 1..10) {  
                                println("How many times will i be printed? $i") 
                            }
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = $$"""
                        fun main() {
                            outermost@ for (num in listOf(1, 2, 3)) {  
                            middle@ for (char in listOf('a', 'b', 'c')) {  
                                innermost@ for (numChar in listOf("1a", "2b", "3c")) {  
                                    println("$num:$char:$numChar")  
                                    if (numChar == "2b") break@middle  
                                }  
                            }
                          }
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = $$"""
                        fun main() {
                            listOf(1, 2, 3).forEach { num ->  
                                listOf('a', 'b', 'c').forEach { char ->  
                                    if (char == 'b') return@forEach  
                                    println("How many times will this be printed? $num:$char")  
                                }  
                            }
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = $$"""
                        fun main() {
                            listOf(1, 2, 3).forEach outer@ { num ->  
                                listOf('a', 'b', 'c').forEach middle@ { char ->  
                                    listOf("1a", "2b", "3c").forEach inner@ {  
                                        println("$num:$char:$it")  
                                        if (it == "2b") return@middle  
                                    }  
                                }    
                            }
                        }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the concept of the until keyword in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The until keyword in Kotlin is used in conjunction with the .. range operator to create a range of values excluding the end value.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It defines a range from the starting value up to, but not including, the end value.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The until range is often used in loop statements to iterate over a range of values.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                  for (i in 1 until 5) {
                                      println(i)
                                  }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "step keyword",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "we can use it to define a distance between the values of the range",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                for (i in 0..8 step 2) print(i)

                                for (i in 0..8 step 2) print(i)
                                // 02468

                                for (i in 0..<8 step 2) print(i)
                                // 0246

                                for (i in 8 downTo 0 step 2) print(i)
                                // 86420
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Ranges and progressions",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "a closed-ended range, call the .rangeTo() function with the .. operator.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "an open-ended range, call the .rangeUntil() function with the ..< operator.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 // Closed-ended range
                                 println(4 in 1..4)
                                 // true

                                 // Open-ended range
                                 println(4 in 1..<4)
                                 // false

                                 for (i in 1.rangeTo(9)) {
                                     print(i) // Print 123456789
                                 }

                                 //progressions
                                 for (i in 1..10) print(i)
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What are the Backing Field and the field keyword?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The Backing Field is the location where the actual Property value is stored. The keyword field is used in custom Getter/Setter implementations to access this value and prevent recursive calls.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is a Kotlin backing field used for?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A backing field is a field that supports the getter and setter of a property. It is used when you need to provide custom behavior or additional logic during property access or modification.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When you define a property with a custom getter or setter, Kotlin generates a backing field automatically. You can refer to the backing field using the field identifier inside the getter or setter.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                var counter: Int = 0
                                get() = field // Getter accessing the backing field
                                set(value) {
                                    field = if (value >= 0) value else 0 // Setter modifying the backing field
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the purpose of the protected modifier in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The protected modifier in Kotlin is an access modifier used to restrict the visibility of a class, function, or property to its containing class and its subclasses. It allows access within the same class and any subclasses that inherit from it. Outside the class hierarchy, the protected members are not visible.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                  open class Parent {
                                      protected val protectedProperty = "Protected Property"
                                  }

                                  class Child : Parent() {
                                      fun printProtectedProperty() {
                                          println(protectedProperty) // Accessible in subclasses
                                      }
                                  }

                                  class Other {
                                      fun printProtectedProperty() {
                                          val parent = Parent()
                                          println(parent.protectedProperty) // Not accessible outside the class hierarchy
                                      }
                                  }

                                  fun main() {
                                      val child = Child()
                                      child.printProtectedProperty() // Output: Protected Property
                                  }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Differentiate between open and public keywords in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "open Keyword: The open keyword is used with classes and methods. When a class is marked as open, it means that the class can be inherited, allowing other classes to extend it. Similarly, when a method is marked as open, it means that the method can be overridden in subclasses.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "public Modifier: If you don’t explicitly specify an access modifier, the declaration is considered public. However, unlike open, public is not a keyword you explicitly write in the code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "What is the open Keyword?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, classes and methods are final by default. This means that we cannot be inherited or overridden unless explicitly marked as open. The open keyword serves as a way to declare that a class or a member (method or property) can be subclassed or overridden.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Inheritance: it’s enables other classes to inherit from the class, inheriting its properties and methods. (Creating new classes by inheriting properties from existing ones.)",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Overriding: it’s allows subclasses to override methods or properties of the base class with their own implementations.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Flexibility: it’s promotes code flexibility by allowing you to extend and customize existing functionality.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Design Patterns: it’s crucial for implementing design patterns like inheritance, polymorphism, and template methods.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Mark Only Necessary Members: Only mark classes, functions, or properties as open if you anticipate the need for inheritance or overriding. Avoid unnecessary openness.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Consider Abstract Classes: If you want to enforce overriding in subclasses, use abstract classes instead of marking methods as open. Abstract classes have implicitly open methods.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Protect Sensitive Data: If you want to prevent subclasses from accessing or modifying certain data, declare it as private or internal.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Nothing",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Nothing represents a dead end. Control is never handed back to the caller normally.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Represents the absence of any value indicating that a function will never return normally - it either throws an exception or otherwise stops the program. In this context, 'halts' means the function stops further execution of the code beyond the point where it is called. The program flow is interrupted, and control is not returned to the caller.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Subtype of all well-formed Kotlin types, including user-defined ones.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Used for functions that never return, either because they throw an exception or enter an infinite loop.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "We cannot create an instance of Nothing, nor can any class inherit from it.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Functions with a return type of Nothing doesn’t return any value not even the default return type Unit.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The Nothing return type in Kotlin saves us from potential bugs by making it clear that they do not return. When any function having Nothing as the return type is invoked, then the compiler will not execute beyond this function call and gives us the Unreachable code warning.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A suspending() that muse be called from a coroutines, but runs an infinite loop so it'll never return. For examle Timer",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                             fun fail(message: String): Nothing {
                                 throw IllegalArgumentException(message)
                             }

                             fun main() {
                                 // This will throw an exception and never return normally
                                 fail("This is an error!")
                                 println("Hello") // Compiler gives warning "Unreachable code"
                             }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is Unit?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Unit is a real object. A function returning Unit finishes its work and returns control back to the caller normally.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When the return type of a function is Unit it means that the function does not return anything. In Kotlin, the default return type of a function is Unit meaning that if you do not specify the return type of a function explicitly then the Kotlin compiler uses Unit as the return type.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 fun printHello(): Unit {
                                     println("Hello")
                                 }

                                 // Equivalent and more concise version
                                 fun printHello() {
                                     println("Hello")
                                 }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                            // Explicitly returning Unit (which is redundant)
                            fun printHello(name : String?) : Unit {
                                if (name != null)
                                    print(name!)
                                else
                                    print("Hi there!")
                                // We don't need to write 'return Unit.VALUE' or 'return', although we could

                             return Unit  // This is not necessary in Kotlin
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the purpose of Unit-returning in functions? Why is VALUE there? What is this value?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, Unit is a type that represents the absence of a value. It is similar to void in Java or other programming languages. The Unit type is used as the return type of functions that don't return a meaningful value.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The Unit keyword itself represents the singleton instance of the Unit type, and it can be omitted when declaring functions with Unit as the return type. It serves as a marker to indicate that the function doesn't produce any useful result.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "For example, a function that performs a side effect, such as printing to the console, can have a return type of Unit to indicate that it doesn't produce a value that needs to be used by the caller.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 fun printHello(): Unit {
                                     println("Hello")
                                 }

                                 // Equivalent and more concise version
                                 fun printHello() {
                                     println("Hello")
                                 }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                            // Explicitly returning Unit (which is redundant)
                            fun printHello(name : String?) : Unit {
                                if (name != null)
                                    print(name!)
                                else
                                    print("Hi there!")
                                // We don't need to write 'return Unit.VALUE' or 'return', although we could

                             return Unit  // This is not necessary in Kotlin
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "fromMillisToMinutes",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    KotlinCode(
                        code = """
                        fun fromMillisToMinutes(millis: Long): String {
                            return if (millis > 0) {
                                String.format(
                                    "%02d:%02d",
                                    TimeUnit.MILLISECONDS.toMinutes(millis) % TimeUnit.HOURS.toMinutes(1),
                                    TimeUnit.MILLISECONDS.toSeconds(millis) % TimeUnit.MINUTES.toSeconds(1)
                                )
                            } else ""
                        }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "ISO 8601 standards converts to UTC.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    KotlinCode(
                        code = $$"""
                                import java.time.Instant
                                import java.time.ZoneOffset
                                import java.time.format.DateTimeFormatter

                                fun main() {
                                    val formatter = DateTimeFormatter.ofPattern ("yyyy-MM-dd'T'HH:mm:ss[.SSS][.SS][.S]X")
                                    val dateString = "2023-10-11T06:33:52Z"
                                    val instant = Instant. from(formatter.parse(dateString))
                                    val hour = instant.atOffset(ZoneOffset.UTC).hour
                                    val minutes = instant.atOffset(ZoneOffset.UTC).minute
                                    val seconds = instant.atOffset(ZoneOffset.UTC).second
                                    println("Hour: $hour, Minutes: $minutes, Seconds: $seconds")
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "ISO Date convert dd-MM-yyyy in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    KotlinCode(
                        code = """
                                fun convertDateFormat(isoDate: String): String {
                                    val inputFormat = SimpleDateFormat("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", Locale.getDefault())
                                    val outputFormat = SimpleDateFormat("dd-MM-yyyy", Locale.getDefault())

                                    try {
                                        val date = inputFormat.parse(isoDate)
                                        return outputFormat.format(date!!)
                                    } catch (e: Exception) {
                                        e.printStackTrace()
                                    }

                                    return ""
                                }

                                fun formatDate(date: String): String {
                                    val originalFormat: DateFormat = SimpleDateFormat("yyyy-MM-dd'T'HH:mm:ss'Z'", Locale.getDefault())
                                    val targetFormat: DateFormat = SimpleDateFormat("MMMM dd, YYYY", Locale.getDefault())
                                    val newDate: Date = originalFormat.parse(date)!!
                                    return targetFormat.format(newDate)
                                }
                            """.trimIndent()
                    )

                    //https://github.com/pingguo0901/zhixiangshipu-app
                    KotlinCode(
                        code = $$"""
                             import kotlinx.datetime.Clock
                             import kotlinx.datetime.Instant
                             import kotlinx.datetime.TimeZone
                             import kotlinx.datetime.toLocalDateTime

                             //ISO string (Asia/Kuala_Lumpur, with +08:00 time zone offset to prevent it from being treated as UTC)
                             fun currentIso(): String {
                                 val tz = TimeZone.of("Asia/Kuala_Lumpur")
                                 val now = Clock.System.now().toLocalDateTime(tz)
                                 return "%04d-%02d-%02dT%02d:%02d:%02d+08:00".format(
                                     now.year, now.monthNumber, now.dayOfMonth,
                                     now.hour, now.minute, now.second
                                 )
                             }

                             // YYYY-MM-DD
                             fun todayDate(): String {
                                 val tz = TimeZone.of("Asia/Kuala_Lumpur")
                                 val now = Clock.System.now().toLocalDateTime(tz)
                                 return "%04d-%02d-%02d".format(now.year, now.monthNumber, now.dayOfMonth)
                             }

                             //YYYY-MM-DD
                             fun millisToDate(millis: Long): String {
                                 val tz = TimeZone.of("Asia/Kuala_Lumpur")
                                 val dt = Instant.fromEpochMilliseconds(millis).toLocalDateTime(tz)
                                 return "%04d-%02d-%02d".format(dt.year, dt.monthNumber, dt.dayOfMonth)
                             }

                             //ISO（2026-09-02T22:33:48+00:00） Asia/Kuala_Lumpur "YYYY-MM-DD HH:mm"
                             fun isoToKlDateTime(iso: String): String {
                                 if (iso.isBlank()) return ""
                                 return runCatching {
                                     val dt = Instant.parse(iso).toLocalDateTime(TimeZone.of("Asia/Kuala_Lumpur"))
                                     "%04d-%02d-%02d %02d:%02d".format(dt.year, dt.monthNumber, dt.dayOfMonth, dt.hour, dt.minute)
                                 }.getOrElse { iso.take(16).replace("T", " ") }
                             }

                             //ISO Asia/Kuala_Lumpur "YYYY-MM-DD"
                             fun isoToKlDate(iso: String): String {
                                 if (iso.isBlank()) return ""
                                 return runCatching {
                                     val dt = Instant.parse(iso).toLocalDateTime(TimeZone.of("Asia/Kuala_Lumpur"))
                                     "%04d-%02d-%02d".format(dt.year, dt.monthNumber, dt.dayOfMonth)
                                 }.getOrElse { iso.take(10) }
                             }

                             //ISO → "dd/MM/yyyy HH:mm"
                             fun isoToKlDateTimeSlash(iso: String): String {
                                 if (iso.isBlank()) return iso
                                 return runCatching {
                                     val dt = Instant.parse(iso).toLocalDateTime(TimeZone.of("Asia/Kuala_Lumpur"))
                                     "%02d/%02d/%04d %02d:%02d".format(dt.dayOfMonth, dt.monthNumber, dt.year, dt.hour, dt.minute)
                                 }.getOrElse {
                                     val datePart = iso.take(10)
                                     val timePart = if (iso.length >= 16) iso.substring(11, 16) else ""
                                     val parts = datePart.split("-")
                                     if (parts.size == 3) "${parts[2]}/${parts[1]}/${parts[0]} $timePart" else iso
                                 }
                             }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "IST Time to GMT Time in Kotlin.",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        KotlinCode(
                            code = """
                                val sdfIST = SimpleDateFormat("yyyy-MM-dd'T'HH:mm", Locale.getDefault())
                                sdfIST.timeZone = TimeZone.getTimeZone("IST") // Set timezone to IST

                                val parsedTimeIST: Date = sdfIST.parse("Enter Time")!!

                                val sdfGMT = SimpleDateFormat("yyyy-MM-dd'T'HH:mm", Locale.getDefault())
                                sdfGMT.timeZone = TimeZone.getTimeZone("GMT") // Set timezone to GMT

                                val timeGMT: String = sdfGMT.format(parsedTimeIST)
                                val parsedTimeGMT: Date = sdfGMT.parse(timeGMT)!!
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How are single-expression functions declared?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, a single-expression function is declared using the = sign after the function signature, followed by the expression representing the function's result.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 fun add(a: Int, b: Int): Int = a + b
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is Android KTX?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        SpanText(
                            text = "Android KTX is a set of Kotlin extensions specifically crafted for Android development. It is an open-source library provided by the Android team to improve the Kotlin programming experience when working with Android APIs. The primary goal of Android KTX is to make Android code more concise and idiomatic in Kotlin.",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                        )

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "implementation “androidx.core:core-ktx:1.7.0",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "implementation “androidx.collection:collection-ktx:1.3.0",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "implementation “androidx.fragment:fragment-ktx:1.6.2",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                val textView: TextView = findViewById(R.id.textView)
                                textView.text = "Hello, Android!"

                                val value = PreferenceManager.getDefaultSharedPreferences(context).getString("key", "defaultValue")

                                //Fragement Transaction
                                supportFragmentManager.transaction {
                                 replace(R.id.fragmentContainer, MyFragment())
                                 addToBackStack(null)
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Validation",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    KotlinCode(
                        code = """
                                 //PASSWORD VALIDATION
                                 // (?=.*[a-z]): Must contain at least one lowercase letter.
                                 // (?=.*[A-Z]): Must contain at least one uppercase letter.
                                 // (?=.*\d): Must contain at least one digit.
                                 // .{8,}: Must be at least 8 characters long.
                                 private val passwordRegex = Regex("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{8,}${'$'}")
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                              fun String.validatePassword(): String? {
                                  return when {
                                      isEmpty() -> "Password must not be empty"
                                      length < 8 -> "Password must be at least 8 characters"
                                      !matches("^(?=.*[A-Za-z])(?=.*\\d).+\$".toRegex()) -> "Password must contain at least 1 letter and 1 number"
                                      !matches("^(?=.*[!@#\$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\\/?]).+\$".toRegex()) -> "Password must contain at least 1 special character"
                                      else -> null
                                  }
                              }

                              fun String.validateConfirmPassword(password: String): String? {
                                  return when {
                                      isEmpty() -> "Confirm password must not be empty"
                                      this != password -> "Confirm password must be the same as password"
                                      else -> null
                                  }
                              }
                        """.trimIndent()
                    )

                    //https://github.com/omprakashsrv/ampairs-app
                    KotlinCode(
                        code = """
                             //GST Validation
                             //https://github.com/omprakashsrv/ampairs-app
                             
                             sealed class GstinValidationError(override val details: String? = null) : ValidationError {
                                 data object InputIsNull : GstinValidationError("Input is not a valid GSTIN because it is null.")
                                 data object Empty : GstinValidationError("Input is not a valid GSTIN because it is empty.")
                                 data object InvalidLength : GstinValidationError("GSTIN must be exactly 15 characters.")
                                 data object InvalidFormat : GstinValidationError("Input is not in a valid GSTIN format.")
                                 data object InvalidStateCode : GstinValidationError("Input contains an invalid state code.")
                                 data object InvalidChecksum : GstinValidationError("Input contains an invalid checksum.")

                                 val message: String
                                     get() = when (this) {
                                         is InputIsNull -> "GSTIN cannot be null"
                                         is Empty -> "GSTIN cannot be empty"
                                         is InvalidLength -> "GSTIN must be exactly 15 characters"
                                         is InvalidFormat -> "Invalid GSTIN format"
                                         is InvalidStateCode -> "Invalid state code in GSTIN"
                                         is InvalidChecksum -> "Invalid GSTIN checksum"
                                     }
                             }
                             
                             class GstinValidator : Validator<String?, String> {

                                 companion object {
                                     // GSTIN format: 15 characters - 2 digits (state code) + 10 alphanumeric (PAN) + 1 digit (entity code) + 1 alphabet (default Z) + 1 digit (checksum)
                                     private val GSTIN_REGEX = Regex("^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}\$")

                                     // Valid state codes (1-38 for states/UTs)
                                     private val VALID_STATE_CODES = (1..38).map { it.toString().padStart(2, '0') }.toSet()
                                 }

                                 override fun validate(input: String?): ValidationResult<String> {
                                     if (input == null) return Invalid(GstinValidationError.InputIsNull)

                                     val cleanInput = input.trim().uppercase()

                                     if (cleanInput.isEmpty()) return Invalid(GstinValidationError.Empty)

                                     if (cleanInput.length != 15) return Invalid(GstinValidationError.InvalidLength)

                                     if (!cleanInput.matches(GSTIN_REGEX)) return Invalid(GstinValidationError.InvalidFormat)

                                     // Validate state code
                                     val stateCode = cleanInput.substring(0, 2)
                                     if (stateCode !in VALID_STATE_CODES) return Invalid(GstinValidationError.InvalidStateCode)

                                     // Validate checksum (simplified - in real implementation you'd calculate the actual checksum)
                                     if (!isValidChecksum(cleanInput)) return Invalid(GstinValidationError.InvalidChecksum)

                                     return Valid(cleanInput)
                                 }

                                 private fun isValidChecksum(gstin: String): Boolean {
                                     // Simplified checksum validation
                                     // In a real implementation, you would calculate the GSTIN checksum algorithm
                                     // For now, we'll just check that the last character is alphanumeric
                                     val lastChar = gstin.last()
                                     return lastChar.isLetterOrDigit()
                                 }
                             }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain data class in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Data classes in kotlin are defined using the data keyword.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It usually comprises properties that encapsulate the data it holds.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Component Functions: Enable easy destructuring of these classes.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Immutability & Mutability: They primarily encourage immutable states but can use mutable properties for flexibility.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                data class User(val name: String, val surname: String)

                                fun main () {
                                    val userList = listOf(User("John", "Dummy"), User("Amanda", "Carol"))
                                    val listFormatIt = userList.map { it.name }
                                    val listFormatItName = userList.map{ user-> user. name}
                                    println(listFormatIt)
                                    println(listFormatItName)

                                    val nameList = userList.map(User::name)
                                    println(nameList)
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is data class in Kotlin? How does a data class in Kotlin differ from a regular class?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, a data class is a special type of class specifically designed to hold data. Kotlin generates several useful methods automatically for data classes, which makes them ideal for representing simple data-holding objects.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "equals () : Compares two instances of the class for equality based on their properties.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "hashCode() : Generates a hash code based on the properties.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "toString() : Provides a string representation of the object with its property values. The toString() method is used to get a string representation of an object. In Kotlin, data classes automatically generate a toString() method that provides a readable string representation of the object’s properties.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "copy () : Allows for creating a new object with some properties copied from the existing one, with the option to modify specific values.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Component functions: For destructuring declarations (e.g., component](), component2() ), allowing you to extract properties easily.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the difference between the == operator and the .equals() method in Java?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The == operator checks for object reference equality, while the .equals() method checks for object value equality. For example, two different String objects with the same value will return true when compared using .equals(), but false when compared using ==.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {

                    SpanText(
                        text = "What is the difference between “==” and “===” operators in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, the == operator is used for structural equality comparison (if the content or values are the same), which checks if the values of two objects are equal. == is for comparing values.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "On the other hand, the === operator is used for referential equality comparison (if two references point to the same object), which checks if two references point to the same object in memory. Comparing object references.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the concepts of immutable and mutable variables in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Immutable Variables: Immutable variables are declared using the val keyword. Once assigned a value, its value cannot be changed or reassigned. They are read-only and provide a guarantee of immutability.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Mutable Variables: Mutable variables are declared using the var keyword. They can be assigned a value initially and then modified or reassigned later. Mutable variables provide flexibility for value changes during program execution. mutable list can be modified by adding, removing, or modifying its elements using specific functions.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                  val immutableList: List<Int> = listOf(1, 2, 3) // Immutable list
                                  val mutableList: MutableList<Int> = mutableListOf(4, 5, 6) // Mutable list
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain JvmInline in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An inline class in Kotlin is a special class that wraps a single value and provides type safety without the memory overhead of a traditional object.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Value classes in Kotlin allow you to create classes that are inline at runtime, meaning they avoid the overhead of object allocation. This is useful for representing small, immutable objects such as identifiers, measurements, or wrappers without additional memory or runtime cost.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "@JvmInline and value keywords, are designed for wrapping a single value efficiently but with no additional overhead at runtime. Inline classes are immutable. Inline classes are declared using the @JvmInline annotation, and the compiler optimizes them by avoiding additional object allocations whenever possible.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = $$"""
                    //1
                    @JvmInline
                    value class UserId(val id: String) {
                        fun getUpperCaseId() = id.uppercase()
                    }

                    fun main() {
                        val userId = UserId("abc123")
                        println(userId.getUpperCaseId()) // Output: ABC123
                    }

                    //2
                    @JvmInline
                    value class UserId(val id: String)

                    fun printUserId(userId: UserId) {
                        println(userId.id)
                    }

                    fun main() {
                        val userId = UserId("12345")
                        printUserId(userId)
                    }

                    //3
                    @Jvminline
                    value class Emailld (val email: String) {
                        fun isValid() = "".toRegex().matches(email)
                    }

                    fun sendEmail(emailld: Emailld): String {
                     	return if (emailld.isValid()) {
                            "Valid email"
                        } else {
                           "Invalid email"
                        }
                    }
                    
                    //4
                    @JvmInline
                    value class Email(val value: String) {
                        init {
                            require(value.contains("@")) { "Invalid email format" }
                        }

                        constructor(local: String, domain: String) : this("$local@$domain")

                        val domain: String
                            get() = value.substringAfter("@")
                    }
                    
                    //5
                    @JvmInline value class OrderId(val value: String)
                    @JvmInline value class UserId(val value: String)

                    fun transferOwnership(orderId: OrderId, from: UserId, to: UserId)
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Kotlin 1.9.0",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    KotlinCode(
                        code = """
                                // Kotlin 1.8.0
                                launch {
                                    val result = asyncTask()
                                    // Handle the result
                                }

                                // Kotlin 1.9.0
                                coroutineScope {
                                    val result = asyncTask()
                                    // Handle the result
                                }

                                // Kotlin 1.8.0
                                if (value != null && value.isNotEmpty()) {
                                    // Do something
                                }

                                // Safe call operator ?.
                                if (value?.isNotEmpty() == true) {
                                    // Do something
                                }

                                // Kotlin 1.8.0
                                val list = listOf(1, 2, 3, 4, 5)
                                val squaredList = list.map { it * it }

                                // Kotlin 1.9.0
                                val squaredList = listOf(1, 2, 3, 4, 5).mapSquared()
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Kotlin 2.0.0 Beta-2",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    KotlinCode(
                        code = """
                                // Before Kotlin 2.0.0 Beta-2
                                val myString: String = "Hello, Kotlin!"

                                // With Kotlin 2.0.0 Beta-2
                                val myString = "Hello, Kotlin!"

                                // Improved coroutine scope
                                viewModelScope.launch {
                                    val result = asyncTask()
                                    // Handle the result
                                }

                                // Cancellation made easy
                                val job = launch {
                                    try {
                                        // Coroutine logic
                                    } finally {
                                        // Cleanup code
                                    }
                                    // More logic
                                    // ...
                                    // Coroutine gets cancelled, and cleanup code is executed
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the concept of lazy initialization in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Lazy initialization in Kotlin is a technique where a property is not initialized until its value is accessed for the first time. It helps in optimizing resource usage by deferring the initialization process until it is actually needed. You have an immutable property (val). ou want to delay computation until first access.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Lazy initialization is typically used for properties that are computationally expensive or require expensive resource allocation, where it is unnecessary to initialize them immediately.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Lazy initialization simply works in the form of *I will only provide memory location for this value only when you use it in your code and I will only do this once and that’s it, all your other usages will be fetched from cache.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This initialization is used in the case of the val property.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It can be used when an object is dependent on a variable internal to the class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                            val expensiveProperty: String by lazy {
                                // Expensive initialization code
                                 "Initialized value"
                            }

                            fun main() {
                                println("Before accessing property")
                                println(expensiveProperty) // Property access triggers initialization
                                println("After accessing property")
                            }
                                """.trimIndent()
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In the example, the expensiveProperty is declared using the lazy delegate. The initialization code is provided as a lambda expression, which will only be executed when the property is accessed for the first time. In this case, the initialization code is executed and the value Initialized value is assigned to the property. Subsequent access to the property will return the already initialized value.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li {
                            SpanText(
                                text = "Lazy initialization is useful for optimizing performance and resource usage, especially for properties that are not frequently accessed or have expensive initialization logic.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "lateinit keyword in kotlin",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "lateinit is for mutable var (non-null, initialized later, throws UninitializedPropertyAccessException if accessed early)",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Used to declare a non-nullable variable that will be initialized later. Usage: Must be initialized before accessing it; otherwise, it throws an UninitializedPropertyAccessException. Cannot be used with primitive types (like Int, Boolean). Can only be used with properties (not local variables).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "lateinit means late initialization. The keyword is used for mutable() properties that will be initialized later but before first use.  Works with var. You must set it before use, or it crashes. lateinit cannot be used for val, Primitive. Common use ependency injection, Android views, unit testing.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "lateinit is a modifier that is used for non-null properties (except primitive types like etc). It allows you to declare a property without initializing it immediately, but you must initialize it before using it, otherwise, it will throw a LateInitializationException.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "lateinit property is a property that is declared without an initial value, but is guaranteed to be initialized before it is used.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This is useful for properties that cannot be initialized in the constructor, but need to be initialized before they are used.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An initialized property, on the other hand, is a property that is declared with an initial value and can be used immediately.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Accessing Lateinit before initialization will throw an UnInitializedPropertyAccessException meaning it must be initialized before usage.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Hidden Pitfall: If lateinit property is never initialized and accessed, it results in a UninitializedPropertyAccessException.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Alternative: If lateinit is overused, consider using nullable types (String?) with !! assertions instead.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 class MainActivity : AppCompatActivity() {
                                     lateinit var textView: TextView // Declared without initialization

                                     override fun onCreate(savedInstanceState: Bundle?) {
                                         super.onCreate(savedInstanceState)
                                         setContentView(R.layout.activity_main)

                                         textView = findViewById(R.id.myTextView) // Initialize here
                                     }
                                 }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                //Check if a lateinit variable has been initialized
                                
                                class Example {
                                    private lateinit var myString: String

                                    fun initialize() {
                                        myString = "Hello, Kotlin!"
                                    }

                                    fun checkInitialization() {
                                        // Check if the variable has been initialized
                                        if (::myString.isInitialized) {
                                            println(myString) // This will print the value if initialized
                                        } else {
                                            println("myString is not initialized.")
                                        }
                                    }
                                }

                                fun main() {
                                    val example = Example()

                                    // Check before initialization
                                    example.checkInitialization() // Outputs: myString is not initialized.

                                    // Initialize the variable
                                    example.initialize()

                                    // Check after initialization
                                    example.checkInitialization() // Outputs: Hello, Kotlin!
                                }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                 private lateinit var mentor: Mentor

                                 if(this::mentor.isInitialized) {
                                     // access mentor
                                 } else {
                                     // do something else
                                 }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                 class Person {
                                     lateinit var name: String

                                     fun initializeName() {
                                         name = "John Doe"
                                     }

                                     fun printName() {
                                         if (::name.isInitialized) {
                                             println(name)
                                         }
                                     }
                                 }

                                 fun main() {
                                     val person = Person()
                                     person.initializeName()
                                     person.printName() // Output: John Doe
                                 }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Real-World Analogy for lateinit",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Think of lateinit as a hotel room booking system. When a guest books a room, the reservation is made, but the actual check-in happens later. The room is guaranteed to exist, but the guest hasn't occupied it yet.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "When to Use lateinit?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When you must initialize a variable before first use, but not in the constructor.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When dependency injection frameworks like Hilt or Dagger are used.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When you need late property initialization in unit tests.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How to check if a lateinit variable has been initialized or not?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        SpanText(
                            text = "You can check if the lateinit variable has been initialized or not before using it with the help of isInitialized method. This method will return true if the lateinit property has been initialized otherwise it will return false.",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                        )
                    }

                    KotlinCode(
                        code = """
                             class Person {
                                lateinit var name: String
                                fun initializeName()
                                {
                                    println(this::name.isInitialized)
                                    name = "Kamlesh" // initializing name
                                    println(this::name.isInitialized)
                                }
                             }

                             fun main(args: Array<String>) {
                                Person().initializeName()
                             }
                    """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the use of the lateinit modifier in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        SpanText(
                            text = "The lateinit modifier in Kotlin is used to declare properties that will be assigned a value later, but not at the time of declaration. It is specifically used with mutable properties of non-null types.",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "In the example, the name property is declared using the lateinit modifier. It is not assigned a value at the time of declaration but is initialized later within the initializeName() function. The printName() function checks if the name property has been initialized using the isInitialized property reference. If it is initialized, the name is printed; otherwise, a message indicating that the name is not initialized yet is printed. The lateinit modifier is useful when you need to delay the initialization of a property.",
                            modifier = Modifier.padding(bottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                        )
                    }

                    KotlinCode(
                        code = """
                            lateinit var name: String

                            fun initializeName() {
                                name = "John"
                            }

                            fun printName() {
                                if (::name.isInitialized) {
                                    println(name)
                                } else {
                                    println("Name is not initialized yet")
                                }
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is lazy?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "lazy is for val, thread-safe by default (SYNCHRONIZED), initialized on first access. Why it matters at senior level: probe whether they know lazy(LazyThreadSafetyMode.NONE) for main-thread-only objects to avoid lock overhead.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The lazy keyword is used for read-only (val) properties and evaluates the assigned value only once, when accessed for the first time. Thread-safe by default.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Think of lazy as turning on a water heater. The heater remains off until someone actually needs hot water. The moment someone turns on the hot water tap, the heater starts, but once heated, it remains available for subsequent use without restarting.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "When to Use lazy?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When a variable is expensive to compute (like database queries, API calls, or large object creations).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When you don't need the value immediately, but only when first accessed.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When ensuring thread safety in multi-threaded environments (lazy by default is thread-safe).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How Lazy works internally?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Kotlin provides three overloads for the lazy function, each creating a Lazy<T> instance with different configurations:",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ol {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "lazy(initializer: () -> T): Uses the SynchronizedLazyImpl with the default SYNCHRONIZED mode.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "lazy(mode: LazyThreadSafetyMode, initializer: () -> T): Uses the specified LazyThreadSafetyMode (SYNCHRONIZED, PUBLICATION, or NONE) to choose between different lazy implementations.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "lazy(lock: Any?, initializer: () -> T): Similar to the default SYNCHRONIZED mode, but allows specifying an explicit lock object for synchronization.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the difference between 'lateinit' and 'by lazy' in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "'lateinit' delays initialization of a non-nullable 'var', common in Android Fragments for views. 'by lazy' initializes a val' on first access, ideal for expensive objects.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Kotlin val vs by lazy list",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ol {
                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Object Episodes referenced: Object initialized",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "val all built immediately: List constructed right away",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Later accesses: Return cached list directly",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Object Episodes referenced: Object initialized (no list yet!)",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "First access triggers lazy block: List constructed on-demand",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Later accesses: Return cached list directly",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = """
                            object Languages {
                                val all = listOf(
                                    "Kotlin Multiplatform"
                                )
                            }
                            
                            object Languages {
                                val all by lazy {
                                    listOf(
                                        "Kotlin Multiplatform"
                                    )
                                }
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Types of lazy modes?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "LazyThreadSafetyMode.SYNCHRONIZED (default, ensures thread-safety).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "LazyThreadSafetyMode.PUBLICATION (allows multiple initializations but ensures only one is retained).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "LazyThreadSafetyMode.NONE (no synchronization, best for single-threaded scenarios).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the difference between lateinit and lazy initialization in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        SpanText(
                            text = "In Kotlin, both lateinit and lazy are mechanisms to defer the initialization of a variable until it is actually needed, but they are used in different contexts and have some key differences:",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                        )

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "lateinit properties must be initialized before use, whereas lazy properties are initialized lazily, upon the first access.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "lateinit can only be used with non-nullable properties, while lazy can be used with both nullable and non-nullable properties.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "lateinit initialization happens immediately when the property is accessed, while lazy initialization occurs only once, upon the first access, making it more suitable for heavy initialization operations.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "lateinit is used specifically for mutable properties (var).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The variable marked with lateinit must be of a non-nullable type, and it must be initialized before you use it.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 class MyClass {
                                     lateinit var name: String

                                     fun initialize() {
                                         name = "John"
                                     }

                                     fun printName() {
                                         println(name)
                                     }
                                 }


                                 fun main() {
                                     val obj = MyClass()
                                     obj.initialize()
                                     obj.printName() // Prints "John"
                                 }
                            """.trimIndent()
                    )

                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Interface",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )


                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "lazy is a delegate that allows for the lazy initialization of a variable. It is used to create a property whose value is calculated only upon first access, rather than when the containing object is created. This can be useful for optimizing the performance of an application, by delaying the creation of costly objects until they are needed",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "lazy is thread-safe by default, meaning that it can be safely accessed from multiple threads. However, it is important to ensure that the initialization code is itself thread-safe.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Using lazy delays the initialization of a property until it is needed, improving performance and reducing memory usage.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Once the property is initialized, its value is cached for subsequent accesses, improving performance and reducing memory usage.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "lazy properties are read-only and cannot be reassigned, preventing accidental changes to the property's value.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = """
                             val myLazyProperty: String by lazy {
                                 // This code block will be executed only upon the first access to the property
                                 "Hello Earth !!"
                             }
                        """.trimIndent()
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It is used with immutable properties (val).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The variable marked with lazy is only computed once when it is first accessed, and subsequent accesses will return the previously computed value.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                fun main() {
                                    val myString: String by lazy {
                                        println("Computing the value")
                                        "Lazy Initialization"
                                    }

                                    // The value is not computed until it is accessed for the first time
                                    println("Before accessing lazy property")
                                    println(myString) // Prints "Computing the value" and "Lazy Initialization"
                                    println("After accessing lazy property")
                                    println(myString) // Prints "Lazy Initialization" (value is not recomputed)

                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What Is Kotlin Delegation?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Delegation allows a class to forward responsibility to another object instead of implementing the logic itself.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Delegation vs Inheritance",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Inheritance may look simpler initially, but it doesn’t scale well in real Android apps. Delegation avoids deep hierarchies, keeps responsibilities explicit, and works naturally with composition and dependency injection.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = $$"""
                        //Custom Property Behavior
                        
                        import kotlin.reflect.KProperty

                        class Student {
                            // Without delegation - repetitive code!
                            /*
                            var firstName: String? = null
                                set(value) {
                                    if (value != null && value.length > 5) {
                                        field = value.trim().uppercase()
                                    }
                                }

                            var lastName: String? = null
                                set(value) {
                                    if (value != null && value.length > 5) {
                                        field = value.trim().uppercase()
                                    }
                                }
                            */

                            // With delegation - DRY principle!
                            var firstName: String? by NameDelegate()
                            var lastName: String? by NameDelegate()

                            override fun toString() = "$firstName $lastName"
                        }

                        // Custom delegate class
                        class NameDelegate {
                            private var formattedValue: String? = null

                            operator fun setValue(
                                thisRef: Any?,           // The object containing the property
                                property: KProperty<*>,  // The property being delegated
                                value: String?           // The new value
                            ) {
                                if (value != null && value.length > 5) {
                                    formattedValue = value.trim().uppercase()
                                }
                            }

                            operator fun getValue(
                                thisRef: Any?,
                                property: KProperty<*>
                            ): String? {
                                return formattedValue
                            }
                        }

                        fun main() {
                            val student = Student()
                            
                            student.firstName = "Kishor"  // Length > 5, accepted
                            student.lastName = "Ramani"   // Length > 5, accepted
                            println(student)  // Output: KISHOR RAMANI

                            student.firstName = "Kish"    // Length <= 5, rejected
                            student.lastName = "Rama"     // Length <= 5, rejected
                            println(student)  // Output: KISHOR RAMANI (unchanged)
                        }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain sealed class in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A sealed class in Kotlin is a class that can have a limited set of subclasses defined within it.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "These classes are similar to abstract classes, but they restrict the subclasses that can be crate from them.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "They offer a way to create restricted class hierarchies where all possible subclasses are known at compile time.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This means you can ensure that you’re handling all potential cases when working with instances of a sealed class, leading to more robust and type-safe code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Sealed classes are particularly useful when you want to represent a restricted type hierarchy, where all possible subclasses are known in advance and should be handled exhaustively in when expressions.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Consists of a limited number of subclasses.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Subclasses must be declared within the sealed class itself.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In the example, the `Result` class is a sealed class with three subclasses: `Success`, `Error`, and `Loading`. The `processResult` function demonstrates exhaustive handling of all possible subclasses using a when expression.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Compile-time Type Safety: Ensures type safety during compilation, not runtime.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Implicitly Abstract: Sealed class is implicitly abstract and cannot be instantiated.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Prevent Inheritance: Protects a class from being inherited.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Protected Constructors: Constructors are protected by default.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What are sealed interfaces?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Sealed interfaces in Kotlin restrict their implementation to a specific set of classes or objects within a defined scope. (Sealed interfaces are similar to sealed classes, but are used to restrict the implementation of an interface. All classes that implement the sealed interface must be defined in the same file.)",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "They create a closed hierarchy of implementing classes, where the allowed implementations are predetermined and limited to a specific set.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Sealed interfaces are often used alongside sealed classes to define a controlled set of implementation options.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 sealed interface Filterable{
                                   fun filter()
                                 }

                                 class SearchFiltering : Filterable{
                                     override fun filter() {
                                     // Implementation filtration
                                   }
                                 }

                                 class DatabaseFiltering : Filterable{
                                     override fun filter() {
                                     // Implementation filtration
                                   }
                                 }

                                 // Usage example:
                                 fun filterAll(filterables: List<Filterable>) {
                                   filterables.forEach { it.log() }
                                 }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                sealed interface Shape {
                                 data class Circle(val radius: Double) : Shape
                                 data class Rectangle(val width: Double, val height: Double) : Shape
                                 data class Triangle(val sideLength: Double) : Shape
                                }
                            """.trimIndent()
                    )

                    //https://github.com/isaac-udy/udytils.git
                    KotlinCode(
                        code = """
                            sealed interface PermissionStatus<out T : Permission> {
                                val permission: T

                                data class Granted<T : Permission>(
                                    override val permission: T
                                ) : PermissionStatus<T>

                                data class Denied<T : Permission>(
                                    override val permission: T
                                ) : PermissionStatus<T>

                                data class DeniedPermanently<T : Permission>(
                                    override val permission: T
                                ) : PermissionStatus<T>
                            }
                            
                            @Serializable
                            sealed interface Permission {
                                val name: StringResource

                                @Serializable
                                data class Location(
                                    val requirePrecise: Boolean,
                                    val requireBackground: Boolean,
                                ): Permission {
                                    override val name: StringResource get() = Res.string.permission_name_location
                                }

                                @Serializable
                                data object Camera : Permission {
                                    override val name: StringResource = Res.string.permission_name_camera
                                }

                                object Bluetooth {
                                    @Serializable
                                    data object Scan : Permission {
                                        override val name: StringResource = Res.string.permission_name_bluetoothScan
                                    }

                                    @Serializable
                                    data object Connect : Permission {
                                        override val name: StringResource = Res.string.permission_name_bluetoothConnect
                                    }
                                }

                                @Serializable
                                data object Phone : Permission {
                                    override val name: StringResource = Res.string.permission_name_phone
                                }

                                @Serializable
                                data object Notifications : Permission {
                                    override val name: StringResource = Res.string.permission_name_notifications
                                }
                            }

                            expect fun hasPermission(permission: Permission): Boolean
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What are the benefits of using sealed classes in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This improves type safety and helps prevent unexpected behavior by exhaustively covering all possible cases when working with the sealed class hierarchy.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Sealed classes represent a closed set of possible subclasses, ensuring that all potential types are handled explicitly.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why do we need sealed classes?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Sealed classes allow us to restrict the inheritance hierarchy to a predefined set of types. This gives us compile-time safety and exhaustive checking in when expressions.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ol {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It is data-oriented.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It can hold a data state.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                //ss
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the advantage of using a sealed interface in Kotlin over a normal interface?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ol {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Correct: Sealed interfaces can only be implemented in the same module and package, enabling exhaustive checks.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Sealed interfaces are automatically converted to enums.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "There is no difference between sealed and normal interfaces.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                //ss
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is a sealed class and how is it different from abstract or enum",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A sealed class restricts subclassing to a known set of types in the same file. It allows exhaustive when expressions — great for modeling states like success, error, loading.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the difference between Inline classes vs. type aliases.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "inline classes allow you to create a wrapper around a single value type without allocating additional memory for the wrapper object. Inline classes are a way to define lightweight, type-safe wrappers around existing types. They are defined with the inline modifier and have a single val property. Inline classes are optimized at compile-time and have zero runtime overhead.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                inline class Meter(val value: Double)

                                val distance: Meter = Meter(10.0)
                                println(distance.value) // Output: 10.0
                            """.trimIndent()
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Type aliases are used to provide alternative names for existing types. They do not introduce new types and are resolved at compile-time. Type aliases are helpful for creating more descriptive or readable type names.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                        fun main(){
                            val  favorites = FavouriteStrings("First", "Second", "Third")
                            for (favorite in favorites){
                                println(favorite)
                            }
                        }

                        class FavouriteStrings(val first: String, val second: String, val third: String) : Iterable<String>{
                            override fun iterator(): Iterator<String> = FavouriteStringsIterator()

                            inner class FavouriteStringsIterator : Iterator<String> {
                                private var currentIndex = 0

                                override fun hasNext() = currentIndex < 3

                                override fun next() = when(currentIndex) {
                                    0 -> first
                                    1 -> second
                                    2 -> third

                                    else -> throw  NoSuchElementException()
                                }.also { currentIndex++ }
                            }
                        }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the difference between an inner class and a nested class?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "nested class (default): Does not have access to the outer class members.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "inner class: Defined with the inner keyword and can access the outer class members.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What problem do Inline Functions solve?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "By copying the function's bytecode to the call site (Inlining), they eliminate the overhead caused by object creation for lambda expressions passed to HOFs, creating performance optimization.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How do inline functions help with reified type parameters?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Inline functions allow the use of reified type parameters, which preserve type information at runtime. This is particularly useful when working with generics, as it allows you to access the actual type passed to the function, which is normally erased at runtime.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Can you explain what a value class (inline class) is and its benefits?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A value class, previously known as an inline class, is a class that wraps a single value and is represented as that value at runtime without creating an object instance. It’s defined using the @JvmInline annotation. The benefits include improved performance by avoiding object allocation while still providing type safety and encapsulation.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Can you use the inline keyword with properties? If so, how?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Yes, you can use the inline keyword with properties, specifically with their accessors (getters and setters). This is done by placing the inline keyword before the val or var declaration. Inline properties are typically used for simple, frequently accessed properties where the getter or setter logic is straightforward.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What are delegates in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Delegates in Kotlin allow you to delegate property handling to another object using the by keyword. They provide a way to implement common patterns, such as lazy initialization (Lazy), observable properties (ObservableProperty), and more.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = $$"""
                        // Interface defining mobile actions
                        interface MobileActions {
                            fun makeCall(number: String)
                            fun sendMessage(number: String, message: String)
                        }

                        // Implementation for Samsung
                        class SamsungMobile : MobileActions {
                            override fun makeCall(number: String) {
                                println("Samsung is calling $number")
                            }
                            override fun sendMessage(number: String, message: String) {
                                println("Samsung sent a message to $number: $message")
                            }
                        }

                        // Implementation for Apple
                        class AppleMobile : MobileActions {
                            override fun makeCall(number: String) {
                                println("Apple is calling $number")
                            }
                            override fun sendMessage(number: String, message: String) {
                                println("Apple sent a message to $number: $message")
                            }
                        }
                        // ! -- Important READ the below comments -- !
                        // Delegation-based Mobile class
                        // If the parameter name and the property name are the same, Kotlin automatically assigns the parameter to the property
                        // In this case, mobileActions in the delegation part (by mobileActions) refers to the property declared by var mobileActions.
                        class Mobile(var mobileActions: MobileActions) : MobileActions by mobileActions

                        fun main() {
                            // Create a Mobile instance with SamsungMobile behavior
                            val mobile = Mobile(SamsungMobile())
                            mobile.makeCall("1234567890")
                            mobile.sendMessage("1234567890", "Hello from Samsung!")

                            // Dynamically swapping behavior to AppleMobile
                            mobile.mobileActions = AppleMobile()
                            mobile.makeCall("0987654321")
                            mobile.sendMessage("0987654321", "Hello from Apple!")
                        }

                        class GamingFeatures {
                            fun playGame(gameName: String) {
                                println("Playing $gameName")
                            }
                        }

                        class AdvancedMobile(
                            mobileActions: MobileActions,
                            private val gamingFeatures: GamingFeatures
                        ) : MobileActions by mobileActions {
                            fun playGame(gameName: String) {
                                gamingFeatures.playGame(gameName)
                            }
                        }
                        fun main() {
                            val samsung = SamsungMobile()
                            val gaming = GamingFeatures()

                            val advancedMobile = AdvancedMobile(samsung, gaming)
                            advancedMobile.makeCall("1234567890")
                            advancedMobile.playGame("PUBG")
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        interface EmailResponder {
                            fun replyToEmail(email: String)
                        }

                        // The smart assistant knows how to handle emails
                        class SmartAssistant : EmailResponder {
                            override fun replyToEmail(email: String) {
                                println("🤖 Auto-reply sent to: ${'$'}email")
                            }
                        }

                        // The lazy developer delegates the task to the assistant
                        class LazyDeveloper(private val assistant: EmailResponder) : EmailResponder by assistant {
                            fun takeABreak() {
                                println("😴 The developer is taking a nap...")
                            }
                        }

                        fun main() {
                            val assistant = SmartAssistant()
                            val lazyDev = LazyDeveloper(assistant)

                            lazyDev.takeABreak() // The developer relaxes
                            lazyDev.replyToEmail("boss@company.com") // But the assistant does all the work!
                        }

                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Delegated Properties",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "lazy – Initializes property only when first accessed.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Delegates.observable – Notifies when property changes. Executes code after the Property value changes.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Delegates.vetoable – Allows or denies property change based on a condition. Executes code before the change and can prevent the change from occurring.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "by map (Map Delegation) – Binds properties to a map (useful for JSON, configs).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = $$"""
                        /**
                         * A class representing a user with an observable 'name' property.
                         */
                        class User {
                            /**
                             * The 'name' property is observable.
                             * The lambda is called every time 'name' changes.
                             *
                             * @param initialValue The initial value of 'name'.
                             * @param handler The callback invoked on property change.
                             */
                            var name: String by Delegates.observable("<no name>") { property, oldValue, newValue ->
                                println("Property '${property.name}' changed from '$oldValue' to '$newValue'")
                            }
                        }

                        /**
                         * Main function to demonstrate observable properties.
                         */
                        fun main() {
                            val user = User()

                            // Initial value
                            println("Initial name: ${user.name}")

                            // Changing the property triggers the observer
                            user.name = "Kamlesh"
                            user.name = "Kamal"
                        }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How does delegation differ from inheritance?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Delegation allows you to compose behavior by combining multiple objects, promoting a “has-a” relationship, while inheritance creates an “is-a” relationship by extending a base class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why use nested class?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Use it when you need to create an specific functionality for a class that other classes will not use and if you don’t need to access the members of the outer class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Doesn’t have access to the outer class members.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Can be instantiated without an instance of the outer class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Used for organizing and modularizing the code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "For example : Json parse some outer class inside to other classes.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Write a code old and new value check.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    KotlinCode(
                        code = $$"""
                                import kotlin.properties.Delegates

                                class Example {
                                    var name: String by Delegates.observable("<no name>") { _, old, new ->
                                        println("$old -> $new")
                                    }
                                }

                                fun main() {
                                    val ex = Example()
                                    ex.name = "Alice"
                                    ex.name = "Bob"
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the use of the reified modifier in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The reified modifier in Kotlin, when combined with the inline modifier, allows the type information of a generic parameter to be accessible at runtime. Typically, due to type erasure, generic type information isn't available during runtime.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "By applying the reified modifier to a generic type parameter, you can access the actual type at runtime within the body of an inline function. This enables operations on the type, such as checking its properties or calling its functions.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The reified modifier is commonly used when dealing with functions that need to perform operations based on the runtime type of a generic parameter, such as reflection or type-specific behavior.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                             fun main() {
                                 println(getEnumValueNullable<Theme>("LIGHT"))
                             }

                             inline fun <reified T : Enum<T>>
                             getEnumValueNullable(name: String): T? =
                                 enumValues<T>().firstOrNull { it.name == name }

                             enum class Theme {
                             	LIGHT,
                             	DARK,
                             	SYSTEM,
                             	DEFAULT
                             }
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                 fun <T> genericData(value: T){
                                         print(value)
                                         print("Type of T: comment to add here") //T::class.java
                                     }

                                 //Error T as reified Type parameter
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                 inline fun <reified T> getTypeName(): String {
                                     return T::class.simpleName ?: "Unknown"
                                 }

                                 val typeName = getTypeName<Int>()
                                 println(typeName) // Prints "Int"
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                            inline fun <reified T> getTypeCount(arrayList: ArrayList<Any>): Int {
                                var count = 0

                                for (item in arrayList) {
                                    if (T::class.isInstance(item))
                                        count++
                                }
                                return count
                            }

                            fun main() {
                                val arrayList = arrayListOf<Any>("Flutter", 56, "KMM")
                                val count = getTypeCount<String>(arrayList)
                                print(count)
                            }
                        """.trimIndent()
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In this example, the getTypeName function uses the reified modifier on the generic type parameter T. Within the function, T::class is employed to access the runtime class object of T. Then, the simpleName property is used to retrieve the name of the type as a string.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The reified modifier is a powerful feature in Kotlin, enabling more advanced operations based on the runtime type of generic parameters. It's especially useful for scenarios requiring runtime type information within inline functions.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How the reified Keyword Works Internally?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Compilation Phase",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The inline function with a reified type parameter doesn't just create a function signature in the bytecode. Instead, the Kotlin compiler replaces the function call with the actual code of the function.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The type T is no longer a placeholder at this point—it’s replaced with the actual type used in the call to the function.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This means that inside the function, you can access T::class, which is normally impossible due to type erasure.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Bytecode Generation",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "When you call an inline function with reified inside a specific type context (e.g., T is String), the Kotlin compiler inserts the type information directly into the bytecode for that specific call.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This allows things like T::class to work because the type T is now concretely known at runtime.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            KotlinCode(
                                code = """
                                inline fun <reified T> printType(value: T) {
                                    println(T::class)
                                }

                                fun main() {
                                    printType("Hello, World!")  // Prints class kotlin.String
                                }
                            """.trimIndent()
                            )

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "In the bytecode generated, the T::class call inside printType is actually compiled into String::class because T is replaced with String at the invocation place.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Limitations of reified",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Only in Inline Functions",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The reified keyword only works in inline functions. This is because the type information needs to be inserted directly into the calling code during compilation. Without inlining, the type information would be erased, making it impossible to access at runtime.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The Role of ::class",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The T::class syntax (which accesses the KClass object for a class type) is one of the most common use cases of reified. When you use reified T, T::class can be used to access the class object for the actual type T passed at runtime.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This would normally not be possible in non-inline generic functions due to type erasure.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Example Use Cases",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Type Checks",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You can check the actual type of a generic parameter in a function, which is impossible in standard generics.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Casting",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You can use reified to safely cast objects when the type information is preserved.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Behind the Scenes in the JVM",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "When the Kotlin compiler compiles a reified function, it actually generates specialized code for every concrete type used. For instance, calling printType<String>(...) and printType<Int>(...) results in two separate copies of the function in the compiled bytecode.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Each of these copies is optimized to use the concrete type (String or Int) in place of the type parameter T.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How Do You Handle Multithreading in Java?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Java, multithreading is handled using either the Thread class or implementing the Runnable interface. You can create multiple threads and run them concurrently, but Java threads can be expensive in terms of memory.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                    class MyTask implements Runnable {
                        public void run() {
                            System.out.println("Task is running");
                        }
                    }

                    Thread thread = new Thread(new MyTask());
                    thread.start();
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "String, StringBuffer and StringBuilder.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "String is immutable whereas StringBuffer and StringBuilder are mutable. Hence, if the content is fixed and wouldn’t change frequently then we should use String. String is more memory-efficient than other two classes if content doesn’t change frequently.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "StringBuffer is mutable, synchronized, thread safe and less efficient.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "StringBuilder is mutable sequence of characters that allows us to append, insert, replace, and delete text efficiently — without creating new objects every time. but not synchronized by default, not thread safe and more effiecient. ",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "String: Creates new objects, less efficient for frequent modifications.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "StringBuffer: More efficient for frequent modifications, modifies in-place.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "String: Use for immutable strings and when modifications are infrequent.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "StringBuffer: Use for mutable strings with frequent modifications or in multithreaded environments where synchronization is needed. StringBuilder is mutable but not synchronized by default, not thread safe and more efficient.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Iterator",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An Iterator is an object that allows us to traverse elements one at a time. Instead of exposing the internal structure of a collection, Kotlin provides an iterator.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                fun main() {
                                    val numbers = listOf(1,2,3,4,5)
                                    val iterator = numbers.iterator()

                                    while(iterator.hasNext()){
                                        println(iterator.next())
                                    }
                                } 
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Sequence",
                        modifier = Modifier.fontSize(FontSize.Large).fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A lazily evaluated collection-processing abstraction useful when chaining operations over potentially large datasets.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A Sequence in Kotlin is a lazily evaluated collection of elements. It allows for more efficient processing of large datasets by computing elements on-demand.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                // Creating sequence
                                val sequence = sequenceOf(1, 2, 3, 4, 5)

                                // Transforming elements using map
                                val squaredSequence = sequence.map { it * it }

                                // Accessing elements after transformation
                                println("Squared sequence:")
                                println(squaredSequence.toList())

                                // Output
                                Squared sequence: [1, 4, 9, 16, 25]
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = $$"""
                              fun main() {
                                  val result = (1..1_000_000)
                                      .asSequence()
                                      .filter { it % 2 == 0 }
                                      .map { it * 2 }
                                      .take(5)
                                      .toList()

                                  println(result)
                              }
                              
                              //Lazy Evaluation
                              fun main() {
                                  val result = listOf(
                                      1, 2, 3, 4, 5
                                  )
                                  .asSequence()
                                  .filter {
                                    println("Filter $it")
                                    it % 2 == 0
                                  }
                                  .map {
                                    println("Map $it")
                                    it * 10
                                  }.toList()

                              } 
                              
                              //Fibonacci Sequence
                              fun main() {
                                  val fibonacci = generateSequence(
                                      Pair(0,1)
                                  ) {
                                      Pair(it.second,it.first+it.second)
                                  }

                                  println(
                                      fibonacci
                                          .map { it.first }
                                          .take(10)
                                          .toList()
                                  )
                              } 
                        """.trimIndent()
                    )


                    KotlinCode(
                        code = $$"""
                            //Custom Sequence Operators
                            internal class OddPositionIterator<T>(source: Sequence<T>) : AbstractIterator<T>() {
                                private var index = 0
                                private val iterator = source.iterator()

                                override fun computeNext() {
                                    while (iterator.hasNext()) {
                                        index++

                                        val next = iterator.next()

                                        if (isEligible()) {
                                            setNext(next)
                                            return
                                        }
                                    }
                                    done()
                                }

                                private fun isEligible() = index % 2 != 0
                            }

                            fun <T> Sequence<T>.takeOddPositions() = OddSequence(this)

                            fun main() {
                                (1..100).asSequence()
                                    .takeOddPositions()
                                    .onEach { println("Filtered element: $it") }
                                    .toList()
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "When Should You Use Sequence?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Processing large datasets",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Chaining multiple operations (filter, map, flatMap)",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Reading files line by line",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Streaming data",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Working with APIs",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Parsing logs",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Generating infinite values",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {

                    SpanText(
                        text = "Can a Sequence be mutable in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "No, sequences are inherently immutable in Kotlin, but you can apply sequence operations to mutable collections.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "runCatching",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This is the Kotlin way of error handling where the runCatching context returns a Result class, similar to that in Rust, represents either the success or failure of an operation.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "if you use runCatching and your coroutine is cancelled for some reason, like timeout, or viewmodelscope is cleaned, or some manual exception occurs, the cancellation is swallowed inside runCatching. So the coroutine does not cancel properly; it keeps on running or finishes silently. This breaks structured concurrency and can cause leaks or unexpected behaviour.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This is a variation of run. runCatching is literally try…catch block but with important difference.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It encapsulates the result of the block execution into a Result object. Result type, which is a union between a Success type and a Failure type. Its purpose is to encapsulate the result of an action, whether successful or not, allowing it to be processed at a later time.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This encapsulation not only makes the code more readable but also facilitates safe data retrieval.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An added advantage is that results of runCatching blocks exectution can be compared.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "run and runCatching are synchronous, and runBlocking and runInterruptible as asynchronous.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                             private fun String.jwtStringClaim(name: String): String? {
                                 val payload = split(".").getOrNull(1) ?: return null
                                 val decoded = runCatching { base64UrlDecode(payload).decodeToString() }.getOrNull() ?: return null
                                 val claims = runCatching { Json.parseToJsonElement(decoded).jsonObject }.getOrNull() ?: return null
                                 return claims[name]?.jsonPrimitive?.contentOrNull
                             }

                             private fun base64UrlDecode(input: String): ByteArray {
                                 val alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
                                 val clean = input.trimEnd('=')
                                 val output = mutableListOf<Byte>()
                                 var buffer = 0
                                 var bits = 0
                                 for (char in clean) {
                                     val value = alphabet.indexOf(char)
                                     if (value < 0) continue
                                     buffer = (buffer shl 6) or value
                                     bits += 6
                                     if (bits >= 8) {
                                         bits -= 8
                                         output.add(((buffer shr bits) and 0xff).toByte())
                                     }
                                 }
                                 return output.toByteArray()
                             }
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                @Throws
                                fun Calculate() {
                                    throw ArithmeticException()
                                }

                                fun main() {
                                    try {
                                        Calculate()
                                    } catch(e: Exception) {
                                        println(e)
                                    }
                                }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                fun main() {
                                    runCatching {
                                        Calculate()
                                    }.onFailure {
                                        println(it)
                                    }
                                }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                fun main() {
                                    val result = runCatching {
                                        Calculate()
                                    }
                                    result.onFailure {
                                        println(it)
                                    }
                                }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                fun Calculate(number: Int):Result<Int> {
                                  return if (number == 0) {
                                        Result.failure(ArithmeticException())
                                    } else {
                                        Result.success(number)
                                    }
                                }


                                fun main() {
                                    val number = Calculate(0)
                                    number.fold(
                                        onSuccess = {
                                            println(number)
                                        },
                                        onFailure = {
                                            println(it)
                                        }
                                    )
                                }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                suspend fun createUser(signUpUser: SignUpUser): Boolean {
                                return runCatching {
                                    val user = hashMapOf(
                                    "name" to signUpUser.name,
                                    "email" to signUpUser.email)
                                        firestore.collection(USER_COLLECTION).add(user).await()
                                    }.isSuccess
                                }
                            """.trimIndent()
                    )
                }

                KotlinCode(
                    code = """
                        fun String?.toShortTimeFromIso(): String {
                            if (this.isNullOrBlank()) return ""

                            val pattern = DateTimeFormatter.ofPattern("HH:mm")

                            return runCatching {
                                pattern.withZone(ZoneId.systemDefault()).format(Instant.parse(this))
                            }.recoverCatching {
                                LocalDateTime.parse(this).format(pattern)
                            }.getOrDefault("")
                        }
                    """.trimIndent()
                )

                //https://www.myandroidsolutions.com/2026/03/02/kotlin-runcatching-result-functional-error-handling/
                KotlinCode(
                    code = """
                       val user: Result = runCatching { fetchUserFromNetwork(userId) }
                           .recover { exception ->
                               when (exception) {
                                   is IOException -> User.anonymous()      // network error — return anonymous
                                   is CancellationException -> throw exception // always rethrow cancellation!
                                   else -> throw exception                 // unknown error — let it propagate
                               }
                           }

                       //recoverCatching wraps exceptions thrown inside the recover block
                       val user2: Result = runCatching { fetchUserFromNetwork(userId) }
                           .recoverCatching { _ -> fetchUserFromCache(userId) }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What are Callback Functions?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin programming, a callback function is a function that is passed as an argument to another function.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The receiving function then invokes the callback function at an appropriate time during its execution.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This enables the receiving function to execute the callback function asynchronously, providing a way for the caller to handle the result of the function execution.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Ul {
                        SpanText(
                            text = "Use",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                        )

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Callback functions are also commonly used for event handling. An event is an occurrence in a program that is triggered by some external action, such as user input or a timer. Callback functions can be used to handle these events, allowing the program to respond to user input or other external stimuli in real-time.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the purpose of the ‘open’ keyword in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The ‘open’ keyword in Kotlin allows classes, methods, and variables to be extended or overridden.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain tailrec keyword in Kotiln.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Kotlin’s tailrec keyword is a powerful tool that allows developers to optimize tail-recursive functions. When a function is annotated with tailrec, it signals the Kotlin compiler to convert the recursion into an iterative loop, reducing the risk of stack overflow and improving performance.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Ul {
                        SpanText(
                            text = "Work",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, a function is tail-recursive if the recursive call is the last operation in the function. The tailrec modifier informs the compiler that the function adheres to this structure and can be optimized.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "By using tailrec, Kotlin ensures that the recursive call is transformed into an iterative loop, preventing stack overflow for large input values and improving the function’s efficiency.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Incorporating tailrec is a simple yet effective way to make your recursive functions more performant and stack-safe in Kotlin.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                //without tailrec
                                fun factorial(n: Int): Int{
                                    return if(n == 0 )1 else n * factorial(n- 1)
                                }

                                //with tailrec
                                tailrec fun factorialTailRec(n: Int, result: Int = 1) : Int {
                                    return if(n == 0) result else factorialTailRec(n-1, n * result)
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain @tailrec Annotation",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The @tailrec annotation ensures that the function is optimized for tail recursion. If the function is not tail-recursive, the compiler will throw an error. If you accidentally introduce non-tail-recursive logic, the compiler will notify you.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                @tailrec
                                fun factTail(num: Int, acc: Int = 1): Long {
                                    return if (num == 1) acc.toLong() else factTail(num - 1, acc * num)
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {

                    SpanText(
                        text = "How is class extensibility achieved in Java compared to Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Java, classes are not final by default, allowing extension without a specific keyword, while in Kotlin, the ‘open’ keyword is used for this purpose.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Can you have an open class with a final method in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "No, an open class in Kotlin implies that it is extensible, so all methods are open by default. You cannot have a final method in an open class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What happens if you try to inherit from a class without the ‘open’ keyword in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It results in a compilation error since classes are final by default in Kotlin.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How does the ‘open’ keyword contribute to code maintainability in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It enables a more flexible and extensible codebase, allowing developers to extend existing classes rather than modifying them directly.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "open class and final class in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "By default, classes are final in Kotlin, preventing inheritance.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Not allowed to inherit or create a subclass from a final class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "To enable inheritance, the class must be explicitly declared as open.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Once the class is marked as open, subclassing becomes possible.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "In Java, what is the default behavior for class extensibility?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Classes in Java are not final by default, allowing them to be extended without any specific keyword.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain object keyword in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, the object keyword is used to define a singleton object. They don’t have any constructors, can hold data, and can inherit from classes.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A singleton object is a class that can only have one instance, meaning it restricts instantiation to a single object.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This is particularly useful when we need a class to have exactly one instance throughout the application.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "So when we only need to define a special instance of a class with some preset configuration, we inherit from that class and create an object instead of creating another subclass explicitly.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Also, creating another subclass means we may create multiple instances out of that subclass and that’s not always necessary.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Objects are great but they don’t pretty print their names. Print memory of address.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 object Singleton {
                                     // properties and methods of the singleton object
                                 }
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                object Test {
                                    private var a: Int = 0
                                    var b: Int = 1

                                    fun makeMe12(): Int {
                                        a = 12
                                        return a
                                    }
                                }

                                fun main(args: Array<String>) {
                                    val result: Int

                                    result = Test.makeMe12()

                                    println(Test.b)
                                    println("result = $\result")
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Can we make a class singleton without Object?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Yes we can make custom singleton class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When creating a singleton class in Kotlin using regular classes (without `object`), you need to ensure thread safety manually, especially in multi-threaded environments.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If multiple threads try to access the singleton at the same time, there’s a risk of creating multiple instances, unless you handle it with proper synchronization.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "so here You can make a singleton thread-safe by using synchronized blocks or lazy initialization.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                            class Singleton private constructor() {
                                companion object {
                                    @Volatile
                                    private var INSTANCE: Singleton? = null

                                    fun getInstance(): Singleton {
                                        return INSTANCE ?: synchronized(this) {
                                            val instance = Singleton()
                                            INSTANCE = instance
                                            instance
                                        }
                                    }
                                }
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain data object in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A data object is identical to a regular object but provides a default implementation of the toString() function that will print its name, removing the need to override it manually, and aligning behavior with a data class definition. They are especially useful for sealed class hierarchies to match behavior with data classes.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Data objects are currently an experimental feature, so to try them out, we have to tell the compiler to use version Kotlin 1.9",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 sealed interface ProfileScreenState {
                                    data class Success(val username: String) : ProfileScreenState
                                    data object Error : ProfileScreenState
                                    data object Loading : ProfileScreenState
                                 }
                            """.trimIndent()
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If we print them now, we can see that their string representation now looks similar to a data class and only the object name is printed. Loading, Success(username=exampleUser1), Error",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is a companion object in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If we have to write a function without having an instance of a class, then we can use the feature of the companion object in Kotlin. We can write it like a member of a companion object inside a class. For example, logging methods or constant values.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Companion Object in Kotlin is a way to access the class members using class names only. There is no requirement for an instance of the class in this scenario.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, if you want to write a function or any member of the class that can be called without having the instance of the class then you can write the same as a member of a companion object inside the class. So, by declaring the companion object, you can access the members of the class by class name only(which is without explicitly creating the instance of the class).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A companion object is an object that is associated with a class, rather than an instance of the class. It can be used to define static methods and properties for the class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Companion objects are initialized the first time the containing class is loaded — even if the companion object is not used. As a result, companion objects are not lazy.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "For example, the following code defines a companion object for the MyClass class, with a static method “myStaticMethod”.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                class MyClass {
                                    companion object {
                                        fun myStaticMethod() {
                                            /* code */ 
                                        }
                                    }
                                }
                            """.trimIndent()
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Companion objects are accessed using the class name instead of object names.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If the companion object name is missing, the default name Companion is assigned to it.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "There can only be one companion object in a class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A companion object is initialized when the class is loaded.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If we try to access class level fields using objects or objects fields using the class name, an error will be thrown.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "When to Use a Companion Object?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When you need to create factory methods (functions that create instances of a class).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When you want constants or shared methods inside a class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When you want to group related utilities within a class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How does the companion object work in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Defined inside a class, acts like a static member. There can be only one companion object per class. Ideal for static-like logic: factory methods, constants, and class-wide functions. Companion object members can be accessed via the class name. A companion object is a singleton object that is associated with a class. It can be used to store static variables and methods or to provide a singleton instance of the class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the difference between an object (Declaration) and a companion object?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "object (Declaration): A class that only has a single Singleton instance throughout the program.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "companion object: An object defined within a class whose members are accessible through the class name (similar to Java's static fields).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What does @Keep companion object mean in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "@Keep annotation prevents a class, object, or function from being removed by proguard. This is useful if a particular piece of your code is necessary for debugging or analysis, or if it would cause unexpected behavior if removed by proguard.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A companion object is an object that contains the static members of a class. These members can be accessed before any instances of the class are created.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When @Keep and companion object are used together, it ensures that the static members are not removed by proguard. This is useful if you need to access the static members from other classes, or if the static members are necessary for debugging or analysis.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        KotlinCode(
                            code = """
                                    @Keep
                                    companion object MyCompanion {
                                        val myStaticVariable = "Hello World!"

                                        fun myStaticFunction() {
                                            println(myStaticVariable)
                                        }
                                    }
                                """.trimIndent()
                        )

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "MyCompanion object is marked with the @Keep annotation. This means that it will not be removed by proguard. The myStaticVariable and myStaticFunction members are also static members of the MyCompanion object. These members can be accessed before an instance of the MyCompanion object is created.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "What do you understand about companion objects in the context of Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It permits you to characterize techniques and properties that are related to the actual class as opposed to the cases of the class. Allowing us to define static members and methods similar to those in Java. A companion object can only be defined within classes.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The companion object is a singleton, meaning there is only one instance of it, and it is created when the class is loaded, meaning it is created even if we haven’t accessed the companion object.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Can a companion object implement an interface?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Yes, a companion object can implement an interface. This is useful when you want to enforce specific behavior or functionality in a companion object.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = $$"""
                            interface Logger {
                                fun log(message: String)
                            }

                            class MyClass {
                                companion object : Logger {
                                    override fun log(message: String) {
                                        println("Log: $message")
                                    }
                                }
                            }

                            fun main() {
                                MyClass.log("This is a log message.")
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Can a companion object have a name?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Yes, you can name a companion object. By default, the name is \"Companion\", but you can give it a custom name.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = $$"""
                            class MyClass {
                                companion object Factory {
                                    fun create(): MyClass = MyClass()
                                }
                            }

                            fun main() {
                                val obj = MyClass.Factory.create()
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Can you access the private members of a class from a companion object?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Yes, a companion object has access to all members of the class, including private members.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = $$"""
                            class MyClass(private val secret: String) {
                                companion object {
                                    fun revealSecret(instance: MyClass) = instance.secret
                                }
                            }

                            fun main() {
                                val myClass = MyClass("Hidden Message")
                                println(MyClass.revealSecret(myClass)) // Output: Hidden Message
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Can you have multiple companion objects in a single class?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "No, a class can only have **one companion object**. However, you can include multiple functions and properties inside the single companion object.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "What is the difference between a companion object and an object declaration?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Companion Object: Belongs to a class, and you can access its members using the class name.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Object Declaration: A standalone singleton that can be accessed globally throughout the app.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "ViewModelProvider.Factory ",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "ViewModelProvider.Factory was a workaround for the lack of constructor injection in the ViewModel API. Every modern approach eliminates it.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Utility Methods: Holding shared functionality like date formatting, logging, or network utilities.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Constants: Storing global constants that can be accessed throughout the app.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "What are the use cases of a companion object in Android development?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Factory Methods: Creating objects without needing an instance of a class, for example, ViewModelProvider.Factory to instantiate view models.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Utility Methods: Holding shared functionality like date formatting, logging, or network utilities.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Constants: Storing global constants that can be accessed throughout the app.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the difference between a HashSet and a TreeSet in Java?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A HashSet is an unordered set of unique elements, implemented using a hash table.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A TreeSet, on the other hand, is an ordered set of unique elements, implemented using a red-black tree. The elements in a TreeSet are stored in sorted order.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "listOf(), arrayListOf, mutableListOf in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Immutable: You cannot modify the list after creation.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Use-case: When you have a fixed set of elements that won’t change.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Semi-mutable: The array’s size is fixed, but you can modify its elements.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Use-case: When you need a fixed-size collection with modifiable elements.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Fully Mutable: Both allow adding, removing, and updating elements.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Use-case: When your collection’s size and elements need to be flexible.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the concept of function composition in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Function composition in Kotlin involves merging several functions to generate a new function capable of executing a sequence of transformations or computations.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This technique permits the linkage of functions, wherein the output of one function serves as the input for the subsequent one.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Function composition fosters modularity, reusability, and code clarity by decomposing intricate operations into smaller, reusable functions.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 fun addFirst(value: Int): Int {
                                     return value + 1
                                 }

                                 fun doubleValue(value: Int): Int {
                                     return value * 2
                                 }

                                 val composedFunction: (Int) -> Int = ::addFirst andThen ::doubleValue

                                 fun main() {
                                     val result = composedFunction(5)
                                     println(result) // Output: 12 (5 + 1 = 6, 6 * 2 = 12)
                                 }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "requireNotNull and require",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If you cannot reduce the nullability and the value must be present, you might think it’s a good idea to use !! , but in Kotlin, you should use requireNotNull.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It throws an IllegalArgumentException if the value is null; otherwise, it returns the non-null value. This function is commonly employed to guarantee that a required value is not null and to furnish informative error messages in the event of encountering null values.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                            fun addItemToCart(item: Item) {
                                require(item.price > 0) { "Price must be positive" }
                                println(item.price) //Item added to cart with price
                            }
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                            fun checkout(cart: Cart?) {
                                requireNotNull(cart) { "Shopping cart cannot be null" }
                                println(cart) //Proceeding to checkout with items
                            }
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                            val name: String? = null
                            val length = requireNotNull(name) { "Name cannot be null" }.length
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                fun printName(name: String?) {
                                    val nonNullName = requireNotNull(name) { "Name must not be null" }
                                    println("Name: $\nonNullName")
                                }

                                fun main() {
                                    printName("John") // Output: Name: John
                                    printName(null) // Throws IllegalArgumentException with the specified error message
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "check and checkNotNull",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "While require is typically used for validating function arguments, check is used for validating internal conditions within your code. If a condition fails, check throws an IllegalStateException, indicating that something has gone wrong within the program’s logic.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        KotlinCode(
                            code = """
                                 fun processPayment(cart: Cart) {
                                     check(cart.cartSize > 0) { "Cart is empty" }
                                     println(cart.cartSize") //Processing payment for items
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                fun finalizeOrder(cart: Cart) {
                                    val shipping = checkNotNull(cart.shippingMethod) { "Shipping method must be selected before finalizing the order" }
                                }
                            """.trimIndent()
                        )
                    }
                }

                //https://medium.com/@elenavanengelen
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "error",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The error() function can be used for signalling critical conditions where proceeding with execution does not make sense or would be harmful. It is especially useful in scenarios where a program flow reaches an invalid state. Consider a scenario where you are handling different payment methods in an online store. You expect either “CreditCard” or “PayPal”, but in case of an unsupported payment method, you want to halt execution. The error function can help you halt execution in cases where proceeding would result in invalid behaviour.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        KotlinCode(
                            code = """
                                 fun processPaymentMethod(paymentMethod: String) {
                                     when (paymentMethod) {
                                         "CreditCard" -> println("Processing payment with Credit Card")
                                         "PayPal" -> println("Processing payment with PayPal")
                                         else -> error(paymentMethod) //Unsupported payment method
                                     }
                                 }
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How to use synchronized in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "To use synchronized in Kotlin, you can apply it to a block of code using the synchronized keyword followed by the object you want to synchronize on. The synchronized block ensures that only one thread can access the block at a time, providing thread-safety for the shared resource.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In this example, the Counter class maintains a private count variable. The increment() and getCount() methods are synchronized using the synchronized keyword followed by the this reference, which refers to the instance of the Counter class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Two threads are created that concurrently increment the counter using the increment() method. By applying synchronization to the critical sections of the code, we ensure that only one thread can access the block at a time, preventing race conditions and maintaining the correctness of the count.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {

                    SpanText(
                        text = "How do you handle concurrency in Kotlin using synchronized blocks?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Concurrency in Kotlin can be managed using synchronized blocks. The synchronized keyword in Kotlin guarantees that only one thread can access a synchronized block of code at a time, thus preventing concurrent modification or access to shared resources.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                import kotlin.concurrent.thread

                                fun main() {
                                    val sharedResource = SharedResource()

                                    val thread1 = thread {
                                        sharedResource.modifySharedResource("Thread 1")
                                    }

                                    val thread2 = thread {
                                        sharedResource.modifySharedResource("Thread 2")
                                    }

                                    thread1.join()
                                    thread2.join()

                                    println("Final value of shared resource:")
                                    println(sharedResource.value)
                                }

                                class SharedResource {
                                    var value = 0

                                    fun modifySharedResource(threadName: String) {
                                        synchronized(this) {
                                            for (i in 1..5) {
                                                println("$\threadName is modifying shared resource")
                                                value++
                                                Thread.sleep(100) // Simulate some computation
                                            }
                                        }
                                    }
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain Kotlin Type-Safe Builders.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Type-Safe Builders in Kotlin harness the language’s expressive syntax by employing extension functions and lambda expressions to craft Domain-Specific Languages (DSLs). These builders enforce compile-time safety, empowering developers to design DSLs that are both succinct and guarantee correctness and readability.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What are extension functions in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Extension functions in Kotlin allow you to add new functionality to existing classes without modifying their source code. You can define these functions outside the class and call them as if theywere part of the class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How do extension functions work under the hood?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Extension functions are resolved statically at compile time. They don’t actually modify the class; instead, they are compiled as static methods with the receiver type as the first parameter. This means that extension functions don’t have access to private or protected members of the class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "To extend a class or implement an interface in Kotlin, we use a single colon (“:”) rather than the Java extends keyword. We can then create an instance of type Programmer and call methods on it, either in the class, it belongs to or in the base class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The purpose of the extension function is to add a new function to the existing class so it simply adds a particular function to a predefined class without declaring it inside the class and the new functions actually behave just like the static functions.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Can you define an extension function for a nullable receiver?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Yes, you can define extension functions for nullable receivers, allowing you to handle cases where the object might be null. You can also use this in the function, which refers to the receiver object, and check if it's null.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                            fun String?.isNullOrEmpty(): Boolean {
                                return this == null || this.isEmpty()
                            }

                            println(null.isNullOrEmpty)
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Can extension functions override member functions in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "No, extension functions cannot override member functions. If a class already has a member function with the same name as an extension function, the member function will take precedence when called.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What are the limitations of extension functions?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Extension functions cannot access the private or protected members of the class they extend. Additionally, they cannot override existing member functions or properties in the class. They are resolved statically, not dynamically, so the type of the object at runtime doesn’t influence which extension function gets called.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How do extension functions interact with companion objects in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "You can define extension functions on a class's companion object, allowing you to add functionality directly to the companion object, similar to how you would for a class instance.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How can extension functions add functionality to existing classes? (Explain the concept of extension functions in Kotlin.)",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Extension functions in Kotlin offer the ability to add new functions to existing classes without altering their source code. They provide a means to extend the capabilities of a class without resorting to inheritance or modifying the original class directly.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                  fun String.addExclamation(): String {
                                      return "$this!"
                                  }

                                  val message = "Hello"
                                  val modifiedMessage = message.addExclamation() // Using an extension function

                                  println(modifiedMessage) // Output: Hello!
                            """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                                 fun String.isPalindrome(): Boolean {
                                     val cleanString = this.replace("\\W".toRegex(), "").toLowerCase()
                                     return cleanString == cleanString.reversed()
                                 }

                                 fun main() {
                                     val palindromeString = "A man, a plan, a canal, Panama"
                                     println(palindromeString.isPalindrome()) // Output: true

                                     val nonPalindromeString = "Hello, World!"
                                     println(nonPalindromeString.isPalindrome()) // Output: false
                                 }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the concept of object expressions in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Object expressions in Kotlin enable the creation of anonymous objects with customized behavior and properties. They are particularly useful when you need to create a one-time object without explicitly declaring a new named class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Similar to anonymous inner classes in Java, object expressions in Kotlin provide a more concise syntax and support for functional programming features.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                interface OnClickListener {
                                    fun onClick()
                                }

                                fun setOnClickListener(listener: OnClickListener) {
                                    // Implementation
                                }

                                fun main() {
                                    setOnClickListener(object : OnClickListener {
                                        override fun onClick() {
                                            println("Button clicked")
                                        }
                                    })
                                }
                            """.trimIndent()
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In this example, we define an interface OnClickListener with a single method onClick(). The setOnClickListener function expects an instance of this interface. Utilizing an object expression, we create an anonymous object that implements the OnClickListener interface and provides the implementation for the onClick() method.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Object expressions allow us to create one-time objects on the fly, enhancing code conciseness and expressiveness. They’re particularly handy for scenarios where a temporary object with specific behavior is required.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is a closure in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A closure in programming refers to a function that retains access to variables and parameters from its enclosing scope, even after that scope has finished execution.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It captures the necessary variables, stores them, and can access them later when the function is invoked. The captured variables maintain their state, and any modifications made to them within the closure are preserved.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 fun createIncrementFunction(incrementBy: Int): () -> Int {
                                     var count = 0

                                     return {
                                         count += incrementBy
                                         count
                                     }
                                 }

                                 fun main() {
                                     val incrementByTwo = createIncrementFunction(2)
                                     println(incrementByTwo()) // Output: 2
                                     println(incrementByTwo()) // Output: 4
                                 }
                            """.trimIndent()
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In this example, createIncrementFunction returns a lambda function that increments count by the specified incrementBy value each time it's invoked. The variable count is captured by the lambda and retains its state between invocations. Thus, each time incrementByTwo() is called, it increments count by 2 and returns the updated value. This demonstrates the concept of closures, where the lambda retains access to the count variable from its surrounding scope.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain joinToString in kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    KotlinCode(
                        code = """
                             val joinedString = listOf("kotlin", "dart", "js", "Java").joinToString(",")
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How does Hashmap work?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A HashMap in Java is an implementation of the Map interface that allows storing data in key-value pairs. HashMap operates on the principle of hashing, which means that data is stored in an array and accessed by computing the hash value for the key.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In the case of HashMap, calculating the hash value is used to determine the index of the array under which the data should be stored. This makes access to data in HashMap very fast, as to find the data, you only need to calculate their hash and find them under the appropriate index in the array.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "To add a new element to HashMap, you should call the put method, which takes two arguments — the key and the value. To retrieve the value for a given key, you should call the get method, which takes the key as an argument and returns the value that has been assigned to that key.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "HashMap is widely used in applications because it provides fast data access and is easy to use. However, it should be remembered that HashMap does not guarantee the order of elements, so if it is necessary to maintain the order of adding elements, you should use a different implementation of the Map interface, for example LinkedHashMap.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the difference between FlatMap and Map in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "FlatMap is used to combine all the items of lists into one list.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Map is used to transform a list based on certain conditions.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "HashMap vs HashTable",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Both HashMap and HashTable are data structures used to store key-value pairs.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "HashMap is not synchronized and allows null keys and values. It is generally preferred over HashTable in non-threaded environments.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "HashTable is synchronized and does not allow null keys or values. It is thread-safe but has a performance overhead.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Queue",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A Queue is a collection interface in Kotlin that represents a data structure that stores elements in a linear order, and follows the First In, First Out (FIFO) principle. This means that the first element added to the queue will be the first one to be removed.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Collection is the collections class that is used to implement the queue. Some possible implementations include a LinkedList, ArrayDeque, and PriorityQueue.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Deque",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The Deque interface represents a double-ended queue data structure, where it is possible to insert and remove elements from both the front and the back of the queue. This allows for the Last-In-First-Out (LIFO) operation of a stack and the First-In-First-Out (FIFO) operation of a traditional queue. The Deque interface extends the Queue interface and, therefore, inherits all the methods from the Queue interface, while also providing additional methods for insertion and removal at both ends of the queue. Classes that extend Deque include LinkedList, ArrayDeque, and ConcurrentLinkedDeque.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Is Kotlin’s ArrayDeque just a wrapper for Java’s?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "No. Kotlin provides its own implementation in kotlin.collections. This makes it Kotlin Multiplatform (KMP) compatible, allowing you to share code across Android, iOS, and Web.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If you are constantly accessing elements by index (e.g., list[400]), ArrayList is still the champion.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How and when to use the finally block while handling exceptions in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "finally block is an optional block while handling exceptions. It executes every time regardless of whether an exception is caught or not. If there’s a code you want to execute regardless of whether an exception is caught or not, you can either include it in both try and catch blocks, or you can include it once within the finally block.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 class Student(val name: String) {
                                     init {
                                         println("init block fired")
                                     }
                                 }

                                 fun main() {
                                     Student("Kamlesh")
                                 }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is an init block in Kotlin and when to use it?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Init blocks are present within a class and they are optional. They are executed right after the primary constructor.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "You cannot add code to the primary constructor body while declaring a class in Kotlin. The init block gets executed immediately after the primary constructor. The init block executed before the secondary constructor. If there’s a code that needs to be executed right after the primary constructor, it goes within the init block.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "There can be multiple init blocks in a class and they’re all executed in the order they’re declared.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If there are multiple constructors and an init block in a class, the primary constructor gets executed first, followed by init blocks, and secondary constructors are executed last.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Primary constructor parameters can be used in the initializer blocks. It does not take any parameters.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is enum class in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Enum class has a finite set of instances who have their own properties and methods.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Imagine you have a special box called “Enum class”. This box can hold a limited number of special items, and each item inside has its own unique features and actions.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Now, let’s think about your favorite food places like Dominos, KFC, Burger King, Starbucks etc. and we want to make sure the menu of food items stays same. That’s where the Enum class comes in. It will help to create the list of food items that won’t change or remain constant.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                            enum class FileAck(val code: Byte) {
                                OK(0),
                                CRC_MISMATCH(1),
                                CANCELLED(2);

                                companion object {
                                    fun fromCode(c: Byte): FileAck =
                                        entries.firstOrNull { it.code == c } ?: CANCELLED
                                }
                            }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Enum.values() VS Enum.entries",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Enum.values() creates separate array every time it called. So its no memory efficient.",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Enum.entries just pull the cached array. Doesn't create new array",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Nested functions in Kotlin.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Nestled within the elegant realm of Kotlin programming lies a feature that often remains hidden in plain sight, yet possesses remarkable potential nested functions.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "These compact powerhouses bring a new dimension to structuring your code, enhancing readability, modularity, and encapsulation.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In this article, we’ll delve into the world of nested functions, exploring their syntax, benefits, and real-world applications.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                fun calculateTax (income: Double): Double {

                                    val taxRate = 0.15
                                    fun calculateBaseTax(income: Double): Double {
                                        return income * taxRate
                                    }

                                    val baseTax = calculateBaseTax(income)
                                    val additionalTax = income * 0.05
                                    return baseTax
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Can an enum class implement an interface?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Yes, it can implement an interface — but it cannot inherit from classes. Here’s an example of an enum class implementing an interface:",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In this example, SomeWorker is an enum class that implements SomeInterface. Each enum constant A and B provides its own implementation of the doWork function declared in the interface. Although an enum class can implement an interface, it cannot inherit from another class because every enum in Kotlin implicitly inherits from Enum (which is a special class in Kotlin).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Result<Any> vs. Result<*>",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Both Result<Any> and Result<*> are ways to represent the outcome of an operation in Kotlin, but they differ in their flexibility and type safety:",
                            modifier = Modifier.padding(topBottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                        )

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Result<Any>",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Represents the result of an operation that can return any type of value.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It’s a generic class with a single parameter T representing the type of the successful result.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "When used as Result<Any>, however, T is inferred to be Any, allowing any possible type for the value.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Result<*>",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Represents the result of an operation that can also return any type of value.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It utilizes the star projection (*) to indicate that the type parameter T is unknown and cannot be determined at compile time.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Similar to Result<Any>, it allows any potential type for the value.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "When to use which",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Prefer Result<T> where the successful result type is known and specific. This provides better type safety and avoids unnecessary runtime checks.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Use Result<Any> cautiously when the successful result type can be any possible type, but be aware of potential runtime type checks.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Avoid Result<*> in general due to its lack of type information and potential safety concerns. Consider using Result<Any> instead if you need to handle any possible type, but understand the trade-off in type safety.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What are anonymous classes in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Anonymous classes are usually used to extend the functionality of an interface or an abstract class without explicitly declaring a new class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the concept of annotations in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Annotations are a way to add metadata to code. They can be used to provide additional information for the compiler or at runtime; for example, they can specify how a class should be serialized or how a function should be called.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the use of @JvmStatic, @JvmOverloads, and @JvmFiled in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "@JvmStatic: @JvmStatic annotations tell the compiler that this variable or method is the static method or variable and can be used in Java code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "@JvmOverloads: To use the default values passed as an argument in Kotlin code from the Java code, we need to use the @JvmOverloads annotation. (@JvmOverloads annotations is used to pass the default values from java code to kotlin code). It instructs the compiler to generate multiple overloads of a function based on its default parameter values.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "@JvmField: To access the fields of a Kotlin class from Java code without using any getters and setters, we need to use the @JvmField in the Kotlin code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the default behavior of Kotlin class?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The default behavior of the kotlin class is final. That’s why kotlin class allow multiple inheritances for classes.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How does Kotlin handle inheritance differently from Java?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, classes are final by default — you must mark them open to allow inheritance. This avoids accidental subclassing and enforces safer OOP.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What are pair and triple in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Pair and Triples are used to return two and three values respectively from a function and the returned values can be of the same data type or different.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain use() function.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The use function in Kotlin is an extension function that handles resources like files, streams, or other Closeable objects. It ensures that the resource is closed automatically once its usage is complete, even if an exception occurs. This makes your code cleaner and helps avoid memory leaks. The use function is used for working with resources that need to be closed after usage, such as files or database connections. It ensures that the resource is properly closed regardless of exceptions or early returns.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                             //Socket
                             val socket =Socket ("example.com", 8080)
                             socket.use {
                               //I Use the socket for communication
                               //I The socket will be closed after this block
                             }

                             //Reading from a BufferedReader
                             val reader = BufferedReader(FileReader())
                             reader.use {
                             val line = reader. readLine()
                               //Process this line
                               //I The reader will be closed after this block?
                             }

                             //Working with a file
                             val file = File ("example.txt")
                             file.use {
                               //Perform operations on the file
                               //The file will be auto closed after this block?
                             }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is asSequence?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, asSequence is a function that converts a collection into a sequence. Sequences are lazy collections, meaning their elements are computed on-demand, not in advance.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                            // Converting a list to a sequence
                            val list = listOf(1, 2, 3)
                            val sequence = list.asSequence()

                            // Using List
                            val list = listOf(1, 2, 3, 4)
                            val newList = list.map { it * 2 }.filter { it > 4 }
                            println(newList)  // Output: [6, 8]

                            // Generating a large list
                            val largeList = (1..1_000_000).toList()

                            // Chaining multiple operations with asSequence
                            val result = listOf(1, 2, 3, 4, 5)
                                        .asSequence()
                                        .map { it * 2 }  // Multiply each element by 2
                                        .filter { it > 5 }  // Filter out elements less than or equal to 5
                                        .take(2)  // Take the first 2 elements
                                        .toList()  // Convert the sequence back to a list
                            println(result)  // Output: [6, 8]

                            // Without asSequence
                            val result1 = largeList.filter { it % 3 == 0 }.map { it * 2 }.take(5)
                            println(result1)  // Output: [6, 12, 18, 24, 30]

                            // With asSequence
                            val result2 = largeList.asSequence().filter { it % 3 == 0 }.map { it * 2 }.take(5).toList()
                            println(result2)  // Output: [6, 12, 18, 24, 30]
                            
                            / With asSequence
                            fun main() {
                                fun digitSum(n: Int): Int = n.toString().sumOf { it - '0' }

                                val number = (1..10_000)
                                    .asSequence()
                                    .map { it * it }
                                    .find { digitSum(it) == 45 }
                                
                                    print(number)
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why Use asSequence?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Performance: Avoids creating intermediate collections.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Lazy Evaluation: Computes elements only when needed.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Chainability: Allows for more readable and maintainable code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "You can chain multiple operations together for more complex transformations.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain invoke operator.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, invoke is a special function that enables instances of a class to be invoked as if they were functions.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Work - By defining an invoke function within a class, you can seamlessly call instances of that class as if they were functions. This can lead to cleaner, more expressive code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Why use - It's a handy tool for creating DSLs, defining custom operations on objects, or simply improving the readability of your code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It is possible to use the operator fun invoke on an \"object\" type in Kotlin, just like you can do it on a class. This allows you to create singleton-like instances that can be called as if they were functions. You cannot use the invoke operator directly on an object type, you can achieve similar functionality using function types in Kotlin.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                            class Calculation {
                                operator fun invoke(x: Int): Int {
                                    return x * x
                                }
                            }

                            fun main() {
                                val calculation = Calculation()
                                val result = calculation(5) // Calls the 'invoke' operator function
                                println(result) // Prints 25
                            }
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = $$"""
                            class HtmlBuilder {
                                private val elements = mutableListOf<HtmlElement>()

                                operator fun invoke(block: HtmlBuilder.() -> Unit): HtmlBuilder {
                                    this.block()
                                    return this
                                }

                                fun element(tag: String, content: String) {
                                    val htmlElement = HtmlElement(tag, content)
                                    elements.add(htmlElement)
                                }

                                override fun toString(): String {
                                    return elements.joinToString("\n") { it.toString() }
                                }
                            }

                            data class HtmlElement(val tag: String, val content: String) {
                                override fun toString(): String {
                                    return "<$tag>$content<$tag>"
                                }
                            }

                            fun main() {
                                val html = HtmlBuilder()

                                html {
                                    element("div", "Hello,")
                                    element("p", "world!")
                                    element("a", "Click me")
                                }

                                println(html)
                            }
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = $$"""
                            class MathFunction(private val coefficients: List<Double>) {
                                operator fun invoke(x: Double): Double {
                                    return coefficients.foldIndexed(0.0) { index, acc, coeff ->
                                        acc + coeff * Math.pow(x, index.toDouble())
                                    }
                                }

                                operator fun plus(other: MathFunction): MathFunction {
                                    val resultCoefficients = mutableListOf<Double>()
                                    val maxDegree = maxOf(coefficients.size, other.coefficients.size)

                                    for (i in 0 until maxDegree) {
                                        val coeff1 = if (i < coefficients.size) coefficients[i] else 0.0
                                        val coeff2 = if (i < other.coefficients.size) other.coefficients[i] else 0.0
                                        resultCoefficients.add(coeff1 + coeff2)
                                    }

                                    return MathFunction(resultCoefficients)
                                }

                                override fun toString(): String {
                                    val terms = coefficients.mapIndexed { index, coeff ->
                                        if (index == 0) "$coeff" else "${coeff}x^$index"
                                    }
                                    return terms.joinToString(" + ")
                                }
                            }

                            fun main() {
                                val f1 = MathFunction(listOf(1.0, 2.0, 3.0)) // f1(x) = 1 + 2x + 3x^2
                                val f2 = MathFunction(listOf(0.5, -1.0, 2.0)) // f2(x) = 0.5 - x + 2x^2

                                println("Function f1(x): $f1")
                                println("Function f2(x): $f2")

                                val sumFunction = f1 + f2
                                println("Sum of f1(x) and f2(x): $sumFunction")

                                val xValue = 2.0
                                val result = sumFunction(xValue)
                                println("Result for x = $xValue: $result")
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is a closure in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A closure refers to a function that can access variables and parameters from its surrounding scope, even after the scope has finished execution.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It captures the variables it needs, stores them, and can access them later when the function is invoked. The captured variables maintain their state, and any modifications made to them within the closure will be preserved.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 fun createIncrementFunction(incrementBy: Int): () -> Int {
                                     var count = 0

                                     return {
                                         count += incrementBy
                                         count
                                     }
                                 }

                                 fun main() {
                                     val incrementByTwo = createIncrementFunction(2)
                                     println(incrementByTwo()) // Output: 2
                                     println(incrementByTwo()) // Output: 4
                                 }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the concept of the internal visibility modifier in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The internal visibility modifier in Kotlin is used to restrict the visibility of a declaration to the same module. It allows the declaration to be accessed from any code within the same module but not from outside the module. A module is defined as a set of Kotlin files compiled together.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                //ModuleA.kt
                                internal class InternalClass {
                                    fun doSomething() {
                                        println("Doing something internally")
                                    }
                                }

                                //ModuleB.kt
                                fun main() {
                                    val internalClass = InternalClass() // Error: InternalClass is not accessible
                                }
                            """.trimIndent()
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The InternalClass is marked as internal, and it is only accessible within the same module (e.g., a group of Kotlin files compiled together). In this case, the main function in ModuleB.kt cannot access the InternalClass because it is in a different module.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the difference between sealed classes and abstract classes in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        SpanText(
                            text = "Sealed classes and abstract classes are both used for defining hierarchies of related classes, but they have different characteristics and purposes in Kotlin.",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                        )

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Sealed classes: A sealed class is used to represent restricted class hierarchies, where all possible subclasses are known and defined within the sealed class itself. Sealed classes are commonly used to represent restricted sets of data or states.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Abstract classes: An abstract class is a class that cannot be instantiated and is intended to be subclassed. It can define both abstract and non-abstract methods, providing a common interface and behavior that its subclasses must implement.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How do you handle concurrency in Kotlin using synchronized blocks?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Concurrency in Kotlin can be handled using synchronized blocks. The synchronized keyword in Kotlin ensures that only one thread can access a synchronized block of code at a time, preventing concurrent modification or access to shared resources.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                class Counter {
                                    private var count = 0

                                    fun increment() {
                                        synchronized(this) {
                                            count++
                                        }
                                    }

                                    fun getCount(): Int {
                                        synchronized(this) {
                                            return count
                                        }
                                    }
                                }

                                fun main() {
                                    val counter = Counter()

                                    // Thread 1
                                    Thread {
                                        for (i in 1..1000) {
                                            counter.increment()
                                        }
                                    }.start()

                                    // Thread 2
                                    Thread {
                                        for (i in 1..1000) {
                                            counter.increment()
                                        }
                                    }.start()

                                    Thread.sleep(1000) // Wait for threads to complete


                                    println(counter.getCount()) // Output: Final count: 2000
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What are the benefits of using a Sealed Class over Enum?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Sealed classes give us the flexibility of having different types of subclasses and also containing the state. The important point to be noted here is the subclasses that are extending the Sealed classes should be either nested classes of the Sealed class or should be declared in the same file as that of the Sealed class.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Kotlin closures",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In java 8, we cannot mutate (change) values of an outside variable inside lambdas but in kotlin we can change the values.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "means in kotlin we have the right to modify the outside variables inside the lambda expression.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                 fun main(args: Array<String>) {

                                     val program = Program()
                                     val result = 0
                                     program.addTwoNumbers(2, 7) { x, y -> result = x + y }
                                     println(result)
                                 }

                                 class Program {
                                     fun addTwoNumbers(a: Int, b: Int, action: (Int, Int) -> Unit) {

                                         action(a, b) // result = x + y = a + b = 2 + 7 = 9
                                     }
                                 }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Exploring the Power and Versatility of Kotlin’s Result Class.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "While looking at different Kotlin codebases, I’ve noticed that we often create custom 𝙍𝙚𝙨𝙤𝙪𝙧𝙘𝙚 or 𝙍𝙚𝙨𝙪𝙡𝙩 classes. These classes serve their purpose well, but did you know that the Kotlin SDK provides a 𝙍𝙚𝙨𝙪𝙡𝙩 class that often fulfills our requirements while providing several utility methods out-of-the-box?",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The Result class in Kotlin encapsulates either a successful operation with its result or a failed operation with its exception.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                        SpanText(
                            text = "Here’s a quick snapshot of its key methods and properties:",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "isFailure and isSuccess: These properties allow quick checks to verify if the Result encapsulates a success or failure.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "getOrNull: This function returns the encapsulated result if it’s a success, or null in case of failure.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "exceptionOrNull: This function, complimenting getOrNull, retrieves the exception if the result represents failure or null if it’s a success.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This function, complimenting getOrNull, retrieves the exception if the result represents failure or null if it’s a success.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                                fun main() {
                                    fun fetchData(): Result<String> {
                                        return try {
                                            // Data retrieval call
                                            val data = "success"
                                            Result.success(data)
                                        } catch (e: Exception) {
                                            Result.failure(e)
                                        }
                                    }

                                    val result = fetchData()
                                    if(result.isSuccess) {
                                        println("Data successfully fetched!")
                                        val data = result.getOrNull()
                                    } else {
                                        println("Data fetch encountered an error")
                                        val error = result.exceptionOrNull()
                                    }
                                }
                            """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain Type Variance.",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "In Kotlin, type variance refers to how types with the same base type but different type arguments relate to each other. This concept is crucial when dealing with complex data structures and APIs. Variance in Kotlin is primarily about ensuring type safety while maintaining flexibility in your code.",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                        )

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Covariance (out)",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Covariance allows you to pass a sub-type where a super-type is expected. In Kotlin, this is achieved using the out keyword. It means you can produce a type (like reading from a source) but not consume it.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Real-World Example — Data Display",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Imagine an app that displays different types of media, such as Book, Movie, and Podcast, all of which inherit from a Media class. You have a function that needs to handle a list of any media type —",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Using out, you can pass a List<Book>, List<Movie>, or List<Podcast> to this function, maintaining type safety while offering flexibility.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                fun displayMediaList(mediaList: List<out Media>) {
                                    // Display the media
                                }
                            """.trimIndent()
                        )

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Contravariance (in)",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Contravariance is the opposite — it allows you to pass a super-type where a subtype is expected. This is marked with the in keyword in Kotlin and is suitable when you consume a type (like writing to a source) but don't produce it.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Real-World Example — Data Processing",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Consider a scenario where you need a generic data processor that works for different types of user inputs, such as TextInput, FileInput, and VoiceInput, all of which inherit from a UserInput class —",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "With contravariance, you can use a DataProcessor<UserInput> where a DataProcessor<TextInput> is expected, enabling broader applicability of your classes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                  class DataProcessor<in T: UserInput> {
                                      fun process(input: T) {
                                          // Process the input
                                      }
                                  }

                                  val textProcessor = DataProcessor<TextInput>()
                                  val fileProcessor = DataProcessor<FileInput>()
                            """.trimIndent()
                        )
                    }
                }

                Li {
                    SpanText(
                        text = "* Vs Any",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Star Projection (*) — This is used when the specific type argument is unknown or irrelevant. It allows for safe read operations but restricts writing, as the type is effectively treated as Any?.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Using Any— In contrast, Any is the super-type of all non-nullable types in Kotlin. When used as a generic type argument, it signifies that any non-nullable type is acceptable, and both read and write operations are permitted.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is structured concurrency?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Every coroutine has a parent scope. When the parent is cancelled, ALL children are cancelled. When a child fails, the parent and siblings are cancelled (unless SupervisorJob).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                        viewModelScope.launch {             // Parent
                            launch { fetchProfile() }       // Child 1
                            launch { fetchRecommendations() } // Child 2
                            launch { fetchNotifications() }   // Child 3
                            // If Child 2 throws → Parent cancels → Child 1 and 3 are cancelled too
                        }

                        // SupervisorJob: Each child fails independently
                        supervisorScope {
                            launch { fetchProfile() }         // Continues even if Child 2 fails
                            launch { fetchRecommendations() } // If this fails...
                            launch { fetchNotifications() }   // ...this still runs
                        }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is a stacktrace?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It is a stack of all methods that were called, before the error happened in your app, and IDEs like Android Studio, can deep link to the actual method sometimes, making it very convenient to know where things went wrong.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is ThreadLocal?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "ThreadLocal provides a way to create variables that are local to the thread they are accessed from. Each thread accessing such a variable has its own, independent copy, making it ideal for scenarios where thread safety and isolation are crucial.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Data Isolation: Ensures that each thread has its own independent data, preventing unintended data sharing between threads.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Thread Safety: Minimizes the risk of concurrency issues by confining data to specific threads.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Legacy System Compatibility: Ideal for maintaining and refactoring legacy systems where threading is involved.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Performance Optimization: Reduces overhead by avoiding synchronization mechanisms for thread-local data.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        KotlinCode(
                            code = """

                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why releasing resources is problematic?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It's straightforward to forget to release resources or do it incorrectly, which can crash or slow down your app. It escalates in memory-heavy places, such as file reading and writing operations.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "AutoCloseable",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "AutoCloseable is a stdlib interface, which tells us that the object resources need to be additionally released.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                KotlinCode(
                    code = """
                    class DatabaseConnection : AutoCloseable {
                        fun connect() {
                            println("Database connected")
                        }

                        override fun close() {
                            println("Database connection closed")
                        }

                        fun main () {
                            // Using the DatabaseConnection with try-with-resources
                            DatabaseConnection().use { connection ->
                                connection. connect()
                                // Perform database operations here
                        } // Automatically calls close() at the end
                    }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is Kotlin Serialization.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Transforms Kotlin objects to data and vice versa.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Type-safe and multiplatform- ready.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Supports popular formats: JSON, Protobuf, CBOR, and more.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain Annotations in Kotlin Serialization.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Basic",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ol {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "@SerialName - Use @SerialName to map property names.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "@Serializable - Add the @Serializable annotation to mark objects for Kotlin Serialization.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Annotations",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "@Serializer",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "An annotation for creating custom serializers to control how data types are serialized and deserialized",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Handle non-standard types like Dateor UUID.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Customize serialization behavior for specific API requirements.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Centralize logic for consistent data handling.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "@Required",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Ensures a field is always present during deserialization.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Avoid null errors for critical fields.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Annotate fields that need default values.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "@Transient",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Excludes fields from serialization.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Prevent sensitive data or transient states from being saved.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Use for non-persistent or calculated fields.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "@JsonNames",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Maps multiple JSON keys to a single Kotlin field.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Handle API inconsistencies or version differences.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Use for fields with varying key names in APIs.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "@Polymorphic",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Supports polymorphic serialization.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Handle object hierarchies efficiently.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Use for polymorphic data structures.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "@UseSerializer",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It's an annotation used to declare the use of one or more custom serializers for specific types within a file or scope (e.g., a class or package).",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Avoids repetitive @Serializable(with = Serializer::class) annotations.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Simplifies applying a custom serializer to a type across an entire file or scope.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "When the same type appears multiple times in a file or class.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "In large data models where annotating individual properties is inefficient.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Ensure your custom serializer implements KSerializer.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "When to Use Serializable?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Simple Data Transfer: When you need to pass simple objects between activities or fragments without worrying too much about performance.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Java Compatibility: Ideal for maintaining compatibility with older Java-based code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Works on JVM, Android, JS, and Native platforms.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Integrates with coroutines for async operations.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Pros Serializable",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Ease of Use: Implementing Serializable is straightforward; you just need to implement the interface without any additional code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Backward Compatibility: Since it's part of Java, it works well with older codebases and libraries.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Cons Serializable",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Performance: Serializable is slower and consumes more memory than Parcelable, which can affect performance, especially with large objects.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "No Control Over Serialization Process: The process is automatic and doesn’t allow for fine-tuning, which might be limiting in complex scenarios.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "When to Use Parcelable?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Performance-Critical Scenarios: These scenarios involve efficiently passing complex or large objects between different app components.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Android-Specific Development: Ideal for Android apps, as Parcelable is designed to work seamlessly with Android’s IPC (Inter-Process Communication).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Pros Parcelable",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Better Performance: Parcelable is faster and more memory-efficient than Serializable, making it suitable for performance-critical scenarios.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Custom Serialization: It allows developers to define exactly how objects should be serialized and deserialized, giving more control over the process.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the describeContents() method in Parcelable?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It describes the kinds of special objects contained in the Parcelable instance. For most cases, it returns 0.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the role of CREATOR in Parcelable?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The CREATOR field generates instances of your Parcelable class from a Parcel. It is required for reconstructing objects.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is Reflection?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Reflection is a feature that allows a program to examine and manipulate its own structure at runtime. This means you can inspect classes, methods, properties, annotations, and other elements of your code dynamically. Reflection is particularly useful in scenarios where you need to handle types, functions, or properties that are not known at compile time.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                             dependencies {
                                 implementation("org.jetbrains.kotlin:kotlin-reflect")
                             }
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                             import kotlin.reflect.full.memberProperties
                             import kotlin.reflect.full.primaryConstructor

                             fun serialize(obj: Any): String {
                                 val kClass = obj::class
                                 val properties = kClass.memberProperties
                                 return properties.joinToString(",") { property ->
                                     val value = property.get(obj)
                                     property.name
                                 }
                             }
                             fun main() {
                                 data class Person(val name: String, val age: Int)
                                 val person = Person("Alice", 30)
                                 val serialized = serialize(person)
                                 println(serialized) // Output: name=Alice,age=30
                             }
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                            import kotlin.reflect.full.functions

                            fun main() {
                                val myClass = MyClass("John", 30)
                                val kClass = MyClass::class
                                val function = kClass.functions.find { it.name == "greet" }
                                function?.call(myClass)
                            }
                            class MyClass(val name: String, val age: Int) {
                                fun greet() {
                                    println(name)
                                }
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "When uses of Reflection in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Accessing Class Metadata: Get details about a class (properties, functions, constructors) without needing to know them in advance. Useful for libraries and frameworks that work with unknown types.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Function and Property Manipulation: Dynamically modify properties or call functions. Ideal for frameworks that need to adjust objects based on user input or config files.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Accessing Private Properties: Reflection can bypass visibility restrictions, which can help in testing or when verifying internal states.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Creating Instances Dynamically: Instantiate classes at runtime, even if their type is unknown. Useful for plugins, dependency injection, and modular applications.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is @receiver?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, the @receiver annotation is used to explicitly specify the receiver type of an extension function or property. The receiver is the type on which the extension function or property is called. By using @receiver, you provide a clear indication of the receiver type, improving code readability and maintainability.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                //https://www.linkedin.com/in/ammar-abdullah-2018/recent-activity/all/
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why Use @receiver?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Clarity: Make it clear what type the extension function is intended for, enhancing code comprehension.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Code Organization: Helps distinguish and organize multiple extension functions with similar names but different receiver types.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Enhanced Readability: Explicit receiver types improve readability, especially in complex projects.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Checked Exceptions",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Checked exceptions are verified by the compiler at compile time. If a method throws a checked exception, the method must either handle it using a try-catch block or declare it using the throws keyword in its signature. This ensures that the exception is acknowledged and handled properly.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Types of Checked Exceptions",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ol {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Fully Checked Exception: All child classes are checked (e.g., IOException, InterruptedException).",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Partially Checked Exception: Only some child classes are checked (e.g., Exception).",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Unchecked Exceptions",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Unchecked exceptions are not checked at compile time. These are typically caused by logical errors in the program. In Java, exceptions under the RuntimeException and Error classes are unchecked exceptions, while everything else under Throwable is checked.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Common unchecked exceptions include: NullPointerException, ArrayIndexOutOfBoundsException, ArithmeticException, IllegalArgumentException",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How object works?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In Kotlin, an object is created lazily, meaning the first time it’s being used, additionally object implements Singleton so only a single instance is being created. Exceptions take a stack trace from a place of their initialization. Can you see what’s happening here?",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "object is being created for the first time in addResource method and takes a stacktrace from that place then when it’s thrown in getResource it’ll still hold the stacktrace from addResource ! This might look like something not that big, but imagine having to debug a crash or issue with logs like these!",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "You should never use the Singleton pattern for exceptions and create a new instance of Exception",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                            //Wrong Way
                            object ResourceNotFoundException : Exception("Failed to load a resource")

                            //Good Way
                            class ResourceNotFoundException : Exception("Failed to load a resource")

                            class ResourceRepository {
                                fun addResource() {
                                    throw ResourceNotFoundException()
                                }

                                fun getResource() {
                                    throw ResourceNotFoundException()
                                }
                            }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Strong References",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When you create an object in Kotlin, you are using a strong reference by default. A strong reference keeps the object alive as long as the reference to it exists. If there are no more strong references to an object, it becomes eligible for garbage collection.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Weak References",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Weak reference allows the object it references to be garbage collected when there are no more strong references to it. Weak references are useful when you want to prevent memory leaks by holding references to objects that should be garbage collected when not in use.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why Sharding is needed",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Data unable to fit on one machine: Sometimes the data becomes too big to fit on one computer. By sharding the data, we can store smaller subsets on different machines.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Improved Performance: It takes less time to search and retrieve data as the data is divided between shards and each shard contains fewer records. Queries can be processed in parallel across different shards, improving the response time.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Fault Tolerance: If one shard fails, requests can still be served from the remaining machines, preventing system-wide outage. Only the users belonging to that shard will be affected.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Cost Optimization: Since data is divided into smaller subsets, multiple affordable servers can be used instead of expensive high-end servers.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }


                //ddd
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is the loader in kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A Loader is a component that manages asynchronous loading of data. It is primarily used to load data in a background thread without blocking the main UI thread. Loaders are useful for tasks such as querying a database or loading data from a network.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Asynchronous Loading: Loaders run on a separate thread, which helps keep the UI responsive.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Lifecycle Management: Loaders are aware of the activity/fragment lifecycle, meaning they can automatically manage their loading processes based on whether the associated activity or fragment is active or not.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Data Caching: Loaders can cache their results, so if the activity or fragment is recreated (like during configuration changes), they can quickly return the cached data without reloading it.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = """
                            class MainActivity : AppCompatActivity(), LoaderManager.LoaderCallbacks<Cursor> {
                                private val LOADER_ID = 1

                                override fun onCreate(savedInstanceState: Bundle?) {
                                    super.onCreate(savedInstanceState)
                                    setContentView(R.layout.activity_main)

                                    // Initialize the loader
                                    LoaderManager.getInstance(this).initLoader(LOADER_ID, null, this)
                                }

                                override fun onCreateLoader(id: Int, args: Bundle?): Loader<Cursor> {
                                    // Create and return a CursorLoader
                                    return CursorLoader(
                                        this,
                                        YourContentProvider.CONTENT_URI, // Replace with your content URI
                                        null, // Projection (null means all columns)
                                        null, // Selection
                                        null, // Selection arguments
                                        null  // Sort order
                                    )
                                }

                                override fun onLoadFinished(loader: Loader<Cursor>, data: Cursor?) {
                                    // Called when the data has been loaded
                                    if (data != null && data.moveToFirst()) {
                                        do {
                                            // Process the data from the Cursor
                                            val item = data.getString(data.getColumnIndex("column_name")) // Replace with your column name
                                            // Use the data (e.g., update the UI)
                                        } while (data.moveToNext())
                                    }
                                }

                                override fun onLoaderReset(loader: Loader<Cursor>) {
                                    // Called when the loader is reset
                                }
                            }
                        """.trimIndent()
                    )
                }


                Li {
                    Column {
                        SpanText(
                            text = "Optimization code",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        KotlinCode(
                            code = """
                                //Filter

                                data class Item(val id: Int, val name: String)

                                // optimized Kotlin code for filtering a list
                                fun filterItems(items: List<Item>, condition: (Item) -> Boolean): List<Item> {
                                    return items.filter {
                                        condition(it)
                                    }
                                }

                                fun main() {
                                    val items = listOf(Item(1, "Apple"), Item(2, "Banana"), Item(3, "Orange"))
                                    val filteredItems = filterItems (items) { it.name.contains("l", ignoreCase = true) }
                                    println(filteredItems)
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Empty

                                val list = urlList.ifEmpty { listOfPredefinedUsers }
                            """.trimIndent()
                        )
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Kotlin Brain Teaser",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        KotlinCode(
                            code = """
                                fun main(){
                                    val numbers = listOf(1, 2, 3, 4, 5)
                                    val result = numbers.map {
                                        it *  2
                                    }.filter {
                                        it % 3 == 0
                                    }.take(2)

                                    println(result)
                                }

                                //output
                                [6]
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                      fun main() {
                                          val numberStrList =
                                              listOf("90", "W6", "1", "228", "L5", "33C", "300", "20", "X1", "118", "30", "10")

                                          val listSortedByLeadingNumberIfPossible = numberStrList
                                              // Do an initial sort, for sorting strings that don't start with a number, e.g. "W6" and "X1"
                                              .sorted()
                                              .sortedBy { str ->
                                                  str.takeWhile { c -> c.isDigit() }.toIntOrNull() ?: Int.MAX_VALUE
                                              }

                                          println(listSortedByLeadingNumberIfPossible)
                                          // prints [1, 10, 20, 30, 33C, 90, 118, 228, 300, L5, W6, X1]
                                      }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 //Sum of Natural Numbers Using Recursion
                                 fun main() {
                                     var sum = 0
                                     for (i in 1..5) {
                                         sum += i
                                     }
                                     println(sum)
                                 }
                                 //output 15

                                 //Recursion
                                 fun addNumbers(num: Int): Int {
                                     if (num != 0)
                                         return num + addNumbers(num - 1)
                                     else
                                         return num
                                 }

                                 //Without recursion and loop
                                 int sum = (N*(N+1))/2;

                                 //Function using
                                 fun runningSum(nums: IntArray): IntArray {
                                   return nums.runningReduce { sum, element -> sum + element }.toIntArray()
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                fun main() {
                                    println(isPalindrome(121))
                                    println(isPalindrome(11211))
                                    println(isPalindrome(0))
                                    println(isPalindrome(1))
                                    println(isPalindrome(10))
                                    println(isPalindrome(-121))
                                }

                                private fun isPalindrome(x: Int): Boolean {
                                    var x = x

                                    if (x < 0 || (x != 0 && x % 10 == 0)) {
                                        return false
                                    }

                                    var reverseNumber = 0

                                    while (x > reverseNumber) {
                                        reverseNumber = (reverseNumber * 10) + (x % 10)
                                        x /= 10
                                    }

                                    return (x == reverseNumber) || (x == reverseNumber / 10)
                                }
                                
                                //Single line
                                val isPalindrome = word.equals(word.reversed(), ignoreCase = true)
                            """.trimIndent()
                        )

                        KotlinCode(
                            """
                            //A E I O U convert to uppercase

                            fun convertVowelsToUppercase(input: String): String {
                            val vowels = setOf('a', 'e', 'i', 'o', 'u', 'A', 'E', 'I', 'O', 'U')
                            val result = StringBuilder()

                            for (char in input) {
                                if (char in vowels) {
                                    result.append(char.toUpperCase())
                                } else {
                                    result.append(char)
                                }
                            }

                            return result.toString()
                        }

                        fun main() {
                            val inputString = "This is a sample string with some vowels."
                            val convertedString = convertVowelsToUppercase(inputString)
                            println(convertedString)
                        }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Remove vowels 1

                                fun main(){
                                    fun removeVowels(S: String): String {
                                        val vowels = setOf('a', 'e', 'i', 'o', 'u')
                                        return S.filterNot { it in vowels }
                                	}
                                }

                                //Remove vowels 2
                                fun main(){
                                    fun removeVowels(S: String): String {
                                  		val vowels = setOf('a', 'e', 'i', 'o', 'u')
                                  		return S.filter { it !in vowels }
                                	}
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 //Count Vowels in a String

                                 fun countVowels(input: String): Int {
                                     return input.count { it in "aeiouAEIOU" }
                                 }

                                 val result = countVowels("Hello World")
                                 println(result)  // Output: 3
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Swap number using also

                                fun main(){
                                    var three = 3
                                    var four = 4

                                    three = four.also {four = three}
                                    println(three) //print 4
                                    println(four) //print 4
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                fun main() {
                                    forOne@ for (i in 0..2) {
                                        forTwo@ for (j in 0..3) {
                                            if (j == 2)
                                            	break@forOne // Or return@forOne
                                            print(j)
                                        }
                                    }
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                fun main() {
                                    check("Kotlin")
                                    check(listOf(1,2,3))
                                }

                                fun check(obj: Any) {
                                    if (obj is String)
                                        println(obj.length) // obj is automatically cast to String

                                    if (obj is List<*>)
                                        println(obj.size) // obj is automatically cast to List

                                    // obj is automatically cast to String on the right-hand side of `&&`
                                    if (obj is String && obj.length > 0)
                                        println(obj.length)
                                }

                                //Output 6, 6, 3
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Remove the intArrayOf specific position element
                                 fun main(){
                                     val array = intArrayOf(0, 1, 2, 3, 4, 5, 6, 7, 8, 9)
                                 	for(index in array.indices - 5) {
                                   		print(array[index])
                                 	}
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 //1
                                 fun mostCommonWord(paragraph: String, banned: Array<String>): String {
                                   // 1. Covert string to lower case and split by words.
                                   val words = paragraph.toLowerCase().split("\\W+|\\s+".toRegex())

                                   // 2. Create a set of banned words.
                                   val bannedSet = banned.toHashSet()

                                   // 3. Create a map of words to their occurrence, excluding the banned words
                                   val wordToCount = words.filterNot { it in bannedSet }.groupingBy { it }.eachCount()

                                   // 4. Return word with the highest number of occurrences from the map.
                                   return wordToCount.maxBy { it.value }!!.key
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = $$"""
                                 fun main() {
                                     val range = 10 // specify the number of terms
                                     var firstNumber = 0
                                     var secondNumber = 1

                                     print("Fibonacci Series up to $range terms: ")

                                     for (index in 1..range) {
                                         print(firstNumber)

                                         val total = firstNumber + secondNumber
                                         firstNumber = secondNumber
                                         secondNumber = total
                                     }
                                 }

                                 //0, 1, 1, 2, 3, 5, 8, 13, 21, 34
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = $$"""
                                fun sunsetView(buildings: IntArray): List<Int> {
                                    val visibleBuildings = mutableListOf<Int>()
                                    var maxHeight = 0
                                    for (i in buildings.indices) {
                                        if (buildings[i] > maxHeight) {
                                            visibleBuildings.add(i)
                                            maxHeight = buildings[i]
                                        }
                                    }
                                    return visibleBuildings
                                }

                                fun main() {
                                    val buildings = intArrayOf(7, 4, 8, 2, 9)
                                    val result = sunsetView(buildings)
                                    println("The sunset can be seen from buildings at indexes: $result")
                                }

                                //output 0, 2, 4
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                class MyTestClass {
                                    fun processNumbers() {
                                        val numbers = arrayOf(1, 2, 3, 4, 5)

                                        val addOne: (Int) -> Int = { it + 1 }
                                        processArray(numbers, addOne)

                                        val square: (Int) -> Int = { it * it }
                                        processArray(numbers, square)
                                    }

                                    private fun processArray(array: Array<Int>, operation: (Int) -> Int) {
                                        val result = array.map { operation(it) }
                                        println(result)
                                    }
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                fun createMultiplier(factor: Int): (Int) -> Int {
                                    return { number -> number * factor }
                                }

                                fun main() {
                                    // Create a multiplier function that doubles its input
                                    val double = createMultiplier(2)

                                    // Create a multiplier function that triples its input
                                    val triple = createMultiplier(3)

                                    // Use the double multiplier function to double a value
                                    val doubledValue = double(5)  // Should return 10

                                    // Use the triple multiplier function to triple a value
                                    val tripledValue = triple(7)  // Should return 21
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Repeatedly character count

                                //Function using
                                fun countCharacters(input: String): Map<Char, Int> {
                                    return input.groupingBy { it }.eachCount()
                                }

                                fun main() {
                                    val text = "Hello, Kotlin!"
                                    val charCountMap = countCharacters(text)
                                    println(charCountMap)
                                }

                                //Without function
                                fun main() {
                                   val text = "Hello, Kotlin!"
                                   val charCountMap = text.groupingBy { it }.eachCount()
                                   println(charCountMap)
                               }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Finding Character Occurrence in a String
                                
                                fun main() {
                                    print(characterCount("aabbc"))
                                }

                                fun characterCount(str: String): Map<Char, Int> {
                                    val map = HashMap<Char, Int>()
                                    for (ch in str) {
                                        map[ch] = (map[ch] ?: 0) + 1
                                    }
                                    return map
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Sum of the first and last elements of the Fibonacci series

                                fun fibonacci(n: Int): List<Int> {
                                    val series = mutableListOf(0, 1)
                                    for (i in 2 until n) {
                                        val sum = series[i - 1] + series[i - 2]
                                        series.add(sum)
                                    }
                                    return series
                                }

                                fun main() {
                                    val n = 10 // Change n to the desired length of Fibonacci series
                                    val fibSeries = fibonacci(n)
                                    val sumFirstAndLast = fibSeries.first() + fibSeries.last()
                                    println(sumFirstAndLast)
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Two strings are anagram

                                fun isAnagrams(str1: String, str2: String): Boolean {
                                    //Both String Length must be Equal
                                    if (str1.length != str2.length) {
                                        return false
                                    }

                                    //Convert Strings to character Array
                                    val strArray1 = str1.toCharArray()
                                    val strArray2 = str2.toCharArray()

                                    //Sort the Arrays
                                    Arrays.sort(strArray1)
                                    Arrays.sort(strArray2)

                                    //Convert Arrays to String
                                    val sortedStr1 = String(strArray1)
                                    val sortedStr2 = String(strArray2)

                                    //Check Both String Equals or not After Sorting
                                    //and Return value True or False
                                    return sortedStr1 == sortedStr2
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Common elements in three sorted arrays
                                //https://www.youtube.com/watch?v=p1M7Ou4E5fo

                                 public class Main {

                                     public static void findCommonElements(int[] arr1, int[] arr2, int[] arr3) {
                                         // stores size of arr1
                                         int n1 = arr1.length;

                                         // stores size of arr2
                                         int n2 = arr2.length;

                                         // stores size of arr3
                                         int n3 = arr3.length;

                                         // stores starting index of arr1
                                         int i = 0;

                                         // stores starting index of arr2
                                         int j = 0;

                                         // stores starting index of arr3
                                         int k = 0;

                                         /*
                                          * traverses the arrays until
                                          * we reach the end of
                                          * one of the arrays
                                         */
                                         while (i < n1 && j < n2 && k < n3) {
                                             // if the integers appointed by i, j and k are equal
                                             if (arr1[i] == arr2[j] && arr2[j] == arr3[k]) {
                                                 // prints the common integer
                                                 System.out.println(arr1[i]);

                                                 // increases i, j and k by 1
                                                 i++; j++; k++;
                                             }

                                             /*
                                              * otherwise, if arr1[i] < arr2[j]
                                              * we have already found one smaller integer
                                              * which is arr1[i]
                                              */
                                             else if (arr1[i] < arr2[j]) {
                                                 i++; // increases i by 1
                                             }

                                             /*
                                              * otherwise, if arr2[j] < arr3[k]
                                              * we have got a smaller integer
                                              * which is arr2[j]
                                              */
                                             else if (arr2[j] < arr3[k]) {
                                                 j++; // increases j by 1
                                             }

                                             /*
                                              * otherwise, we consider arr3[k] to be smaller
                                              */
                                             else {
                                                 k++; // increases k by 1
                                             }
                                         }
                                     }

                                     public static void main(String[] args) {
                                         int arr1[] = {1, 2, 3};
                                         int arr2[] = {1, 3, 4, 5};
                                         int arr3[] = {1, 2, 3, 4, 6};

                                         findCommonElements(arr1, arr2, arr3);
                                     }
                                 }
                            """.trimIndent()
                        )

                        /*
data class Order(val amount: Double, val discountStrategy: (Double) -> Double)

fun main() {
    val noDiscount: (Double) -> Double = { it }
    val tenPercentDiscount: (Double) -> Double = { it * 0.9 }
    val twentyPercentDiscount: (Double) -> Double = { it * 0.8 }

    val orders = listOf(
        Order(100.0, noDiscount),
        Order(200.0, tenPercentDiscount),
        Order(300.0, twentyPercentDiscount))

    orders.forEach { order ->
        val finalAmount = order.discountStrategy(order .amount)
        println("Original Amount: \$$order.amount}, Final Amount after discount: \$${finalAmount}")
    }
}
*/

                        KotlinCode(
                            code = """
                                //Order Discount

                                data class Order(val amount: Double, val discountStrategy: (Double) -> Double)

                                fun main() {
                                    val noDiscount: (Double) -> Double = { it }
                                    val tenPercentDiscount: (Double) -> Double = { it * 0.9 }
                                    val twentyPercentDiscount: (Double) -> Double = { it * 0.8 }

                                    val orders = listOf(
                                        Order(100.0, noDiscount),
                                        Order(200.0, tenPercentDiscount),
                                        Order(300.0, twentyPercentDiscount))

                                    orders.forEach { order ->
                                        val finalAmount = order.discountStrategy(order .amount)
                                        println(finalAmount)
                                        println(order.amount)
                                    }
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                            //Zone convert to UTC

                            import java.time.Instant
                            import java.time.ZoneOffset
                            import java.time.format.DateTimeFormatter

                            fun main() {
                                val formatter = DateTimeFormatter.ofPattern ("yyyy-MM-dd'T'HH:mm:ss[.SSS][.SS][.S]X")
                                val dateString = "2023-10-11T06:33:52Z"
                                val instant = Instant. from(formatter.parse(dateString))
                                val hour = instant.atOffset(ZoneOffset.UTC).hour
                                val minutes = instant.atOffset(ZoneOffset.UTC).minute
                                val seconds = instant.atOffset(ZoneOffset.UTC).second
                            }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //ISO DateTime Convert To LocalDateTime
                                fun formatIsoStringToReadableDate(isoString: String): String {
                                    val localDateTime = LocalDateTime.parse(isoString)
                                    val dayOfWeek = localDateTime.dayOfWeek.name
                                    val dayOfMonth = localDateTime.dayOfMonth
                                    val month = localDateTime.month.name
                                }

                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 //Do not specific field serializable
                                 
                                 import kotlinx.serialization.Serializable

                                 @Serializable
                                 data class UserProfile(
                                     val name: String,
                                     
                                     // Non-serializable properties to break circular dependency
                                     @Transient val secretKey: String = "", // Will not be serialized
                                     val email: String
                                 )
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                @Serializable
                                data class EmailMessage(
                                    val messageServerId: String,
                                    val folderName: String,

                                    val subject: String?,
                                    val fromAddress: String?,
                                    val toList: List<String>?,
                                    val ccList: List<String>?,
                                    val bccList: List<String>?,

                                    val bodyPlainText: String?,
                                    val bodyHtml: String?,

                                    @Serializable(with = NullableLocalDateTimeSerializer::class)
                                    val sentDate: LocalDateTime?,

                                    @Serializable(with = NullableLocalDateTimeSerializer::class)
                                    val receivedDate: LocalDateTime?,

                                    var isRead: Boolean = false,
                                    var hasAttachments: Boolean = false,
                                    val attachments: List<EmailAttachmentInfo>? = null,
                                ) {
                                    fun isSameMessageAs(other: EmailMessage?): Boolean {
                                        if (other == null) return false
                                        return this.messageServerId == other.messageServerId && this.folderName == other.folderName
                                    }
                                }

                                object LocalDateTimeIso8601Serializer : KSerializer<LocalDateTime> {
                                    override val descriptor: SerialDescriptor =
                                        PrimitiveSerialDescriptor("kotlinx.datetime.LocalDateTime.ISO8601", PrimitiveKind.STRING)

                                    override fun serialize(encoder: Encoder, value: LocalDateTime) {
                                        encoder.encodeString(value.toString())
                                    }

                                    override fun deserialize(decoder: Decoder): LocalDateTime {
                                        return LocalDateTime.parse(decoder.decodeString())
                                    }
                                }

                                object NullableLocalDateTimeSerializer : KSerializer<LocalDateTime?> {
                                    override val descriptor: SerialDescriptor = PrimitiveSerialDescriptor("kotlinx.datetime.LocalDateTime.ISO8601.Nullable", PrimitiveKind.STRING).nullable


                                    @OptIn(ExperimentalSerializationApi::class)
                                    override fun serialize(encoder: Encoder, value: LocalDateTime?) {
                                        if (value == null) {
                                            encoder.encodeNull()
                                        } else {
                                            encoder.encodeSerializableValue(LocalDateTimeIso8601Serializer, value)
                                        }
                                    }

                                    @OptIn(ExperimentalSerializationApi::class)
                                    override fun deserialize(decoder: Decoder): LocalDateTime? {
                                        return if (decoder.decodeNotNullMark()) {
                                            decoder.decodeSerializableValue(LocalDateTimeIso8601Serializer)
                                        } else {
                                            decoder.decodeNull()
                                            null
                                        }
                                    }
                                }
                            """.trimIndent()
                        )

                        //https://github.com/developerBBee/AssemblePC_KMP.git
                        KotlinCode(
                            code = """
                                 //KSerializer Instant
                                 
                                 import kotlin.time.ExperimentalTime
                                 import kotlin.time.Instant

                                 @OptIn(ExperimentalTime::class)
                                 class InstantTokyoSerializer : KSerializer<Instant> {

                                     override val descriptor: SerialDescriptor = PrimitiveSerialDescriptor(
                                         serialName = "instant",
                                         kind = PrimitiveKind.STRING,
                                     )

                                     override fun deserialize(decoder: Decoder): Instant {
                                         val dateTimeText = decoder.decodeString()
                                         return dateTimeText.toTokyoInstant()
                                     }

                                     override fun serialize(
                                         encoder: Encoder,
                                         value: Instant
                                     ) {
                                         encoder.encodeString(value.toString())
                                     }
                                 }
                                 
                                 private const val TOKYO_TZ = "Asia/Tokyo"

                                 val tokyoTz = TimeZone.of(TOKYO_TZ)

                                 fun now(): Instant = Clock.System.now()

                                 fun String.toTokyoInstant(): Instant {
                                     return runCatching {
                                         val ldt = LocalDateTime.parse(this)
                                         ldt.toInstant(tokyoTz)
                                     }.getOrElse {
                                         Instant.parse(this)
                                     }
                                 }
                            """.trimIndent()
                        )

                        //https://github.com/developerBBee/AssemblePC_KMP.git
                        KotlinCode(
                            code = $$"""
                                //Price KSerializer with operator function
                                
                                class PriceSerializer : KSerializer<Price> {
                                    override val descriptor: SerialDescriptor =
                                        PrimitiveSerialDescriptor(
                                            serialName = "price",
                                            kind = PrimitiveKind.INT,
                                        )

                                    override fun deserialize(decoder: Decoder): Price {
                                        return Price(decoder.decodeInt())
                                    }

                                    override fun serialize(
                                        encoder: Encoder,
                                        value: Price
                                    ) {
                                        encoder.encodeInt(value.value)
                                    }
                                }
                                
                                @Serializable(with = PriceSerializer::class)
                                @JvmInline
                                value class Price(val value: Int): Comparable<Price> {

                                    operator fun plus(price: Price): Price = Price(value + price.value)
                                    operator fun plus(priceInt: Int): Price = Price(value + priceInt)
                                    operator fun minus(price: Price): Price = Price(value - price.value)
                                    operator fun minus(priceInt: Int): Price = Price(value - priceInt)
                                    operator fun times(price: Price): Price = Price(value * price.value)
                                    operator fun times(multiplier: Int): Price = Price(value * multiplier)

                                    override operator fun compareTo(other: Price): Int = value.compareTo(other.value)
                                    operator fun compareTo(priceInt: Int): Int = value.compareTo(priceInt)

                                    fun yenOrUnknown(): String = if (isZero()) "価格情報なし" else yen()

                                    fun isZero(): Boolean = this == ZERO_PRICE

                                    override fun toString(): String {
                                        return value.toString()
                                    }
                                }

                                expect fun Price.yen(): String

                                val ZERO_PRICE = Price(0)
                                val MAX_PRICE = Price(Int.MAX_VALUE)

                                fun Int.toPrice(): Price = Price(this)

                                fun List<Price>.sum(): Price = Price(sumOf { it.value })

                                fun List<Price>.hasZero(): Boolean = any { it.isZero() }

                                fun List<Price>.sumYen(): String = sum().yen().appendIf(hasZero()) { "(+α)" }

                                private fun String.appendIf(
                                    condition: Boolean,
                                    append: () -> String
                                ): String = if (condition) this + append() else this
                                
                                //androidMain
                                actual fun Price.yen(): String = String.format(Locale.JAPAN, "¥ %,d", value)
                                
                                //iosMain
                                import platform.Foundation.NSLocale
                                import platform.Foundation.NSNumber
                                import platform.Foundation.NSNumberFormatter
                                import platform.Foundation.NSNumberFormatterCurrencyStyle
                                import platform.Foundation.localeWithLocaleIdentifier
                                import platform.Foundation.numberWithLong

                                actual fun Price.yen(): String {
                                    val formatter = NSNumberFormatter().apply {
                                        numberStyle = NSNumberFormatterCurrencyStyle
                                        currencyCode = "JPY"
                                        locale = NSLocale.localeWithLocaleIdentifier("ja_JP")
                                        maximumFractionDigits = 0UL
                                        minimumFractionDigits = 0UL
                                    }
                                    val nsNumber = NSNumber.numberWithLong(value.toLong())
                                    return formatter.stringFromNumber(nsNumber) ?: "¥$value"
                            """.trimIndent()
                        )

                        //https://github.com/developerBBee/AssemblePC_KMP.git
                        KotlinCode(
                            code = """
                                 //Enum KSerializer
                                 
                                 class DeviceTypeSerializer() : KSerializer<DeviceType> {
                                     override val descriptor: SerialDescriptor =
                                         PrimitiveSerialDescriptor(
                                             serialName = "deviceType",
                                             kind = PrimitiveKind.STRING,
                                         )

                                     override fun deserialize(decoder: Decoder): DeviceType {
                                         return DeviceType.from(decoder.decodeString())
                                     }

                                     override fun serialize(
                                         encoder: Encoder,
                                         value: DeviceType
                                     ) {
                                         encoder.encodeString(value.key)
                                     }
                                 }
                                 
                                 @Serializable(with = DeviceTypeSerializer::class)
                                 enum class DeviceType(val key: String) {
                                     PC_CASE("pccase"),
                                     MOTHER_BOARD("motherboard"),
                                     POWER_SUPPLY("powersupply"),
                                     CPU("cpu"),
                                     CPU_COOLER("cpucooler"),
                                     MEMORY("pcmemory"),
                                     SSD("ssd"),
                                     HDD("hdd35inch"),
                                     VIDEO_CARD("videocard"),
                                     OS("ossoft"),
                                     DISPLAY("lcdmonitor"),
                                     KEYBOARD("keyboard"),
                                     MOUSE("mouse"),
                                     DVD_DRIVE("dvddrive"),
                                     BD_DRIVE("bluraydrive"),
                                     SOUND_CARD("soundcard"),
                                     SPEAKER("pcspeaker"),
                                     FAN_CONTROLLER("fancontroller"),
                                     CASE_FAN("casefan");

                                     companion object {

                                         fun from(key: String): DeviceType {
                                             return entries.first { it.key == key }
                                         }
                                     }
                                 }
                            """.trimIndent()
                        )

                        //https://github.com/mikaere66/DiscoverMultiplatform
                        KotlinCode(
                            code = """
                                 //KSerializer

                                 {
                                   "type": "FeatureCollection",
                                   "features": [
                                     {
                                       "type": "Feature",
                                       "geometry": {
                                         "type": "LineString",
                                         "coordinates": [
                                           [
                                             172.61891,
                                             -43.59812
                                           ],
                                           [
                                             172.63083,
                                             -43.61325
                                           ]
                                         ]
                                       },
                                       "properties": {
                                         "feature": "mtbtrackstatus",
                                         "popup": "Worsleys track and Body bag",
                                         "id": 14,
                                         "Name": "Worsleys track and Body bag",
                                         "Length": "2.08871km",
                                         "Status": "Open",
                                         "Grade": 3,
                                         "Link": "https://www.ccc.govt.nz/sign-of-the-kiwi-to-bowenvale-valley-mtb-track/",
                                         "strava_all": 8185,
                                         "strava_day": 0,
                                         "strava_max_grade": "27.3",
                                         "strava_avg_grade": "11.5",
                                         "_legendGroup": "Open"
                                       }
                                     }
                                   ]
                                 }

                                 import kotlinx.serialization.json.Json
                                 class JsonUtils {

                                     private val json = Json {
                                         ignoreUnknownKeys = true  // Default is false
                                         useAlternativeNames = true // Default is true
                                     }

                                     fun parseRoutesFile(jsonString: String): FeatureCollectionRoutes {
                                         return json.decodeFromString<FeatureCollectionRoutes>(jsonString)
                                     }
                                 }

                                 import kotlinx.serialization.SerialName
                                 import kotlinx.serialization.Serializable

                                 @Serializable
                                 data class FeatureCollectionRoutes(

                                     @SerialName("type")
                                     val type: String,

                                     @SerialName("features")
                                     val features: List<Features>
                                 )

                                 import kotlinx.serialization.SerialName
                                 import kotlinx.serialization.Serializable

                                 @Serializable
                                 data class Features(

                                     @SerialName("type")
                                     val type: String,

                                     @Serializable(with = GeometrySerializer::class)
                                     val geometry: List<Coordinates>,

                                     @SerialName("properties")
                                     val properties: Properties
                                 )

                                 import kotlinx.serialization.Serializable

                                 @Serializable
                                 data class Coordinates(
                                     val latitude : Double,
                                     val longitude: Double
                                 )

                                 import co.touchlab.kermit.Logger
                                 import kotlinx.serialization.KSerializer
                                 import kotlinx.serialization.descriptors.PrimitiveKind
                                 import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
                                 import kotlinx.serialization.descriptors.SerialDescriptor
                                 import kotlinx.serialization.encoding.Decoder
                                 import kotlinx.serialization.encoding.Encoder
                                 import kotlinx.serialization.json.Json
                                 import kotlinx.serialization.json.JsonArray
                                 import kotlinx.serialization.json.JsonDecoder
                                 import kotlinx.serialization.json.JsonObject
                                 import kotlinx.serialization.json.decodeFromJsonElement
                                 import kotlinx.serialization.json.jsonArray

                                 object GeometrySerializer: KSerializer<List<Coordinates>> {

                                     override val descriptor: SerialDescriptor
                                         get() = PrimitiveSerialDescriptor("type", PrimitiveKind.STRING)

                                     override fun deserialize(decoder: Decoder): List<Coordinates> {
                                         val json = ((decoder as JsonDecoder).decodeJsonElement() as JsonObject)
                                         return parseGeometry(json)
                                     }

                                     private fun parseGeometry(json: JsonObject): List<Coordinates> {
                                         val coordsList = mutableListOf<Coordinates>()

                                         val type        = json["type"]        ?: return emptyList()
                                         val coordinates = json["coordinates"] ?: return emptyList()

                                         try {

                                             val elementType: String = Json.decodeFromJsonElement(type)
                                             val coordsArray = coordinates.jsonArray

                                             if (coordsArray.isNotEmpty()) {

                                                 if (elementType == "MultiLineString") {
                                                     /*  Both the Bowenvale Valley and Scarborough Bluffs
                                                         tracks have multi-part lines. We separate each
                                                         line/section here with coordinates of 0.0,0.0 */

                                                     coordsArray.forEachIndexed { index, array ->

                                                         val subArray = array.jsonArray
                                                         val subList = getSubList(subArray)
                                                         coordsList.addAll(subList)

                                                         if (coordsArray.size > 1) {
                                                             if (index == coordsArray.size.minus(2)) {
                                                                 coordsList.add(
                                                                     Coordinates(0.0,0.0)
                                                                 )
                                                             }
                                                         }
                                                     }

                                                 } else if (elementType == "LineString") {

                                                     val subList = getSubList(coordsArray)
                                                     coordsList.addAll(subList)

                                                 } /* elementTypes of "Point" are ignored */
                                             }

                                         } catch (exception: Exception) {
                                             Logger.e(exception) { "Shite!" }
                                         }

                                         return coordsList
                                     }

                                     private fun getSubList(array: JsonArray): List<Coordinates> {
                                         val coordsList = mutableListOf<Coordinates>()

                                         if (array.isNotEmpty()) {
                                             array.forEach { element ->
                                                 val doubles: List<Double> =
                                                     Json.decodeFromJsonElement(element)

                                                 /* Be aware that these two are reversed (by
                                                    Google Maps standards) i.e. in the .json
                                                    files, they appear as longitude,latitude */
                                                 coordsList.add(
                                                     Coordinates(
                                                         latitude  = doubles[1],
                                                         longitude = doubles[0]
                                                     )
                                                 )
                                             }
                                         }

                                         return coordsList
                                     }

                                     override fun serialize(encoder: Encoder, value: List<Coordinates>) {
                                         TODO("Not yet implemented")
                                     }
                                 }

                                 class DatabaseImpl(
                                     databaseDriverFactory: DatabaseDriverFactory,
                                     private val json: JsonUtils
                                 ) {
                                     private val database = Database(databaseDriverFactory)

                                     @Throws(Exception::class)
                                     suspend fun loadRoutes() {
                                         val fullPath = "files".plus(
                                             "/"
                                         ).plus("walking_tracks.geojson")
                                         /* Annotation reqd for readBytes.
                                            Read each file as a ByteArray */
                                         @OptIn(ExperimentalResourceApi::class)
                                         val bytes = Res.readBytes(fullPath)
                                         /* ... then decode the bytes to JSON */
                                         val jsonString = bytes.decodeToString()
                                         json.parseRoutesFile(jsonString).also { collection ->
                                             database.loadRoutes(collection)
                                         }
                                     }
                                 }
                            """.trimIndent()
                        )

                        //https://github.com/xephosbot/AnilibriaRefresh
                        KotlinCode(
                            code = $$"""
                                //Enum Generic KSerializer
                                
                                /**
                                 * Generic serializer that accepts both plain enum value
                                 * or nested object { "value": ..., "description": ... }.
                                 */
                                @OptIn(ExperimentalSerializationApi::class)
                                internal class EnumSerializer<T: Enum<T>>(
                                    private val kClass: KClass<T>,
                                    enumValues: Array<T>
                                ) : KSerializer<T?> {

                                    private val byValue: Map<String, T> = enumValues.associateBy { it.toString() }

                                    override val descriptor: SerialDescriptor =
                                        PrimitiveSerialDescriptor(kClass.simpleName ?: "Enum", PrimitiveKind.STRING).nullable

                                    override fun deserialize(decoder: Decoder): T? {
                                        val input = decoder as? JsonDecoder
                                            ?: error("EnumSerializer works only with Json decoder")

                                        val key = when(val element = input.decodeJsonElement()) {
                                            is JsonPrimitive -> {
                                                if (element.isString) {
                                                    element.content
                                                } else {
                                                    return null
                                                }
                                            }
                                            is JsonObject -> {
                                                when(val valueElement = element["value"]) {
                                                    null -> return null
                                                    is JsonNull -> return null
                                                    is JsonPrimitive -> valueElement.content
                                                    else -> error("Invalid 'value' type in enum wrapper:  $valueElement")
                                                }
                                            }
                                            is JsonNull -> return null
                                            else -> error("Unexpected JSON:  $element")
                                        }

                                        if (key.isBlank()) {
                                            return null
                                        }

                                        return byValue[key] ?: error("Unknown enum value:  $key for enum  ${kClass.simpleName}")
                                    }

                                    override fun serialize(encoder: Encoder, value: T?) {
                                        if (value == null) {
                                            encoder.encodeNull()
                                        } else {
                                            encoder.encodeString(value.toString())
                                        }
                                    }

                                    companion object {
                                        inline fun <reified T: Enum<T>> create(): EnumSerializer<T> {
                                            return EnumSerializer(T::class, enumValues<T>())
                                        }
                                    }
                                }
                                
                                @Serializable(with = AgeRatingDto.Companion.Serializer::class)
                                enum class AgeRatingDto(val value: String) {
                                    @SerialName("R0_PLUS") R0_PLUS("R0_PLUS"),
                                    @SerialName("R18_PLUS") R18_PLUS("R18_PLUS");

                                    override fun toString(): String = value

                                    companion object {
                                        object Serializer : KSerializer<AgeRatingDto?> by EnumSerializer.create<AgeRatingDto>()
                                    }
                                }
                                
                                internal fun AgeRatingDto.toDomain(): AgeRating = when (this) {
                                    AgeRatingDto.R0_PLUS -> AgeRating.R0_PLUS
                                    AgeRatingDto.R18_PLUS -> AgeRating.R18_PLUS
                                }
                            """.trimIndent()
                        )

                        //https://github.com/Luwaphemi/DataTruth.git
                        KotlinCode(
                            code = """
                                //DateTime KSerializer
                                
                                @OptIn(ExperimentalTime::class)
                                object InstantSerializer : KSerializer<kotlin.time.Instant> {
                                    override val descriptor: SerialDescriptor =
                                        PrimitiveSerialDescriptor("Instant", PrimitiveKind.STRING)

                                    @OptIn(ExperimentalTime::class)
                                    override fun serialize(encoder: Encoder, value: kotlin.time.Instant) {
                                        encoder.encodeString(value.toString())
                                    }

                                    override fun deserialize(decoder: Decoder): kotlin.time.Instant {
                                        return kotlin.time.Instant.parse(decoder.decodeString())
                                    }
                                }
                                
                                @Serializable
                                data class DataUsageModel @OptIn(ExperimentalTime::class) constructor(
                                    val id: String,
                                    
                                    @Serializable(with = InstantSerializer::class)
                                    val timestamp: kotlin.time.Instant,
                                    
                                    val mobileDataBytes: Long,
                                    val wifiDataBytes: Long,
                                    val totalBytes: Long = mobileDataBytes + wifiDataBytes,
                                    
                                    val source: DataSourceType = DataSourceType.DEVICE
                                )
                                
                                enum class DataSourceType {
                                    DEVICE,
                                    PROVIDER
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                            private val jokeJson = buildJsonObject {
                                put("id", 1)
                                put("content", "Test")
                                put("date", 1223445)

                                putJsonArray("arrayKey") {
                                    for (i in 1..10) add(i)
                                }

                                putJsonObject("objectKey") {
                                    put("key", "value")
                                }
                            }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = $$"""
                                 @Serializable
                                 data class WeatherData(
                                     val city: String,
                                     val temperature: Temperature
                                 )

                                 @Serializable(with = TemperatureSerializer::class)
                                 data class Temperature(val value: Double?)

                                 object TemperatureSerializer : KSerializer<Temperature> {
                                     override val descriptor: SerialDescriptor = PrimitiveSerialDescriptor("Temperature", PrimitiveKind.STRING)

                                     override fun deserialize(decoder: Decoder): Temperature {
                                         return try {
                                             // Try to decode as a double
                                             val number = decoder.decodeDouble()
                                             Temperature(number)
                                         } catch (e: Exception) {
                                             // If decoding as a double fails, decode as a string and handle it
                                             val stringValue = decoder.decodeString()
                                             if (stringValue == "N/A") {
                                                 Temperature(null)  // Represent "N/A" as null
                                             } else {
                                                 throw IllegalArgumentException("Unexpected temperature value: $stringValue")
                                             }
                                         }
                                     }

                                     override fun serialize(encoder: Encoder, value: Temperature) {
                                         if (value.value != null) {
                                             encoder.encodeDouble(value.value)
                                         } else {
                                             encoder.encodeString("N/A")
                                         }
                                     }
                                 }

                                 import kotlinx.serialization.decodeFromString
                                 import kotlinx.serialization.json.Json

                                 fun main() {
                                     val json1 = ""$${'"'}{
                                         "city": "Berlin",
                                         "temperature": 25
                                     }""$${'"'}

                                     val json2 = ""$${'"'}{
                                         "city": "Berlin",
                                         "temperature": "N/A"
                                     }""$${'"'}

                                     val format = Json { ignoreUnknownKeys = true }

                                     val weatherData1 = format.decodeFromString<WeatherData>(json1)
                                     println(weatherData1)  // Output: WeatherData(city=Berlin, temperature=Temperature(value=25.0))

                                     val weatherData2 = format.decodeFromString<WeatherData>(json2)
                                     println(weatherData2)  // Output: WeatherData(city=Berlin, temperature=Temperature(value=null))
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                class BasicFormValidationUC {
                                    operator fun invoke(text: String) =
                                        if (text.isBlank()) FormValidation(false, "This field is required")
                                        else FormValidation()
                                }

                                data class FormValidation(
                                    val isSuccess: Boolean = true,
                                    val errorMessage: String? = null
                                )
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                import kotlinx.serialization.DeserializationStrategy
                                import kotlinx.serialization.ExperimentalSerializationApi
                                import kotlinx.serialization.SerializationStrategy
                                import kotlinx.serialization.json.Json
                                import kotlinx.serialization.json.decodeFromStream
                                import java.io.InputStream
                                import javax.inject.Inject

                                @OptIn(ExperimentalSerializationApi::class)
                                class JsonSerializer @Inject constructor() {

                                    private val json = Json {
                                        isLenient = true // Reason: In case some formats don't conform to the strict RFC-4627 standard
                                        ignoreUnknownKeys = true // Allows to specify minimal models
                                        encodeDefaults = true // Default parameters are still encoded
                                        explicitNulls =
                                            false // Nulls are not encoded. Decode absent values into nulls if no default set.
                                    }

                                    fun <T> encode(serializer: SerializationStrategy<T>, data: T) =
                                        json.encodeToString(serializer, data)

                                    fun <T> decode(serializer: DeserializationStrategy<T>, data: String) =
                                        json.decodeFromString(serializer, data)

                                    fun <T> decodeStream(serializer: DeserializationStrategy<T>, data: InputStream) =
                                        json.decodeFromStream(serializer, data)
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Random File Name

                                private fun getRandomString(length: Int): String {
                                    val charset = ('a'..'z') + ('A'..'Z') + ('0'..'9')
                                    return (1..length)
                                        .map { charset.random() }
                                        .joinToString("")
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                              val weightList = (50..200 step 10).map { it.toDouble() }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Read Json File

                                 import android.content.Context
                                 import com.google.gson.Gson
                                 import com.google.gson.reflect.TypeToken
                                 import kotlinx.coroutines.CoroutineDispatcher
                                 import kotlinx.coroutines.ensureActive
                                 import kotlinx.coroutines.withContext
                                 import timber.log.Timber
                                 import java.io.BufferedReader
                                 import java.io.InputStreamReader

                                 suspend inline fun <reified T> parseJson(
                                     path: String,
                                     context: Context,
                                     dispatcher: CoroutineDispatcher,
                                 ): T = withContext(dispatcher) {
                                     val file = context.assets.open(path)
                                     val bufferedReader = BufferedReader(InputStreamReader(file))
                                     val stringBuilder = StringBuilder()
                                     bufferedReader.useLines { lines ->
                                         ensureActive()
                                         lines.forEach { stringBuilder.append(it) }
                                     }
                                     val jsonString = stringBuilder.toString()
                                     return@withContext Gson().fromJson(jsonString, object : TypeToken<T>() {}.type)
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 open class Parent

                                 class Child : Parent()

                                 fun Parent.printMessage() = println("Parent Extension")
                                 fun Child.printMessage() = println("Child Extension")

                                 fun main(){
                                    val parent: Parent = Child()
                                    parent. printMessage()
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Count Vowels

                                fun countVowels(input: String): Int {
                                    return input.count { it in "aeiouAEIOU" }
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 //Sum of Digits

                                 //1
                                 fun sumOfDigits(number: Int): Int {
                                    return number.toString().sumOf { it.digitToInt() }
                                 }
                                 
                                 //2
                                 fun sumOfDigits(n: Int): Int {
                                     require(n >= 0) { "Input must be a non-negative integer." }
                                     return n.toString().map { it - '0' }.sum()
                                 }
                                 
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Check if a Number is Prime

                                fun isPrime(n: Int): Boolean {
                                    if (n <= 1) return false
                                    for (i in 2..Math.sqrt(n.toDouble()).toInt()) {
                                        if (n % i == 0) return false
                                    }
                                    return true
                                }
                            """.trimIndent()
                        )



                        KotlinCode(
                            code = """
                                 //Find Missing Number in Array
                                  
                                 //1 
                                 fun main() {
                                    val arr = intArrayOf(1,2,4,5)
                                    val n = 5
                                    println(findMissing(arr,n))
                                 }
                                 
                                 fun findMissing(arr: IntArray, n: Int) =
                                    (1..n).reduce(Int::xor) xor arr.reduce(Int::xor)
                        
                                //2
                                fun findMissingNumber(arr: Array<Int>, n: Int): Int {
                                    val totalSum = (n * (n + 1)) / 2
                                    val arrSum = arr.sum()
                                    return totalSum - arrSum
                                }

                                val result = findMissingNumber(arrayOf(1, 2, 4, 5), 5)
                                println(result)  // Output: 3   
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Find Missing id in List
                                 fun findMissingId(ids: List<Int>): Int {
                                     val n = ids.size + 1
                                     val expectedSum = n * (n + 1) / 2
                                     val actualSum = ids.sum()
                                     return expectedSum - actualSum
                                 }

                                 fun main() {
                                     val ids = listOf(1, 2, 3, 5)
                                     println(findMissingId(ids)) // Output: 4
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Group Anagrams

                                fun groupAnagrams(strs: List<String>): List<List<String>> {
                                    val map = mutableMapOf<String, MutableList<String>>()
                                    for (str in strs) {
                                        val sortedStr = str.toCharArray().sorted().joinToString("")
                                        map.computeIfAbsent(sortedStr) { mutableListOf() }.add(str)
                                    }
                                    return map.values.toList()
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Check if Two Strings Are Anagrams

                                fun areAnagrams(str1: String, str2: String): Boolean {
                                    return str1.toCharArray().sorted() == str2.toCharArray().sorted()
                                }

                                val result = areAnagrams("listen", "silent")
                                println(result)  // Output: true

                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Calculate Factorial

                                fun factorial(n: Int): Int {
                                    return if (n <= 1) 1 else n * factorial(n - 1)
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //BinarySearch

                                 class BinarySearch {
                                     private fun binarySearchRecursive(list: List<Int>, start: Int, end: Int, target: Int): Int {
                                         if (start == end) {
                                             return if (list[start] == target) {
                                                 start
                                             } else {
                                                 -1
                                             }
                                         }

                                         val middleIndex = (start + end) / 2
                                         return if (target <= list[middleIndex]) {
                                             binarySearchRecursive(list, start, middleIndex, target)
                                         } else {
                                             binarySearchRecursive(list, middleIndex + 1, end, target)
                                         }
                                     }

                                     fun searchRecursive(list: List<Int>, target: Int): Int {
                                         return binarySearchRecursive(list, 0, list.size - 1, target)
                                     }

                                     private fun binarySearchIterative(list: List<Int>, target: Int): Int {
                                         var start = 0
                                         var end = list.size - 1

                                         while (start < end) {
                                             val middleIndex = (start + end) / 2
                                             if (target <= list[middleIndex]) {
                                                 end = middleIndex
                                             } else {
                                                 start = middleIndex + 1
                                             }
                                         }

                                         return if (target == list[end]) end else -1
                                     }

                                     fun searchIterative(list: List<Int>, target: Int): Int {
                                         return binarySearchIterative(list, target)
                                     }
                                 }

                                 fun main() {
                                     val list = BinarySearchTests.test5()
                                     val index = BinarySearch().searchIterative(list, 5)
                                     println(index)
                                 }

                                 object BinarySearchTests {
                                     fun test1() = listOf(1)
                                     fun test2() = listOf(1, 1)
                                     fun test3() = listOf(1, 2)
                                     fun test4() = listOf(1, 2, 3, 4, 5, 6, 7, 8, 9, 10)
                                     fun test5() = listOf(1, 2, 3, 4, 5, 5, 6, 7, 8, 9, 10)
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Sorting

                                class Sort {
                                    fun heapSortNewList(list: List<Int>): List<Int> {
                                        val orderedList = list.toMutableList()
                                        maxHeap(orderedList, orderedList.size)

                                        var lastPosition = orderedList.size - 1
                                        while(lastPosition > 0) {
                                            swap(orderedList, 0, lastPosition)
                                            lastPosition--
                                            maxHeap(orderedList, lastPosition + 1)
                                        }

                                        return orderedList
                                    }

                                    fun heapSortInPlace(list: MutableList<Int>) {
                                        maxHeap(list, list.size)

                                        var lastPosition = list.size - 1
                                        while(lastPosition > 0) {
                                            swap(list, 0, lastPosition)
                                            lastPosition--
                                            maxHeap(list, lastPosition + 1)
                                        }
                                    }

                                    private fun maxHeap(heap: MutableList<Int>, n: Int) {
                                        val start = (n / 2) - 1

                                        (start downTo 0).forEach {
                                            maxHeapify(heap, it, n)
                                        }
                                    }

                                    private fun swap(heap: MutableList<Int>, current: Int, new: Int) {
                                        val aux = heap[current]
                                        heap[current] = heap[new]
                                        heap[new] = aux
                                    }


                                    private fun maxHeapify(heap: MutableList<Int>, i: Int, n: Int) {
                                        var largest = i
                                        val leftChild = (2 * i) + 1
                                        val rightChild = (2 * i) + 2

                                        if (leftChild < n && heap[leftChild] > heap[largest]) largest = leftChild
                                        if (rightChild < n && heap[rightChild] > heap[largest]) largest = rightChild

                                        if (largest != i) {
                                            swap(heap, i, largest)
                                            maxHeapify(heap, largest, n)
                                        }
                                    }

                                    private fun merge(list1: List<Int>, list2: List<Int>): List<Int> {
                                        var i = 0
                                        var j = 0
                                        val mergedList = mutableListOf<Int>()

                                        while(i < list1.size && j < list2.size) {
                                            if (list1[i] < list2[j]) {
                                                mergedList.add(list1[i])
                                                i++
                                            } else {
                                                mergedList.add(list2[j])
                                                j++
                                            }
                                        }

                                        if (i < list1.size) mergedList.addAll(list1.subList(i, list1.size))
                                        if (j < list2.size) mergedList.addAll(list2.subList(j, list2.size))

                                        return mergedList
                                    }

                                    private fun mergeSort(list: List<Int>, start: Int, end: Int): List<Int> {
                                        if (start == end) {
                                            return listOf(list[start])
                                        }

                                        val middleIndex = (start + end) / 2

                                        val list1 = mergeSort(list, start, middleIndex)
                                        val list2 = mergeSort(list, middleIndex + 1, end)

                                        return merge(list1, list2)
                                    }

                                    fun mergeSort(list: List<Int>): List<Int> {
                                        if (list.isEmpty()) return list
                                        return mergeSort(list, 0, list.size - 1)
                                    }
                                }

                                fun main() {
                                    val result = Sort().mergeSort(SortTests.test3())
                                    print(result)
                                }

                                object SortTests {
                                    fun test1() = mutableListOf(3, 2, 1)
                                    fun test2() = mutableListOf(10, 9, 8, 7, 6, 5, 4, 3, 2, 1)
                                    fun test3() = mutableListOf(2, 4, 1, 10, 1, 2, 5, 7, 8, 1, 9)
                                    fun test4() = mutableListOf(1)
                                    fun test5() = mutableListOf<Int>()
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                fun mergeSortedLists(list1: List<Int>, list2: List<Int>): List<Int> {
                                    val result = mutableListOf<Int>()
                                    var i = 0
                                    var j = 0

                                    while (i < list1.size && j < list2.size) {
                                        if (list1[i] <= list2[j]) {
                                            result.add(list1[i])
                                            i++
                                        } else {
                                            result.add(list2[j])
                                            j++
                                        }
                                    }

                                    while (i < list1.size) {
                                        result.add(list1[i])
                                        i++
                                    }

                                    while (j < list2.size) {
                                        result.add(list2[j])
                                        j++
                                    }

                                    return result
                                }

                                fun main() {
                                    val list1 = listOf(1, 3, 5)
                                    val list2 = listOf(2, 4, 6)
                                    println(mergeSortedLists(list1, list2)) // Output: [1, 2, 3, 4, 5, 6]
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 //Merge Strings
                                 
                                public class MergeStrings {
                                    public static void main(String[] args) {
                                        String a = "abcd";
                                        String b = "1234";
                                        StringBuilder result = new StringBuilder();

                                        for(int i = 0; i < a.length(); i++) {
                                            result.append(a.charAt(i)).append(b.charAt(i));
                                        }

                                        System.out.println(result.toString());
                                    }
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Find Distance

                                inline fun findBearing(lat1: Double, lng1: Double, lat2: Double, lng2: Double): Double {
                                    val dLon = lng2 - lng1

                                    val y = sin(dLon) * cos(lat2)
                                    val x = cos(lat1) * sin(lat2) - sin(lat1) * cos(lat2) * cos(dLon)

                                    var brng = atan2(y, x)

                                    brng = brng.toDegrees()
                                    brng = (brng + 360) % 360

                                    return -(brng - 180) + 180
                                }

                                inline fun findDistanceToSegment(latP: Double, lngP: Double, lat1: Double, lng1: Double, lat2: Double, lng2: Double): Double {
                                    val a = findDistance(latP, lngP, lat1, lng1)
                                    val b = findDistance(latP, lngP, lat2, lng2)
                                    val c = findDistance(lat1, lng1, lat2, lng2)

                                    val s = (a + b + c) / 2
                                    val area = sqrt(s * (s - a) * (s - b) * (s - c))

                                    val distanceToLine = (2 * area) / c

                                    return distanceToLine
                                }

                                fun distanceInKm(lat1: Double, lon1: Double, lat2: Double, lon2: Double): Double {
                                    val theta = lon1 - lon2
                                    var dist =
                                        sin(deg2rad(lat1)) * sin(deg2rad(lat2)) + cos(deg2rad(lat1)) * cos(deg2rad(lat2)) * cos(
                                            deg2rad(theta)
                                        )
                                    dist = acos(dist)
                                    dist = rad2deg(dist)
                                    dist *= 60 * 1.1515
                                    dist *= 1.609344
                                    return dist
                                }

                                private fun deg2rad(deg: Double): Double {
                                    return deg * Math.PI / 180.0
                                }

                                private fun rad2deg(rad: Double): Double {
                                    return rad * 180.0 / Math.PI
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                sealed class RequestState<out T> {
                                    data object Idle : RequestState<Nothing>()
                                    data object Loading : RequestState<Nothing>()
                                    data class Success<out T>(val data: T) : RequestState<T>()
                                    data class Error(val message: String) : RequestState<Nothing>()

                                    fun isLoading(): Boolean = this is Loading
                                    fun isError(): Boolean = this is Error
                                    fun isSuccess(): Boolean = this is Success

                                    fun getSuccessData() = (this as Success).data
                                    fun getErrorMessage(): String = (this as Error).message
                                }
                            """.trimIndent()
                        )

                        //Java 8
                        //https://medium.com/@ketan.patel_46870
                        KotlinCode(
                            code = """
                                //Find anagrams

                                List<String> words = Arrays.asList("listen", "silent", "enlist", "rat", "tar", "god", "dog", "evil", "vile", "veil");

                                Map<String, List<String>> anagrams =  words.stream()
                                            .collect(Collectors.groupingBy(word -> {
                                                char[] charArray = word.toCharArray();
                                                Arrays.sort(charArray); // Sort the characters
                                                return new String(charArray); // Return the sorted string
                                            }));

                                anagrams.values().stream()
                                                .filter(group -> group.size() > 1) // Filter only groups with more than one anagram
                                                .forEach(System.out::println); // Output the anagram groups

                                // Output
                                // [silent, listen, enlist]
                                // [tar, rat]
                                // [dog, god]
                                // [vile, evil, veil]
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Second highest salary

                                 List<Employee> employees = Arrays.asList(
                                             new Employee("Alice", 70000),
                                             new Employee("Bob", 80000),
                                             new Employee("Charlie", 60000),
                                             new Employee("David", 90000),
                                             new Employee("Eve", 80000)
                                         );

                                 Optional<Employee> secondHighest =  employees.stream()
                                             .sorted(Comparator.comparingDouble(Employee::getSalary).reversed())
                                             .distinct() // To avoid duplicates in case of equal salaries
                                             .skip(1) // Skip the highest salary
                                             .findFirst(); // Get the second highest salary
                                 // Output
                                 // Employee{name='Bob', salary=80000.0}
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Remove duplicates and sort a list 
                                
                                fun main() {
                                    val users = listOf(
                                        User(2, "Alice"),
                                        User(1, "Bob"),
                                        User(2, "Alice"),
                                        User(3, "Charlie")
                                    )

                                    // Remove duplicates (by id) and sort by name
                                    val result = users
                                        .distinctBy { it.id }
                                        .sortedBy { it.name }

                                    result.forEach { println(it) }
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Find the Second Largest Element in an Array

                                fun secondLargest(arr: Array<Int>): Int? {
                                    val sortedArr = arr.distinct().sorted()
                                    return if (sortedArr.size > 1) sortedArr[sortedArr.size - 2] else null
                                }

                                val result = secondLargest(arrayOf(1, 3, 4, 2, 5))
                                println(result)  // Output: 4
                            """.trimIndent()
                        )

                        KotlinCode(
                            //All individual words
                            code = """
                                List<String> sentences = Arrays.asList("Hello world", "Java 8 Streams", "flatMap example");

                                List<String> words = sentences.stream()
                                    .flatMap(sentence -> Arrays.stream(sentence.split(" ")))
                                    .collect(Collectors.toList());

                                System.out.println(words);
                                // Output: [Hello, world, Java, 8, Streams, flatMap, example]
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Check if all elements in a List<Integer> are positive.

                                List<Integer> numbers = Arrays.asList(1, 2, 3, 4, 5);
                                boolean allPositive = numbers.stream().allMatch(n -> n > 0);
                                System.out.println(allPositive);
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Reverse alphabetical order

                                List<String> words = Arrays.asList("apple", "banana", "cherry");
                                List<String> sortedWords = words.stream()
                                                                .sorted(Comparator.reverseOrder())
                                                                .collect(Collectors.toList());
                                System.out.println(sortedWords);
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Find the First Non-Repeated Character in a String

                                fun firstNonRepeatedCharacter(input: String): Char? {
                                    val charCount = mutableMapOf<Char, Int>()
                                    input.forEach { char -> charCount[char] = charCount.getOrDefault(char, 0) + 1 }
                                    return input.find { char -> charCount[char] == 1 }
                                }

                                val result = firstNonRepeatedCharacter("swiss")
                                println(result)  // Output: w
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Sum of Digits in a Number

                                fun sumOfDigits(n: Int): Int {
                                    return n.toString().map { it.toString().toInt() }.sum()
                                }

                                val result = sumOfDigits(12345)
                                println(result)  // Output: 15
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Flatten a Nested List of Integers

                                 fun flatten(list: List<List<Int>>): List<Int> {
                                     return list.flatten()
                                 }

                                 val result = flatten(listOf(listOf(1, 2), listOf(3, 4), listOf(5, 6)))
                                 println(result)  // Output: [1, 2, 3, 4, 5, 6]
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Find Common Elements in Two Arrays

                                fun findCommonElements(arr1: Array<Int>, arr2: Array<Int>): Array<Int> {
                                    return arr1.intersect(arr2.toSet()).toTypedArray()
                                }

                                val result = findCommonElements(arrayOf(1, 2, 3, 4), arrayOf(3, 4, 5, 6))
                                println(result.joinToString())  // Output: 3, 4
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Find the Largest Palindrome in a String

                                fun largestPalindrome(input: String): String {
                                    var largestPalindrome = ""

                                    for (i in input.indices) {
                                        for (j in i + 1..input.length) {
                                            val substring = input.substring(i, j)
                                            if (substring == substring.reversed() && substring.length > largestPalindrome.length) {
                                                largestPalindrome = substring
                                            }
                                        }
                                    }
                                    return largestPalindrome
                                }

                                val result = largestPalindrome("babad")
                                println(result)  // Output: bab (or aba)
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Find the Missing Character in a String

                                fun findMissingCharacter(input: String): Char? {
                                    val fullAlphabet = "abcdefghijklmnopqrstuvwxyz"
                                    for (char in fullAlphabet) {
                                        if (char !in input) return char
                                    }
                                    return null
                                }

                                val result = findMissingCharacter("thequickbrownfoxjumpsoverlazydog")
                                println(result)  // Output: 's' (if 's' was missing)
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Count Occurrences of Each Character in a String

                                fun countCharacterOccurrences(input: String): Map<Char, Int> {
                                    return input.groupingBy { it }.eachCount()
                                }

                                val result = countCharacterOccurrences("hello")
                                println(result)  // Output: {h=1, e=1, l=2, o=1}
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Find the Longest Substring Without Repeating Characters
                                //1
                                fun longestSubstringWithoutRepeating(input: String): String {
                                    var start = 0
                                    var maxLength = 0
                                    var maxSubstring = ""
                                    val charSet = mutableSetOf<Char>()

                                    for (end in input.indices) {
                                        while (input[end] in charSet) {
                                            charSet.remove(input[start])
                                            start++
                                        }
                                        charSet.add(input[end])
                                        if (end - start + 1 > maxLength) {
                                            maxLength = end - start + 1
                                            maxSubstring = input.substring(start, end + 1)
                                        }
                                    }
                                    return maxSubstring
                                }

                                val result = longestSubstringWithoutRepeating("abcabcbb")
                                println(result)  // Output: "abc"
                                
                                //2
                                fun lengthOfLongestSubstring(s: String): Int {
                                    val lastSeen = mutableMapOf<Char, Int>()
                                    var left = 0
                                    var maxLen = 0

                                    for ((right, ch) in s.withIndex()) {
                                        // If the character was seen and is inside the current window
                                        if (ch in lastSeen && lastSeen[ch]!! >= left) {
                                            left = lastSeen[ch]!! + 1
                                        }
                                        lastSeen[ch] = right
                                        maxLen = maxOf(maxLen, right - left + 1)
                                    }

                                    return maxLen
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                // Longest Subarray with Sum K
                                 
                                 fun longestSubarraySumK(arr: IntArray, k: Int): Int {
                                     val map = HashMap<Int, Int>()
                                     var sum = 0
                                     var maxLen = 0
                                     for (i in arr.indices) {
                                         sum += arr[i]
                                         if (sum == k) maxLen = i + 1
                                         if (!map.containsKey(sum)) map[sum] = i
                                         if (map.containsKey(sum - k)) {
                                             maxLen = maxOf(maxLen, i - map[sum - k]!!)
                                         }
                                     }
                                     return maxLen
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                               //Find the Element That Appears Once in an Array

                                fun findSingleElement(arr: Array<Int>): Int {
                                    return arr.reduce { acc, num -> acc xor num }
                                }

                                val result = findSingleElement(arrayOf(4, 1, 2, 1, 2))
                                println(result)  // Output: 4
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 class Solution {
                                     fun twoSum(numbers: IntArray, target: Int): IntArray {
                                         var left = 0
                                         var right = numbers.lastIndex

                                         while (left < right) {
                                             val sum = numbers[left] + numbers[right]
                                             when {
                                                 sum == target -> return intArrayOf(left + 1, right + 1)
                                                 sum < target -> left++
                                                 else -> right--
                                             }
                                         }
                                         return intArrayOf(-1, -1)
                                     }
                                 }

                                 fun main() {
                                     val solution = Solution()
                                     val numbers = intArrayOf(2, 7, 11, 15)
                                     val target = 9
                                     val result = solution.twoSum(numbers, target)
                                     println(result.joinToString())  // Output: 1, 2
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Generate Fibonacci Sequence Up to n

                                fun generateFibonacci(n: Int): List<Int> {
                                    val fibonacci = mutableListOf(0, 1)
                                    for (i in 2 until n) {
                                        fibonacci.add(fibonacci[i - 1] + fibonacci[i - 2])
                                    }
                                    return fibonacci
                                }

                                val result = generateFibonacci(10)
                                println(result)  // Output: [0, 1, 1, 2, 3, 5, 8, 13, 21, 34]
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                               //Find the Maximum Product of Two Integers in an Array

                                fun maxProduct(arr: Array<Int>): Int {
                                    val sortedArr = arr.sorted()
                                    return sortedArr[sortedArr.size - 1] * sortedArr[sortedArr.size - 2]
                                }

                                val result = maxProduct(arrayOf(1, 3, 5, 7, 9))
                                println(result)  // Output: 63
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                               //Check if a String is a Valid Number

                               fun isValidNumber(input: String): Boolean {
                                   return input.toDoubleOrNull() != null
                               }

                               val result = isValidNumber("123.45")
                               println(result)  // Output: true
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Find the First Non-Repeated Character in a String

                                fun firstNonRepeatedChar(input: String): Char? {
                                    val charCount = input.groupingBy { it }.eachCount()
                                    return input.find { charCount[it] == 1 }
                                }

                                val result = firstNonRepeatedChar("swiss")
                                println(result)  // Output: w
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //String Rotation Check
                                 fun isRotation(s1: String, s2: String): Boolean {
                                     return (s1.length == s2.length) && (s1 + s1).contains(s2)
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                               //Find the Duplicates in an Array

                                 fun findDuplicates(arr: Array<Int>): List<Int> {
                                     val seen = mutableSetOf<Int>()
                                     val duplicates = mutableListOf<Int>()

                                     for (num in arr) {
                                         if (num in seen) {
                                             duplicates.add(num)
                                         } else {
                                             seen.add(num)
                                         }
                                     }

                                     return duplicates
                                 }

                                 val result = findDuplicates(arrayOf(1, 2, 3, 4, 2, 5, 3))
                                 println(result.joinToString())  // Output: 2, 3
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                               //Find the Majority Element in an Array

                                 fun majorityElement(nums: Array<Int>): Int {
                                     var count = 0
                                     var candidate = 0

                                     for (num in nums) {
                                         if (count == 0) candidate = num
                                         count += if (num == candidate) 1 else -1
                                     }

                                     return candidate
                                 }

                                 val result = majorityElement(arrayOf(3, 3, 4, 2, 4, 4, 2, 4, 4))
                                 println(result)  // Output: 4
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                               //Find All Permutations of a String

                                fun permute(str: String): List<String> {
                                    if (str.length == 1) return listOf(str)

                                    val result = mutableListOf<String>()
                                    for (i in str.indices) {
                                        val char = str[i]
                                        val remaining = str.substring(0, i) + str.substring(i + 1)
                                        for (perm in permute(remaining)) {
                                            result.add(char + perm)
                                        }
                                    }
                                    return result
                                }

                                val result = permute("abc")
                                println(result.joinToString())  // Output: abc, acb, bac, bca, cab, cba
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                               //Find the Missing Number in an Array of Consecutive Numbers

                                fun findMissingNumber(arr: IntArray): Int {
                                    val n = arr.size + 1
                                    val totalSum = n * (n + 1) / 2
                                    val arrSum = arr.sum()
                                    return totalSum - arrSum
                                }

                                val result = findMissingNumber(intArrayOf(1, 2, 4, 5, 6))
                                println(result)  // Output: 3
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Find the Longest Common Prefix of a List of Strings

                                fun longestCommonPrefix(strs: List<String>): String {
                                    if (strs.isEmpty()) return ""
                                    var prefix = strs[0]

                                    for (str in strs) {
                                        while (!str.startsWith(prefix)) {
                                            prefix = prefix.dropLast(1)
                                            if (prefix.isEmpty()) return ""
                                        }
                                    }
                                    return prefix
                                }

                                val result = longestCommonPrefix(listOf("flower", "flow", "flight"))
                                println(result)  // Output: "fl"
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Merge Alternating Characters from Two Strings

                                un mergeStrings(a: String, b: String): String {
                                    val result = StringBuilder()
                                    val length = minOf(a.length, b.length)

                                    // Iterate through both strings and add alternating characters to the result
                                    for (i in 0 until length) {
                                        result.append(a[i])
                                        result.append(b[i])
                                    }

                                    // If 'a' is longer, append the remaining characters
                                    if (a.length > b.length) {
                                        result.append(a.substring(length))
                                    }

                                    // If 'b' is longer, append the remaining characters
                                    if (b.length > a.length) {
                                        result.append(b.substring(length))
                                    }

                                    return result.toString()
                                }

                                fun main() {
                                    val a = "abcd"
                                    val b = "1234"
                                    val output = mergeStrings(a, b)
                                    println(output)  // Output: a1b2c3d4
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Find the Third Largest Element in an Array

                                fun thirdLargestElement(arr: IntArray): Int? {
                                    if (arr.size < 3) return null  // Return null if there are fewer than 3 elements

                                    var first = Int.MIN_VALUE
                                    var second = Int.MIN_VALUE
                                    var third = Int.MIN_VALUE

                                    for (num in arr) {
                                        if (num > first) {
                                            third = second
                                            second = first
                                            first = num
                                        } else if (num > second && num != first) {
                                            third = second
                                            second = num
                                        } else if (num > third && num != second) {
                                            third = num
                                        }
                                    }

                                    return if (third != Int.MIN_VALUE) third else null
                                }

                                fun main() {
                                    val arr = intArrayOf(12, 35, 1, 10, 34, 1)
                                    val result = thirdLargestElement(arr)
                                    if (result != null) {
                                        println(result)
                                    } else {
                                        println("Array has fewer than 3 distinct elements.")
                                    }
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Check if One Array is a Subset of Another

                                fun isSubset(arr1: IntArray, arr2: IntArray): Boolean {
                                    // Convert arr1 to a set for faster lookup
                                    val set1 = arr1.toHashSet()

                                    // Check if each element of arr2 is in arr1
                                    for (element in arr2) {
                                        if (!set1.contains(element)) {
                                            return false  // arr2 contains an element not in arr1
                                        }
                                    }
                                    return true  // All elements of arr2 are in arr1
                                }

                                fun main() {
                                    val arr1 = intArrayOf(1, 2, 3, 4, 5)
                                    val arr2 = intArrayOf(2, 4, 5)

                                    val result = isSubset(arr1, arr2)
                                    if (result) {
                                        println("arr2 is a subset of arr1.")
                                    } else {
                                        println("arr2 is NOT a subset of arr1.")
                                    }
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                fun nationalDutchFlagSort(arr: Array<String>): Array<String> {
                                    var low = 0
                                    var mid = 0
                                    var high = arr.size - 1
                                    val pivot = "red" // or any other value in the array

                                    while (mid <= high) {
                                        when {
                                            arr[mid] == pivot -> {
                                                arr[low] = arr[mid].also { arr[mid] = arr[low] }
                                                low++
                                                mid++
                                            }
                                            arr[mid] == "white" -> mid++
                                            else -> {
                                                arr[mid] = arr[high].also { arr[high] = arr[mid] }
                                                high--
                                            }
                                        }
                                    }

                                    return arr
                                }

                                val arr = arrayOf("white", "blue", "red", "red", "white", "blue")
                                val sortedArr = nationalDutchFlagSort(arr)
                                println(sortedArr.joinToString())

                                //output
                                red, red, white, white, blue, blue
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                /*
                                Input: nums = [1,2,3,4]
                                Output: [1,3,6,10]
                                Explanation: Running sum is obtained as follows: [1, 1+2, 1+2+3, 1+2+3+4].
                                 */

                                class RunningSumIn1dArray {
                                    companion object {
                                        fun runningSum(nums : IntArray) : IntArray {
                                            val newArray = IntArray(nums.size)
                                            for(i in nums.indices){
                                                var count = 0
                                                for(j in 0..i){
                                                    count += nums[j]
                                                    println(count)
                                                }
                                                newArray[i] = count
                                            }
                                            return newArray
                                        }
                                    }
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 //Find the Kth Largest Element in App Metrics
                                 import java.util.PriorityQueue

                                 fun findKthLargest(nums: IntArray, k: Int): Int {
                                     val minHeap = PriorityQueue<Int>()
                                     for (num in nums) {
                                         minHeap.add(num)
                                         if (minHeap.size > k) {
                                             minHeap.poll()
                                         }
                                     }
                                     return minHeap.peek()
                                 }

                                 fun main() {
                                     val metrics = intArrayOf(3, 2, 1, 5, 6, 4)
                                     println(findKthLargest(metrics, 2)) // Output: 5
                                 }
                                 11. Check Palindrome in User Input
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Top K Frequent App Features Used

                                fun topKFrequentFeatures(features: List<String>, k: Int): List<String> {
                                    val frequencyMap = features.groupingBy { it }.eachCount()
                                    val pq = PriorityQueue<Map.Entry<String, Int>>(compareBy { it.value })

                                    for (entry in frequencyMap.entries) {
                                        pq.add(entry)
                                        if (pq.size > k) {
                                            pq.poll()
                                        }
                                    }

                                    return pq.map { it.key }
                                }

                                fun main() {
                                    val features = listOf("login", "signup", "login", "profile", "login", "signup")
                                    println(topKFrequentFeatures(features, 2)) // Output: ["signup", "login"]
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 //Longest Consecutive Sequence of User Activity

                                 fun longestConsecutive(nums: IntArray): Int {
                                     val numSet = nums.toSet()
                                     var longest = 0

                                     for (num in numSet) {
                                         if (num - 1 !in numSet) { // Start of a sequence
                                             var currentNum = num
                                             var currentStreak = 1

                                             while (currentNum + 1 in numSet) {
                                                 currentNum++
                                                 currentStreak++
                                             }

                                             longest = maxOf(longest, currentStreak)
                                         }
                                     }
                                     return longest
                                 }

                                 fun main() {
                                     val timestamps = intArrayOf(100, 4, 200, 1, 3, 2)
                                     println(longestConsecutive(timestamps)) // Output: 4 (Sequence: 1, 2, 3, 4)
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Rearrange App Screens to Avoid Repetition

                                import java.util.PriorityQueue

                                fun rearrangeScreens(screens: List<String>): List<String> {
                                    val freqMap = screens.groupingBy { it }.eachCount()
                                    val pq = PriorityQueue<Map.Entry<String, Int>>(compareByDescending { it.value })
                                    pq.addAll(freqMap.entries)

                                    val result = mutableListOf<String>()
                                    var prev: Map.Entry<String, Int>? = null

                                    while (pq.isNotEmpty()) {
                                        val current = pq.poll()
                                        result.add(current.key)

                                        if (prev != null && prev.value > 0) {
                                            pq.offer(prev)
                                        }

                                        prev = current.copy(value = current.value - 1)
                                    }

                                    return if (result.size == screens.size) result else emptyList()
                                }

                                fun main() {
                                    val screens = listOf("A", "A", "B", "B", "C")
                                    println(rearrangeScreens(screens)) // Output: [A, B, A, C, B] or similar valid result
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Rotate App Content by K Positions

                                fun rotateContent(content: List<Int>, k: Int): List<Int> {
                                    val n = content.size
                                    val rotations = k % n
                                    return content.takeLast(rotations) + content.dropLast(rotations)
                                }

                                fun main() {
                                    val content = listOf(1, 2, 3, 4, 5)
                                    println(rotateContent(content, 2)) // Output: [4, 5, 1, 2, 3]
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //DSL Based Shopping Cart

                                 class ShoppingCart {
                                     private val categories = mutableListOf<Category>() // Holds categories

                                     // Method to create a category
                                     fun category(name: String, init: Category.() -> Unit) {
                                         val category = Category(name) // Create a Category instance
                                         category.init()               // Apply the lambda to the Category
                                         categories.add(category)      // Add the category to the cart
                                     }

                                     // Calculate the total price of all categories in the cart
                                     fun total(): String {
                                         val totalCost = categories.sumOf { it.totalCost() }
                                         return "Total"
                                     }

                                     // Nested Category class
                                     class Category(val name: String) {
                                         private val items = mutableListOf<Item>()

                                         fun addItem(name: String, quantity: Int, price: Double) {
                                             items.add(Item(name, quantity, price))
                                         }

                                         fun totalCost(): Double {
                                             return items.sumOf { it.quantity * it.price }
                                         }
                                     }

                                     // Nested Item class
                                     data class Item(val name: String, val quantity: Int, val price: Double)
                                 }

                                 fun main() {
                                     val cart = shoppingCart {
                                         category("Fruits") {
                                             addItem("Apple", 3, 2.5) // Adds 3 Apples
                                             addItem("Banana", 2, 1.2) // Adds 2 Bananas
                                         }
                                         category("Vegetables") {
                                             addItem("Carrot", 4, 0.8) // Adds 4 Carrots
                                             addItem("Potato", 3, 0.5) // Adds 3 Potatoes
                                         }
                                     }

                                     println(cart.total())
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Tax Calculation

                                interface TaxStrategy {
                                	fun applyTax (price: Double): Double
                                }

                                class FoodTax : TaxStrategy
                                	override fun applyTax(price: Double) = price * 1.05
                                }

                                class ElectronicsTax : TaxStrategy {
                                	override fun applyTax(price: Double) = price * 1.18
                                }
                                class NoTax : TaxStrategy {
                                	override fun applyTax(price: Double) = price
                                }

                                // Use it in the Product class
                                class Product val name: String, val basePrice: Double, private val taStrategy: TaxStrategy)
                                {
                                    val priceWithTax: Double
                                    					get = taxStrategy.applyTax(basePrice)
                                }

                                fun main() {
                                    val apple = Product("Apple", 100.0, FoodTax())
                                    val laptop = Product("Laptop", 1000.0, ElectronicsTax())
                                    val book = Product("Book", 500.0, NoTax())

                                    //apple.priceWithTax
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = $$"""
                                fun News.timeSince(
                                    now: Long = Calendar.getInstance().timeInMillis,
                                    timeZone: TimeZone = Calendar.getInstance().timeZone
                                ): String {
                                    //2025-01-01T15:16:40+00:00
                                    val date = this.date.toDate() ?: return ""

                                    val newsDate = Calendar.getInstance().apply {
                                        time = date
                                    }
                                    val timeDifferenceInMillis = now - newsDate.timeInMillis
                                    val seconds = timeDifferenceInMillis / 1000
                                    val minutes = seconds / 60
                                    val hours = minutes / 60
                                    val days = hours / 24
                                    val weeks = days / 7
                                    return when {
                                        weeks > 4 || timeDifferenceInMillis < 0 -> {
                                            this.date.formatDateTime(timeZone = timeZone)
                                        }
                                        weeks > 0 -> "${weeks}w ago"
                                        days > 0 -> "${days}d ago"
                                        hours > 0 -> "${hours}h ago"
                                        minutes > 0 -> "${minutes}m ago"
                                        else -> "${seconds}s ago"
                                    }
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 //Repeat List

                                 fun main() {
                                     val nameList = List (13) { "Lakhani Kamlesh" }
                                     println(nameList)
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 //Find the winner of a game using score and time

                                 data class Player(
                                     val name: String,
                                     val score: Int,
                                     val time: Int // Time in seconds
                                 )

                                 fun findWinner(players: List<Player>): Player? {
                                     return players.maxWithOrNull(compareBy({ it.score }, { -it.time }))
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Domain-Specific Languages (DSLs) with Infix Functions

                                class HtmlBuilder {
                                    private val content = StringBuilder()

                                    infix fun add(text: String) {
                                        content.append(text).append("\n")
                                    }

                                    override fun toString(): String = content.toString()
                                }

                                fun html(init: HtmlBuilder.() -> Unit): HtmlBuilder {
                                    val builder = HtmlBuilder()
                                    builder.init()
                                    return builder
                                }

                                fun main() {
                                    val myHtml = html {
                                        add "<h1>Hello, Kotlin DSL!</h1>"
                                        add "<p>This is a paragraph.</p>"
                                    }
                                    println(myHtml)
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                import kotlin.math.pow
                                import kotlin.math.round

                                fun Float.format(decimals: Int = 2): String {
                                    val multiplier = 10.0.pow(decimals).toFloat()
                                    return (round(this * multiplier) / multiplier).toString()
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //roundToDecimals
                                private fun Double.roundToDecimals(decimals: Int): Double {
                                    var dotAt = 1
                                    repeat(decimals) { dotAt *= 10 }
                                    val roundedValue = (this * dotAt).roundToInt()
                                    return (roundedValue / dotAt) + (roundedValue % dotAt).toDouble() / dotAt
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = $$"""
                                //preciseFormat
                                fun Double.preciseFormat(): String {
                                    val str = toFullString().replace(",", ".")

                                    if (str.endsWith(".0")) return str.substringBefore(".")

                                    val parts = str.split(".")
                                    val integer = parts[0]
                                    val fraction = parts.getOrNull(1) ?: return integer

                                    if (fraction.all { it == '0' }) return integer

                                    var significantDigits = 0
                                    var endIndex = 0
                                    while (endIndex < fraction.length && significantDigits < 2) {
                                        if (fraction[endIndex] != '0') significantDigits++
                                        endIndex++
                                    }

                                    val trimmed = fraction.take(endIndex).trimEnd('0')

                                    return if (trimmed.isEmpty()) integer else "$integer.$trimmed"
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //contract kotlin
                                
                                sealed class NResult<T> {
                                    data class Success<T>(val body: T) : NResult<T>()
                                    class Error(val ex: Throwable) : NResult<Nothing>()
                                }

                                @OptIn(ExperimentalContracts::class)
                                fun <T> NResult<T>.isSuccess(): Boolean {
                                    contract {
                                        returns(true) implies (this@isSuccess is NResult.Success)
                                        returns(false) implies (this@isSuccess is NResult.Error)
                                    }
                                    return this is NResult.Success
                                }
                                
                                //1
                                fun checkNotNull(x: String?) {
                                    if (x == null) error("Null value")
                                }
                                
                                val name: String? = "Shivi"
                                checkNotNull(name)
                                println(name.length)
                                
                                //2
                                fun checkNotNull(x: String?) {
                                    contract {
                                        returns() implies (x != null)
                                    }
                                    if (x == null) error("Null value")
                                }
                                
                                val name: String? = "Shivi"
                                checkNotNull(name)
                                println(name.length)
                                
                                //3
                                fun isValid(s: String?): Boolean {
                                    return !s.isNullOrBlank()
                                }
                                
                                if (isValid(name)) {
                                    println(name.length)
                                }
                                
                                fun isValid(s: String?): Boolean {
                                    contract {
                                        returns(true) implies (s != null)
                                    }
                                    return !s.isNullOrBlank()
                                }
                                
                                //4 Variable initialization inside lambdas
                                val result: String
                                run {
                                    result = "Hello"
                                }
                                println(result)
                                
                                //Solution
                                inline fun runOnce(block: () -> Unit) {
                                    contract {
                                        callsInPlace(block, InvocationKind.EXACTLY_ONCE)
                                    }
                                    block()
                                }
                                
                                val result: String
                                runOnce {
                                    result = "Hello"
                                }
                                println(result)
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 /**
                                  * Returns the string if not blank, or null otherwise.
                                  */
                                  
                                 fun String?.orNullIfBlank(): String? = if (this.isNullOrBlank()) null else this
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Get first character capital
                                
                                fun String.initials(): String {
                                    return this
                                        .trim()
                                        .split("\\s+".toRegex())  // Split by whitespace
                                        .filter { it.isNotEmpty() && it.first().isLetter() } // Skip 
                                        .take(2)                            
                                        .map { it.first().uppercaseChar() } 
                                        .joinToString("")
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                            //Max long length substring
                                
                            fun maxUniqueSubstringLength(s: String): Int {
                            var maxLength = 0
                            var start = 0
                            val seen = mutableMapOf<Char, Int>()

                            for ((end, char) in s.withIndex()) {
                                if (char in seen && seen[char]!! >= start) {
                                    start = seen[char]!! + 1
                                }
                                seen[char] = end
                                maxLength = maxOf(maxLength, end - start + 1)
                            }

                            return maxLength
                        }
                        
                        //abcabcbb - output 3
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //File type get
                                
                                sealed class FileType {
                                    object MDFile : FileType()
                                    object Image : FileType()
                                    object Other : FileType()

                                    fun String.getFileType(): FileType {
                                        return when {
                                            this.endsWith(".md") -> MDFile
                                            this.endsWith(".png") || this.endsWith(".jpg") || this.endsWith(".jpeg") || this.endsWith(
                                                ".gif"
                                            ) || this.endsWith(".webp") || this.endsWith(".svg") -> Image

                                            else -> Other
                                        }
                                    }
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Given a string with '(', ')', and '*', check if it’s valid.
                                
                                fun checkValidString(s: String): Boolean {
                                    var low = 0   // Minimum possible '(' count
                                    var high = 0  // Maximum possible '(' count
                                    
                                    for (ch in s) {
                                        when (ch) {
                                            '(' -> {
                                                low++
                                                high++
                                            }
                                            ')' -> {
                                                if (low > 0) low--   // one '(' can be matched
                                                high--               // one '(' must close
                                            }
                                            '*' -> {
                                                // '*' could be '(', ')' or empty
                                                if (low > 0) low--   // if it acts as ')'
                                                high++               // if it acts as '('
                                            }
                                        }
                                        
                                        if (high < 0) return false   // too many ')'
                                    }
                                    
                                    return low == 0
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                //Max Sum of Non-Adjacent Elements
                                
                                fun maxNonAdjacentSum(nums: IntArray): Int {
                                    if (nums.isEmpty()) return 0
                                    if (nums.size == 1) return nums[0]
                                    
                                    var include = nums[0]  // include current element
                                    var exclude = 0        // exclude current element
                                    
                                    for (i in 1 until nums.size) {
                                        val newInclude = exclude + nums[i]  // pick current, so skip previous
                                        val newExclude = maxOf(include, exclude)  // skip current, take best so far
                                        
                                        include = newInclude
                                        exclude = newExclude
                                    }
                                    
                                    return maxOf(include, exclude)
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                class Solution {
                                    fun canJump(nums: IntArray): Boolean {
                                        var farthest = 0
                                        for (i in nums.indices) {
                                            if (i > farthest) return false
                                            farthest = maxOf(farthest, i + nums[i])
                                        }
                                        return true
                                    }
                                }

                                fun main() {
                                    val solution = Solution()
                                    
                                    val test1 = intArrayOf(2, 3, 1, 0, 4)
                                    val test2 = intArrayOf(3, 2, 1, 0, 4)

                                    println(solution.canJump(test1)) // ✅ true
                                    println(solution.canJump(test2)) // ❌ false
                                }
                            """.trimIndent()
                        )

                        //https://github.com/iosifvilcea/baseapp
                        KotlinCode(
                            code = """
                                object Patterns {
                                    /**
                                     * Pattern for validating email addresses
                                     * Matches standard email format: username@domain.tld
                                     * - Username can contain letters, numbers, and common special characters
                                     * - Domain must contain letters, numbers, dots, and hyphens
                                     * - TLD must be at least 2 characters
                                     */
                                    val EMAIL_ADDRESS: Regex = Regex(
                                        "[a-zA-Z0-9+._%\\-]{1,256}" +
                                                "@" +
                                                "[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}" +
                                                "(" +
                                                "\\." +
                                                "[a-zA-Z0-9][a-zA-Z0-9\\-]{0,25}" +
                                                ")+"
                                    )

                                    // Regular expression for validating a password
                                    // Minimum 8 characters, at least 1 letter, 1 number, and 1 special character
                                    val PASSWORD: Regex = Regex(
                                        "^" +
                                                "(?=.*[0-9])" +            // At least 1 digit
                                                "(?=.*[a-zA-Z])" +         // At least 1 letter
                                                "(?=.*[!@#\$%^&*()_+\\-=\\[\\]{}|;:,.<>?])" + // At least 1 special character
                                                ".{8,}" +                  // Minimum 8 characters
                                                "$"
                                    )

                                    fun isValidEmail(email: String): Boolean {
                                        return EMAIL_ADDRESS.matches(email)
                                    }

                                    fun isValidPassword(password: String): Boolean {
                                        return PASSWORD.matches(password)
                                    }
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                fun main()
                                {
                                    val result = null + null
                                	if (result = null) {
                                    	println("Its null")
                                	} else {
                                    	println("Its not null")
                                	}
                                }
                            """.trimIndent()
                        )

                        //https://medium.com/@abdullahkhan1571998/your-reference-types-are-breaking-encapsulation-heres-why-40c978e22bdf
                        KotlinCode(
                            code = $$"""
                                 class ChildData(
                                     private val data: MutableList<String>,
                                     private var age: Int?
                                 ) {
                                     override fun toString(): String {
                                         return "ChildData(data=$data, age=$age)"
                                     }
                                     fun getDataList() = data
                                     fun getAge() = age
                                 }
                                 class ParentData(
                                     var childData: ChildData = ChildData(mutableListOf("Some data"), age = Integer.valueOf(10))
                                 )
                                 fun main() {
                                     val parentData = ParentData()
                                     val childData = parentData.childData
                                     println(parentData.childData)
                                     childData.getDataList().add("New Data")
                                     var age = childData.getAge()
                                     age = null
                                     println(parentData.childData)
                                 }
                                 
                                 ChildData(data=[Some data], age=10)
                                 ChildData(data=[Some data, New Data], age=10)
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                fun Double.usPrice(): String {
                                    return "$%.2f".format(Locale.US, this)
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = $$"""
                                 inline fun measureTime(block: () -> Unit) {
                                    val start = System.currentTimeMillis()
                                    block()
                                    println("Took ${System.currentTimeMillis() - start} ms")
                                 }
                            """.trimIndent()
                        )

                        //https://github.com/tosoba/WarsawTransportMap
                        KotlinCode(
                            code = """
                                //Distance Between Km
                                
                                import kotlin.math.PI
                                import kotlin.math.atan2
                                import kotlin.math.cos
                                import kotlin.math.sin
                                import kotlin.math.sqrt

                                fun calculateDistanceBetweenKm(lat1: Double, lon1: Double, lat2: Double, lon2: Double): Double {
                                  val r = 6371.0
                                  val dLat = (lat2 - lat1) * (PI / 180.0)
                                  val dLon = (lon2 - lon1) * (PI / 180.0)
                                  val a =
                                    sin(dLat / 2) * sin(dLat / 2) +
                                      cos(lat1 * (PI / 180.0)) * cos(lat2 * (PI / 180.0)) * sin(dLon / 2) * sin(dLon / 2)
                                  val c = 2 * atan2(sqrt(a), sqrt(1 - a))
                                  return r * c
                                }
                            """.trimIndent()
                        )

                        //https://github.com/peterdsp/Syrmos.git
                        KotlinCode(
                            code = """
                                 //Distance In Meters
                                 private const val EARTH_RADIUS_METERS = 6_371_000.0

                                 fun distanceInMeters(
                                     lat1: Double, lon1: Double,
                                     lat2: Double, lon2: Double,
                                 ): Int {
                                     val dLat = Math.toRadians(lat2 - lat1)
                                     val dLon = Math.toRadians(lon2 - lon1)
                                     val a = sin(dLat / 2) * sin(dLat / 2) +
                                         cos(Math.toRadians(lat1)) * cos(Math.toRadians(lat2)) *
                                         sin(dLon / 2) * sin(dLon / 2)
                                     val c = 2 * atan2(sqrt(a), sqrt(1 - a))
                                     return (EARTH_RADIUS_METERS * c).toInt()
                                 }

                                 private object Math {
                                     fun toRadians(degrees: Double): Double = degrees * kotlin.math.PI / 180.0
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = $$"""
                                 //loop syntax 
                                 val numbers = mutableListOf(1, 2, 3, 4)
                                 
                                 list.asSequence().forEachIndexed { index, value ->
                                     println("$index -> $value")
                                 }
                                 
                                 numbers.forEachIndexed { index, value ->
                                     numbers[index] = value * 2
                                 }
                                 
                                 for ((index, value) in list.withIndex()) {
                                     println("$index -> $value")
                                 }
                            """.trimIndent()
                        )

                        //https://medium.com/@sandeepjak2007/kotlin-collection-problem-wipro-interview-question-explained-b3f3792f069e?postPublishedType=initial
                        KotlinCode(
                            code = """
                                A list of students
                                Each student has a list of courses
                                Each course has a flag isPaid
                                
                                👉 Task:
                                   Find the top 3 most frequently purchased (paid) courses
                                
                                 val students = listOf(
                                     Student("A", listOf(
                                         Course("Math", true),
                                         Course("Science", false)
                                     )),
                                     Student("B", listOf(
                                         Course("Math", true),
                                         Course("English", true)
                                     )),
                                     Student("C", listOf(
                                         Course("Math", true),
                                         Course("English", true),
                                         Course("Physics", true)
                                     ))
                                 )

                                 data class Student(
                                     val name: String,
                                     val courses: List<Course>
                                 )

                                 data class Course(
                                     val name: String,
                                     val isPaid: Boolean
                                 )

                                 fun top3PaidCourses(students: List<Student>): List<Pair<String, Int>> {
                                     return students
                                         .flatMap { it.courses }                // flatten all courses
                                         .filter { it.isPaid }                  // keep only paid courses
                                         .groupingBy { it.name }                // group by course name
                                         .eachCount()                           // count occurrences
                                         .entries
                                         .sortedByDescending { it.value }       // sort by frequency
                                         .take(3)                               // take top 3
                                         .map { it.key to it.value }            // convert to Pair
                                 }

                                 fun main() {
                                     val result = top3PaidCourses(students)
                                     println(result)
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                private fun generateLocalRandom(min: Int, max: Int): Int {
                                    val rangeSize = max.toLong() - min.toLong() + 1L
                                    val offset = Random.nextLong(until = rangeSize)
                                    return (min.toLong() + offset).toInt()
                                }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                 class SecureDataManager {
                                     private val keyStore = KeyStore.getInstance("AndroidKeyStore")
                                     
                                     init {
                                         keyStore.load(null)
                                     }
                                     
                                     fun encryptData(data: ByteArray): ByteArray {
                                         val cipher = Cipher.getInstance("AES/GCM/NoPadding")
                                         cipher.init(Cipher.ENCRYPT_MODE, getOrCreateSecretKey())
                                         return cipher.doFinal(data)
                                     }
                                     
                                     private fun getOrCreateSecretKey(): SecretKey {
                                         return try {
                                             keyStore.getKey("app_secret_key", null) as SecretKey
                                         } catch (e: Exception) {
                                             createSecretKey()
                                         }
                                     }
                                     
                                     private fun createSecretKey(): SecretKey {
                                         val keyGenerator = KeyGenerator.getInstance(KeyProperties.KEY_ALGORITHM_AES, "AndroidKeyStore")
                                         val keyGenParameterSpec = KeyGenParameterSpec.Builder(
                                             "app_secret_key",
                                             KeyProperties.PURPOSE_ENCRYPT or KeyProperties.PURPOSE_DECRYPT
                                         )
                                             .setBlockModes(KeyProperties.BLOCK_MODE_GCM)
                                             .setEncryptionPaddings(KeyProperties.ENCRYPTION_PADDING_NONE)
                                             .build()
                                         
                                         keyGenerator.init(keyGenParameterSpec)
                                         return keyGenerator.generateKey()
                                     }
                                 }
                            """.trimIndent()
                        )
                    }
                }
            }
        }
    }
}


//https://algomaster.io (https://algomaster.io/learn/lld/singleton Good Design Pattern)

/*
fun Item.getFormatedDiffTime(): String =
    when (val diff = Clock.System.now().minus(getInstant()).toLong(DurationUnit.SECONDS)) {
        in 0..60 -> "$diff seconds ago"
        in 60..3600 -> "${diff / 60} minutes ago"
        in 3600..86400 -> "${diff / 3600} hours ago"
        else -> "${diff / 86400} days ago"
    }

        /**
         * Regex pattern for valid device IDs:
         * - 3-50 characters
         * - Lowercase letters, numbers, and hyphens only
         * - Must start and end with letter or number
         */
        val ID_PATTERN = Regex("^[a-z0-9][a-z0-9-]{1,48}[a-z0-9]$")

*/

//Companion Objects
//forEachIndexed

//DS
//longestSubarrayDivisibleByK

// require(count >= 1)
//This allows the function to be called like the object itself, not like a normal method. primary responsibility, verb phrase, class does one thing suspend operator fun invoke()

//drop, dropLast, dropWhile

//https://www.youtube.com/watch?v=aF8RYQrJI8Q
//https://medium.com/@alekseijegorov/kotlin-lambda-and-invoke-4242d225c941
//https://velog.io/@mraz3068/How-To-Solve-Race-Condition-In-Kotlin
//https://github.com/Dev-Aditya-More/PokeVerse.git (GroupBy Good)

//AI TOOLS
//https://workik.com/kotlin-code-generator

//https://github.com/thisisyusub/kotlin-ds-and-algorithm
//https://medium.com/@mahesh31.ambekar/why-kotlin-delegation-beats-base-classes-in-android-78b4a15d055b

//https://www.notion.so/Kotlin-Interview-Questions-and-Answers-110fc872121680e99251c7387a67b54c

//https://medium.com/@shaktiprakash0207/android-interview-question-kotlin-basic-chapter-2-736e475dbffa

//https://bugfender.com/blog/kotlin-collections
//https://blog.devgenius.io/kotlin-lambda-with-receiver-c8de99364201

//https://medium.com/@learn_to_code_smartly/kotlin-collections-unpacking-the-power-of-flatmap-and-flatmapto-bafb7bcb2d19
//https://syedovaiss.medium.com/understanding-variance-in-kotlin-covariance-contra-variance-invariance-explained-acc7e9b53c4e
//https://medium.com/@esmaeeilmoradi700/37-kotlin-interview-questions-and-answers-every-android-developer-must-know-633fec1568d6
//https://www.linkedin.com/in/tarun-suhalka
//https://medium.com/@learn_to_code_smartly/kotlin-collections-mastering-the-take-family-in-kotlin-63de14f57c72
//https://medium.com/@kmkim7575/how-kotlinx-serialization-handles-polymorphism-internally-e6938217382a
//https://medium.com/@learn_to_code_smartly/kotlin-collections-mastering-the-min-family-in-kotlin-d5bd8552d023F

//DSA
//https://github.com/Quantum3600/dsa-kotlin-comprehensive

//Pending
//https://medium.com/@avula.koti.realpage/capgemini-ios-developer-interview-experience-real-questions-honest-answers-d8381ddd3355
//https://doveletter.dev/quiz/kotlin
//https://www.wecreateproblems.com/interview-questions/kotlin-interview-questions
//https://medium.com/@sivavishnu0705/7004bb808c9f
//https://medium.com/@ranjithravibe
//https://medium.com/@guruprasadhegde4/lateinit-and-lazy-property-in-kotlin-8776c67878a0
//https://medium.com/@radoslaw.tywanek/kotlin-syntax-sugar-15f67c693d29
//https://github.com/rroohit/LeetCode-2026
//https://medium.com/@guruprasadhegde4/kotlin-lambda-expressions-bb9d4e15b6fc
//https://medium.com/@morozione/android-interview-trap-quistions-0c94468a8de8
//ExecutorService